var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.22,251c-.34.43-1.23-.21-.89-.76,1.37-2.22,1.18-5.7,2.54-7.93a23.11,23.11,0,0,0,3.26-6.9c.91-4.22-.61-8.52.44-12.78,1.84-7.5,7.44-12.24,13.94-15.76A24,24,0,0,0,88,198c2.09-3.42,3.66-7.13,5.7-10.57a23.46,23.46,0,0,1,7-7.95c3.13-2.05,6.78-3,10.13-4.64,4.41-2.1,6.86-5.72,9.93-9.34,2.22-2.6,8.38-6.82,10.18-5.38C132.22,161.1,63.47,245.7,59.22,251Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.62,442.37c4-2.56,105-65.79,133.44-83.84,2-1.26,1.66,3.77.71,4.71-3,3-6.61,5.33-9.93,8a41.18,41.18,0,0,0-8.56,9c-2,2.95-4,6.09-6.69,8.49-5.27,4.63-12.42,4.73-18.79,6.82a14.71,14.71,0,0,0-9.11,7.7c-1.58,3.14-2.72,6.43-4.52,9.46a48.73,48.73,0,0,1-31.9,22.39,44.8,44.8,0,0,1-9.53.89c-3.79-.05-7.54-.83-11.33-.86-8.41-.07-15,5.87-22.87,7.79C264.1,443,263.28,442.59,263.62,442.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.23,66.91c-5.38,3.3-95.53,59.5-101.33,62.82-.42.24-1-.23-.72-.68,2.49-4,6.78-6.12,9.73-9.67,1.74-2.08,2.21-4.35,2.72-6.92a12.26,12.26,0,0,1,2.82-6,11.58,11.58,0,0,1,5-3.31c2.11-.69,4.35-.62,6.51-1,5.35-1,8.62-5.18,9.75-10.31.93-4.22,1.91-8.27,4.51-11.84a13.37,13.37,0,0,1,9-5.69c4.25-.54,8.38,1.09,12.62,1,5-.11,9.13-3.33,13.61-5.19s9.74-.34,14.53-.56a9.08,9.08,0,0,0,4.65-1.19,26.55,26.55,0,0,0,2.17-1.8c1.14-.91,2.33-1.59,3.79-1.07C175,65.6,175.58,66.69,175.23,66.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.51,315.06c0-6.31-1.08-112.54-.88-119.21,0-.48.71-.74.95-.27,2.1,4.2,1.7,9,3.18,13.35.88,2.57,2.57,4.14,4.5,5.92a12.28,12.28,0,0,1,3.63,5.52,11.71,11.71,0,0,1,.21,6c-.51,2.15-1.73,4-2.51,6.09-1.9,5.11-.06,10.06,3.73,13.69,3.12,3,6.07,5.94,7.76,10a13.31,13.31,0,0,1,.18,10.64c-1.75,3.9-5.29,6.59-7.41,10.26-2.53,4.34-1.91,9.53-2.66,14.32s-4.77,8.49-7.08,12.7a9,9,0,0,0-1.4,4.59,26.39,26.39,0,0,0,.4,2.79c.18,1.44.15,2.82-1.06,3.79C395.76,315.52,394.51,315.48,394.51,315.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.94,380c4.45,1.2,79.47,20.87,84.14,22.29.34.1.38.65,0,.72-3.36.67-6.65-.53-10-.32a10.37,10.37,0,0,0-5,2,8.91,8.91,0,0,1-4.58,1.5,8.63,8.63,0,0,1-4.28-1,38.29,38.29,0,0,1-3.81-2.94c-3.23-2.33-7.07-2-10.36,0-2.71,1.63-5.35,3.14-8.55,3.54a9.71,9.71,0,0,1-7.53-1.91c-2.41-2-3.62-5-5.79-7.2-2.58-2.61-6.35-3.17-9.59-4.62s-5.06-5-7.58-7.43a6.58,6.58,0,0,0-3-1.87,19.93,19.93,0,0,0-2-.25,2.8,2.8,0,0,1-2.47-1.47C136.38,380.8,136.65,379.93,136.94,380Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.64,192.66,355.82,91.1c-.34-.41,0-.92.5-.67,4.71,2.23,7.63,6.67,11.92,9.46,2.53,1.64,5.08,1.86,8,2.08a13.7,13.7,0,0,1,6.94,2.33,13,13,0,0,1,4.31,5.1c1,2.23,1.25,4.71,2,7,1.83,5.77,6.84,8.82,12.63,9.39,4.77.48,9.36,1,13.63,3.43a14.75,14.75,0,0,1,7.45,9.15c1.15,4.61-.1,9.38.56,14,.78,5.52,4.87,9.62,7.51,14.31s3.67,9.56,4.54,14.82a10,10,0,0,0,1.92,5c.67.8,1.53,1.43,2.27,2.16,1.15,1.13,2.06,2.35,1.68,4C441.56,193.12,441.62,195.05,439.64,192.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.83,
    y: 343.52,
    width: 22.65,
    height: 118.74,
    transform: "translate(771.54 679.47) rotate(161.41)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.25,
    y: 449.3,
    width: 4.4,
    height: 4.53,
    transform: "translate(830.49 767.18) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.91,
    y: 451.1,
    width: 4.4,
    height: 4.53,
    transform: "translate(820.66 772.38) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.79,
    y: 442,
    width: 4.4,
    height: 4.53,
    transform: "translate(823.38 753.75) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.45,
    y: 443.8,
    width: 4.4,
    height: 4.53,
    transform: "translate(813.56 758.95) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.34,
    y: 434.71,
    width: 4.4,
    height: 4.53,
    transform: "translate(816.27 740.32) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 436.5,
    width: 4.4,
    height: 4.53,
    transform: "translate(806.45 745.52) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.88,
    y: 427.41,
    width: 4.4,
    height: 4.53,
    transform: "translate(809.17 726.89) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.54,
    y: 429.21,
    width: 4.4,
    height: 4.53,
    transform: "translate(799.34 732.09) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.43,
    y: 420.12,
    width: 4.4,
    height: 4.53,
    transform: "translate(802.06 713.47) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.09,
    y: 421.91,
    width: 4.4,
    height: 4.53,
    transform: "translate(792.23 718.67) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.97,
    y: 412.82,
    width: 4.4,
    height: 4.53,
    transform: "translate(794.95 700.04) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.64,
    y: 414.62,
    width: 4.4,
    height: 4.53,
    transform: "translate(785.13 705.24) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.52,
    y: 405.52,
    width: 4.4,
    height: 4.53,
    transform: "translate(787.84 686.61) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.18,
    y: 407.32,
    width: 4.4,
    height: 4.53,
    transform: "translate(778.02 691.81) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.07,
    y: 398.23,
    width: 4.4,
    height: 4.53,
    transform: "translate(780.74 673.18) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.73,
    y: 400.02,
    width: 4.4,
    height: 4.53,
    transform: "translate(770.91 678.38) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.61,
    y: 390.93,
    width: 4.4,
    height: 4.53,
    transform: "translate(773.63 659.75) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.27,
    y: 392.73,
    width: 4.4,
    height: 4.53,
    transform: "translate(763.81 664.94) rotate(161.4)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.16,
    y: 383.64,
    width: 4.4,
    height: 4.53,
    transform: "translate(766.52 646.32) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.82,
    y: 385.43,
    width: 4.4,
    height: 4.53,
    transform: "translate(756.7 651.52) rotate(161.4)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.7,
    y: 376.34,
    width: 4.4,
    height: 4.53,
    transform: "translate(759.41 632.9) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.36,
    y: 378.14,
    width: 4.4,
    height: 4.53,
    transform: "translate(749.6 638.09) rotate(161.4)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.25,
    y: 369.05,
    width: 4.4,
    height: 4.53,
    transform: "translate(752.31 619.46) rotate(161.4)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.91,
    y: 370.84,
    width: 4.4,
    height: 4.53,
    transform: "translate(742.48 624.67) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.79,
    y: 361.75,
    width: 4.4,
    height: 4.53,
    transform: "translate(745.21 606.03) rotate(161.4)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.45,
    y: 363.55,
    width: 4.4,
    height: 4.53,
    transform: "translate(735.37 611.24) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.34,
    y: 354.45,
    width: 4.4,
    height: 4.53,
    transform: "translate(738.09 592.61) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.71,
    y: 358.03,
    width: 4.4,
    height: 4.53,
    transform: "translate(-98.71 117.63) rotate(-18.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.16,
    y: 365.33,
    width: 4.4,
    height: 4.53,
    transform: "translate(-100.91 118.79) rotate(-18.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.62,
    y: 372.62,
    width: 4.4,
    height: 4.53,
    transform: "translate(-103.1 119.95) rotate(-18.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.07,
    y: 379.92,
    width: 4.4,
    height: 4.53,
    transform: "translate(-105.3 121.12) rotate(-18.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.52,
    y: 387.21,
    width: 4.4,
    height: 4.53,
    transform: "translate(-107.5 122.28) rotate(-18.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.98,
    y: 394.51,
    width: 4.4,
    height: 4.53,
    transform: "translate(-109.7 123.45) rotate(-18.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.43,
    y: 401.81,
    width: 4.4,
    height: 4.53,
    transform: "translate(-111.9 124.61) rotate(-18.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.89,
    y: 409.1,
    width: 4.4,
    height: 4.53,
    transform: "translate(-114.1 125.77) rotate(-18.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.34,
    y: 416.4,
    width: 4.4,
    height: 4.53,
    transform: "translate(-116.29 126.93) rotate(-18.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.8,
    y: 423.69,
    width: 4.4,
    height: 4.53,
    transform: "translate(-118.5 128.1) rotate(-18.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.25,
    y: 430.99,
    width: 4.4,
    height: 4.53,
    transform: "translate(-120.69 129.26) rotate(-18.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.71,
    y: 438.28,
    width: 4.4,
    height: 4.53,
    transform: "translate(-122.89 130.43) rotate(-18.59)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.16,
    y: 445.58,
    width: 4.4,
    height: 4.53,
    transform: "translate(-125.09 131.6) rotate(-18.6)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.62,
    y: 452.88,
    width: 4.4,
    height: 4.53,
    transform: "translate(-127.3 132.76) rotate(-18.6)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 356.25,
    width: 4.4,
    height: 4.53,
    transform: "translate(728.27 597.81) rotate(161.41)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.03,
    y: 349.97,
    width: 17.86,
    height: 118.74,
    transform: "translate(736.21 698.17) rotate(161.41)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.21,
    y: 364.38,
    width: 3.64,
    height: 4.53,
    transform: "translate(-101.72 111.94) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.62,
    y: 362.9,
    width: 3.64,
    height: 4.53,
    transform: "translate(-101.02 113.27) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.67,
    y: 371.68,
    width: 3.64,
    height: 4.53,
    transform: "translate(-103.92 113.1) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.08,
    y: 370.19,
    width: 3.64,
    height: 4.53,
    transform: "translate(-103.22 114.43) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.12,
    y: 378.97,
    width: 3.64,
    height: 4.53,
    transform: "translate(-106.11 114.26) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.53,
    y: 377.49,
    width: 3.64,
    height: 4.53,
    transform: "translate(-105.42 115.6) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.58,
    y: 386.27,
    width: 3.64,
    height: 4.53,
    transform: "translate(-108.32 115.44) rotate(-18.6)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.98,
    y: 384.79,
    width: 3.64,
    height: 4.53,
    transform: "matrix(0.95, -0.32, 0.32, 0.95, -107.6, 116.75)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.03,
    y: 393.56,
    width: 3.64,
    height: 4.53,
    transform: "translate(-110.52 116.6) rotate(-18.6)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.44,
    y: 392.08,
    width: 3.64,
    height: 4.53,
    transform: "translate(-109.81 117.92) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.48,
    y: 400.86,
    width: 3.64,
    height: 4.53,
    transform: "translate(-112.72 117.77) rotate(-18.6)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.89,
    y: 399.38,
    width: 3.64,
    height: 4.53,
    transform: "translate(-112.01 119.09) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.94,
    y: 408.16,
    width: 3.64,
    height: 4.53,
    transform: "translate(-114.91 118.92) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.35,
    y: 406.67,
    width: 3.64,
    height: 4.53,
    transform: "translate(-114.21 120.25) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.39,
    y: 415.45,
    width: 3.64,
    height: 4.53,
    transform: "translate(-117.11 120.08) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.8,
    y: 413.97,
    width: 3.64,
    height: 4.53,
    transform: "translate(-116.4 121.41) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.85,
    y: 422.75,
    width: 3.64,
    height: 4.53,
    transform: "translate(-119.3 121.24) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.26,
    y: 421.27,
    width: 3.64,
    height: 4.53,
    transform: "translate(-118.6 122.58) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.3,
    y: 430.04,
    width: 3.64,
    height: 4.53,
    transform: "translate(-121.5 122.41) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.71,
    y: 428.56,
    width: 3.64,
    height: 4.53,
    transform: "translate(-120.8 123.74) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.76,
    y: 437.34,
    width: 3.64,
    height: 4.53,
    transform: "translate(-123.7 123.57) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.17,
    y: 435.86,
    width: 3.64,
    height: 4.53,
    transform: "translate(-123 124.9) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.21,
    y: 444.64,
    width: 3.64,
    height: 4.53,
    transform: "translate(-125.9 124.74) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.62,
    y: 443.15,
    width: 3.64,
    height: 4.53,
    transform: "translate(-125.2 126.07) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.67,
    y: 451.93,
    width: 3.64,
    height: 4.53,
    transform: "translate(-128.1 125.9) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.08,
    y: 450.45,
    width: 3.64,
    height: 4.53,
    transform: "translate(-127.4 127.23) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.12,
    y: 459.23,
    width: 3.64,
    height: 4.53,
    transform: "translate(-130.3 127.06) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.9,
    y: 456.27,
    width: 3.64,
    height: 4.53,
    transform: "translate(792.33 787.37) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.45,
    y: 448.98,
    width: 3.64,
    height: 4.53,
    transform: "translate(785.23 773.94) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.99,
    y: 441.68,
    width: 3.64,
    height: 4.53,
    transform: "translate(778.12 760.52) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.54,
    y: 434.39,
    width: 3.64,
    height: 4.53,
    transform: "translate(771.02 747.08) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.08,
    y: 427.09,
    width: 3.64,
    height: 4.53,
    transform: "translate(763.91 733.66) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.63,
    y: 419.79,
    width: 3.64,
    height: 4.53,
    transform: "translate(756.8 720.23) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.17,
    y: 412.5,
    width: 3.64,
    height: 4.53,
    transform: "translate(749.69 706.8) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.72,
    y: 405.2,
    width: 3.64,
    height: 4.53,
    transform: "translate(742.59 693.37) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.26,
    y: 397.91,
    width: 3.64,
    height: 4.53,
    transform: "translate(735.48 679.95) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.81,
    y: 390.61,
    width: 3.64,
    height: 4.53,
    transform: "translate(728.37 666.52) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.35,
    y: 383.32,
    width: 3.64,
    height: 4.53,
    transform: "translate(721.26 653.09) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.9,
    y: 376.02,
    width: 3.64,
    height: 4.53,
    transform: "translate(714.15 639.66) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.45,
    y: 368.72,
    width: 3.64,
    height: 4.53,
    transform: "translate(707.05 626.23) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.99,
    y: 361.43,
    width: 3.64,
    height: 4.53,
    transform: "translate(699.94 612.81) rotate(161.41)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.53,
    y: 457.74,
    width: 3.64,
    height: 4.53,
    transform: "translate(-129.6 128.4) rotate(-18.59)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.38,
    y: 53.99,
    width: 27.27,
    height: 113.69,
    transform: "translate(-11.26 26.91) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.04,
    y: 52.15,
    width: 27.93,
    height: 2.26,
    transform: "translate(-4.68 25.72) rotate(-6.62)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.1,
    y: 58.44,
    width: 2.76,
    height: 110.35,
    transform: "translate(-11.65 25.83) rotate(-6.62)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.96,
    y: 57.88,
    width: 2.76,
    height: 110.35,
    transform: "translate(-11.55 26.38) rotate(-6.62)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.83,
    y: 57.31,
    width: 2.76,
    height: 110.35,
    transform: "translate(-11.45 26.94) rotate(-6.62)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.69,
    y: 56.75,
    width: 2.76,
    height: 110.35,
    transform: "translate(-11.36 27.5) rotate(-6.62)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.55,
    y: 56.18,
    width: 2.76,
    height: 110.35,
    transform: "translate(-11.26 28.05) rotate(-6.62)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.33,
    y: 61.64,
    width: 2.76,
    height: 4.47,
    transform: "translate(-5.95 24.83) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.19,
    y: 61.07,
    width: 2.76,
    height: 4.47,
    transform: "translate(-5.85 25.38) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.05,
    y: 60.51,
    width: 2.76,
    height: 4.47,
    transform: "translate(-5.76 25.95) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.91,
    y: 59.94,
    width: 2.76,
    height: 4.47,
    transform: "translate(-5.66 26.5) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.78,
    y: 59.38,
    width: 2.76,
    height: 4.47,
    transform: "translate(-5.56 27.05) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.17,
    y: 68.85,
    width: 2.76,
    height: 4.47,
    transform: "translate(-6.78 24.98) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.03,
    y: 68.29,
    width: 2.76,
    height: 4.47,
    transform: "translate(-6.68 25.53) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.89,
    y: 67.72,
    width: 2.76,
    height: 4.47,
    transform: "translate(-6.58 26.09) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.75,
    y: 67.16,
    width: 2.76,
    height: 4.47,
    transform: "translate(-6.48 26.64) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.61,
    y: 66.59,
    width: 2.76,
    height: 4.47,
    transform: "translate(-6.39 27.2) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.01,
    y: 76.06,
    width: 2.76,
    height: 4.47,
    transform: "translate(-7.6 25.12) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.87,
    y: 75.5,
    width: 2.76,
    height: 4.47,
    transform: "translate(-7.51 25.68) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.73,
    y: 74.94,
    width: 2.76,
    height: 4.47,
    transform: "translate(-7.41 26.24) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.59,
    y: 74.37,
    width: 2.76,
    height: 4.47,
    transform: "translate(-7.31 26.79) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.45,
    y: 73.81,
    width: 2.76,
    height: 4.47,
    transform: "translate(-7.21 27.34) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.84,
    y: 83.28,
    width: 2.76,
    height: 4.47,
    transform: "translate(-8.43 25.27) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.7,
    y: 82.71,
    width: 2.76,
    height: 4.47,
    transform: "translate(-8.33 25.82) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.56,
    y: 82.15,
    width: 2.76,
    height: 4.47,
    transform: "translate(-8.24 26.38) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.43,
    y: 81.59,
    width: 2.76,
    height: 4.47,
    transform: "translate(-8.14 26.93) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.29,
    y: 81.02,
    width: 2.76,
    height: 4.47,
    transform: "translate(-8.04 27.49) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.68,
    y: 90.49,
    width: 2.76,
    height: 4.47,
    transform: "translate(-9.25 25.4) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.54,
    y: 89.93,
    width: 2.76,
    height: 4.47,
    transform: "translate(-9.16 25.97) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.4,
    y: 89.36,
    width: 2.76,
    height: 4.47,
    transform: "translate(-9.06 26.52) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.26,
    y: 88.8,
    width: 2.76,
    height: 4.47,
    transform: "translate(-8.96 27.07) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.12,
    y: 88.24,
    width: 2.76,
    height: 4.47,
    transform: "translate(-8.87 27.64) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.52,
    y: 97.71,
    width: 2.76,
    height: 4.47,
    transform: "translate(-10.08 25.55) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.38,
    y: 97.14,
    width: 2.76,
    height: 4.47,
    transform: "translate(-9.98 26.11) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.24,
    y: 96.58,
    width: 2.76,
    height: 4.47,
    transform: "translate(-9.88 26.66) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.1,
    y: 96.02,
    width: 2.76,
    height: 4.47,
    transform: "translate(-9.79 27.23) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.96,
    y: 95.45,
    width: 2.76,
    height: 4.47,
    transform: "translate(-9.69 27.78) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.35,
    y: 104.92,
    width: 2.76,
    height: 4.47,
    transform: "translate(-10.91 25.7) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.22,
    y: 104.36,
    width: 2.76,
    height: 4.47,
    transform: "translate(-10.81 26.26) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.08,
    y: 103.79,
    width: 2.76,
    height: 4.47,
    transform: "translate(-10.71 26.81) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.94,
    y: 103.23,
    width: 2.76,
    height: 4.47,
    transform: "translate(-10.62 27.37) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.8,
    y: 102.67,
    width: 2.76,
    height: 4.47,
    transform: "translate(-10.52 27.93) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.19,
    y: 112.14,
    width: 2.76,
    height: 4.47,
    transform: "translate(-11.73 25.84) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.05,
    y: 111.57,
    width: 2.76,
    height: 4.47,
    transform: "translate(-11.64 26.4) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.91,
    y: 111.01,
    width: 2.76,
    height: 4.47,
    transform: "translate(-11.54 26.95) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.78,
    y: 110.44,
    width: 2.76,
    height: 4.47,
    transform: "translate(-11.44 27.52) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.64,
    y: 109.88,
    width: 2.76,
    height: 4.47,
    transform: "translate(-11.34 28.07) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.03,
    y: 119.35,
    width: 2.76,
    height: 4.47,
    transform: "translate(-12.56 25.98) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.89,
    y: 118.79,
    width: 2.76,
    height: 4.47,
    transform: "translate(-12.46 26.54) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.75,
    y: 118.22,
    width: 2.76,
    height: 4.47,
    transform: "translate(-12.37 27.1) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.61,
    y: 117.66,
    width: 2.76,
    height: 4.47,
    transform: "translate(-12.27 27.65) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.47,
    y: 117.09,
    width: 2.76,
    height: 4.47,
    transform: "translate(-12.17 28.22) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.87,
    y: 126.57,
    width: 2.76,
    height: 4.47,
    transform: "translate(-13.39 26.13) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.73,
    y: 126,
    width: 2.76,
    height: 4.47,
    transform: "translate(-13.29 26.69) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.59,
    y: 125.44,
    width: 2.76,
    height: 4.47,
    transform: "translate(-13.19 27.24) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.45,
    y: 124.87,
    width: 2.76,
    height: 4.47,
    transform: "translate(-13.09 27.8) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.31,
    y: 124.31,
    width: 2.76,
    height: 4.47,
    transform: "translate(-13 28.36) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.7,
    y: 133.78,
    width: 2.76,
    height: 4.47,
    transform: "translate(-14.21 26.28) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.56,
    y: 133.22,
    width: 2.76,
    height: 4.47,
    transform: "translate(-14.12 26.84) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.43,
    y: 132.65,
    width: 2.76,
    height: 4.47,
    transform: "translate(-14.02 27.39) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.29,
    y: 132.09,
    width: 2.76,
    height: 4.47,
    transform: "translate(-13.92 27.94) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.15,
    y: 131.52,
    width: 2.76,
    height: 4.47,
    transform: "translate(-13.82 28.5) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.54,
    y: 140.99,
    width: 2.76,
    height: 4.47,
    transform: "translate(-15.04 26.42) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.4,
    y: 140.43,
    width: 2.76,
    height: 4.47,
    transform: "translate(-14.94 26.98) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.26,
    y: 139.87,
    width: 2.76,
    height: 4.47,
    transform: "translate(-14.84 27.54) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.12,
    y: 139.3,
    width: 2.76,
    height: 4.47,
    transform: "translate(-14.75 28.09) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.99,
    y: 138.74,
    width: 2.76,
    height: 4.47,
    transform: "translate(-14.64 28.64) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.38,
    y: 148.21,
    width: 2.76,
    height: 4.47,
    transform: "translate(-15.86 26.56) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.24,
    y: 147.64,
    width: 2.76,
    height: 4.47,
    transform: "translate(-15.77 27.12) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.1,
    y: 147.08,
    width: 2.76,
    height: 4.47,
    transform: "translate(-15.67 27.68) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.96,
    y: 146.52,
    width: 2.76,
    height: 4.47,
    transform: "translate(-15.57 28.23) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.82,
    y: 145.95,
    width: 2.76,
    height: 4.47,
    transform: "translate(-15.47 28.79) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.71,
    y: 155.39,
    width: 2.76,
    height: 13.07,
    transform: "translate(-17.18 26.8) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.57,
    y: 154.83,
    width: 2.76,
    height: 13.07,
    transform: "translate(-17.08 27.35) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.43,
    y: 154.27,
    width: 2.76,
    height: 13.07,
    transform: "translate(-16.99 27.91) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.29,
    y: 153.7,
    width: 2.76,
    height: 13.07,
    transform: "translate(-16.89 28.47) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.16,
    y: 153.14,
    width: 2.76,
    height: 13.07,
    transform: "translate(-16.79 29.02) rotate(-6.62)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.5,
    y: 51.41,
    width: 17.51,
    height: 113.69,
    transform: "translate(-10.82 29.45) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.82,
    y: 49.49,
    width: 18.26,
    height: 2.26,
    transform: "translate(-4.22 28.34) rotate(-6.62)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.19,
    y: 55.3,
    width: 2.76,
    height: 110.35,
    transform: "translate(-11.1 28.93) rotate(-6.62)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.05,
    y: 54.73,
    width: 2.76,
    height: 110.35,
    transform: "translate(-11.01 29.49) rotate(-6.62)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.91,
    y: 54.17,
    width: 2.76,
    height: 110.35,
    transform: "translate(-10.91 30.04) rotate(-6.62)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.42,
    y: 58.49,
    width: 2.76,
    height: 4.47,
    transform: "translate(-5.41 27.93) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.28,
    y: 57.93,
    width: 2.76,
    height: 4.47,
    transform: "translate(-5.31 28.49) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.14,
    y: 57.36,
    width: 2.76,
    height: 4.47,
    transform: "translate(-5.21 29.05) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.26,
    y: 65.71,
    width: 2.76,
    height: 4.47,
    transform: "translate(-6.23 28.08) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.12,
    y: 65.14,
    width: 2.76,
    height: 4.47,
    transform: "translate(-6.14 28.64) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.98,
    y: 64.58,
    width: 2.76,
    height: 4.47,
    transform: "translate(-6.04 29.18) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.09,
    y: 72.92,
    width: 2.76,
    height: 4.47,
    transform: "translate(-7.06 28.21) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.95,
    y: 72.36,
    width: 2.76,
    height: 4.47,
    transform: "translate(-6.96 28.78) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.82,
    y: 71.79,
    width: 2.76,
    height: 4.47,
    transform: "translate(-6.87 29.34) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.93,
    y: 80.14,
    width: 2.76,
    height: 4.47,
    transform: "translate(-7.89 28.37) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.79,
    y: 79.57,
    width: 2.76,
    height: 4.47,
    transform: "translate(-7.79 28.92) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.65,
    y: 79.01,
    width: 2.76,
    height: 4.47,
    transform: "translate(-7.69 29.47) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.77,
    y: 87.35,
    width: 2.76,
    height: 4.47,
    transform: "translate(-8.71 28.51) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.63,
    y: 86.79,
    width: 2.76,
    height: 4.47,
    transform: "translate(-8.62 29.07) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.49,
    y: 86.22,
    width: 2.76,
    height: 4.47,
    transform: "matrix(0.99, -0.12, 0.12, 0.99, -8.52, 29.63)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.6,
    y: 94.56,
    width: 2.76,
    height: 4.47,
    transform: "translate(-9.54 28.66) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.47,
    y: 94,
    width: 2.76,
    height: 4.47,
    transform: "translate(-9.44 29.21) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.33,
    y: 93.44,
    width: 2.76,
    height: 4.47,
    transform: "translate(-9.34 29.76) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.44,
    y: 101.78,
    width: 2.76,
    height: 4.47,
    transform: "translate(-10.36 28.8) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.3,
    y: 101.21,
    width: 2.76,
    height: 4.47,
    transform: "translate(-10.27 29.36) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.16,
    y: 100.65,
    width: 2.76,
    height: 4.47,
    transform: "translate(-10.17 29.91) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.28,
    y: 108.99,
    width: 2.76,
    height: 4.47,
    transform: "translate(-11.19 28.95) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.14,
    y: 108.43,
    width: 2.76,
    height: 4.47,
    transform: "translate(-11.09 29.49) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 107.86,
    width: 2.76,
    height: 4.47,
    transform: "translate(-11 30.06) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.12,
    y: 116.21,
    width: 2.76,
    height: 4.47,
    transform: "translate(-12.02 29.09) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.98,
    y: 115.64,
    width: 2.76,
    height: 4.47,
    transform: "translate(-11.92 29.65) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.84,
    y: 115.08,
    width: 2.76,
    height: 4.47,
    transform: "translate(-11.82 30.2) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.95,
    y: 123.42,
    width: 2.76,
    height: 4.47,
    transform: "translate(-12.84 29.24) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.81,
    y: 122.86,
    width: 2.76,
    height: 4.47,
    transform: "translate(-12.75 29.79) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.68,
    y: 122.29,
    width: 2.76,
    height: 4.47,
    transform: "translate(-12.65 30.35) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.79,
    y: 130.64,
    width: 2.76,
    height: 4.47,
    transform: "translate(-13.67 29.38) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.65,
    y: 130.07,
    width: 2.76,
    height: 4.47,
    transform: "translate(-13.57 29.94) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.51,
    y: 129.51,
    width: 2.76,
    height: 4.47,
    transform: "translate(-13.47 30.48) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.63,
    y: 137.85,
    width: 2.76,
    height: 4.47,
    transform: "translate(-14.49 29.52) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.49,
    y: 137.29,
    width: 2.76,
    height: 4.47,
    transform: "translate(-14.4 30.08) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.35,
    y: 136.72,
    width: 2.76,
    height: 4.47,
    transform: "translate(-14.3 30.64) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.47,
    y: 145.07,
    width: 2.76,
    height: 4.47,
    transform: "translate(-15.32 29.67) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.33,
    y: 144.5,
    width: 2.76,
    height: 4.47,
    transform: "translate(-15.22 30.23) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.19,
    y: 143.94,
    width: 2.76,
    height: 4.47,
    transform: "translate(-15.12 30.77) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.8,
    y: 152.25,
    width: 2.76,
    height: 13.07,
    transform: "translate(-16.64 29.9) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.66,
    y: 151.69,
    width: 2.76,
    height: 13.07,
    transform: "translate(-16.54 30.46) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.52,
    y: 151.12,
    width: 2.76,
    height: 13.07,
    transform: "translate(-16.44 31.01) rotate(-6.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.36,
    y: 321.49,
    width: 22.41,
    height: 73.3,
    transform: "translate(-82.67 673.07) rotate(-124.81)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.96,
    y: 376.71,
    width: 19.22,
    height: 4.86,
    transform: "translate(-151.75 678.97) rotate(-124.81)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.31,
    y: 334.58,
    width: 17.5,
    height: 54.8,
    transform: "translate(-94.48 674.57) rotate(-124.81)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.64,
    y: 373.61,
    width: 17.5,
    height: 1.29,
    transform: "matrix(-0.57, -0.82, 0.82, -0.57, -132.32, 679.36)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.04,
    y: 370.55,
    width: 17.5,
    height: 1.29,
    transform: "translate(-122.89 678.16) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.44,
    y: 367.49,
    width: 17.5,
    height: 1.29,
    transform: "translate(-113.46 676.97) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.85,
    y: 364.43,
    width: 17.5,
    height: 1.29,
    transform: "translate(-104.03 675.78) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.25,
    y: 361.37,
    width: 17.5,
    height: 1.29,
    transform: "translate(-94.6 674.58) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.66,
    y: 358.3,
    width: 17.5,
    height: 1.3,
    transform: "translate(-85.16 673.39) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.06,
    y: 355.24,
    width: 17.5,
    height: 1.29,
    transform: "translate(-75.73 672.19) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.46,
    y: 352.18,
    width: 17.5,
    height: 1.29,
    transform: "translate(-66.3 671) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.87,
    y: 349.12,
    width: 17.5,
    height: 1.29,
    transform: "translate(-56.87 669.81) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.27,
    y: 346.06,
    width: 17.5,
    height: 1.29,
    transform: "translate(-47.44 668.61) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.15,
    y: 306.53,
    width: 14.04,
    height: 73.3,
    transform: "translate(-86.73 641.03) rotate(-124.81)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.71,
    y: 363.92,
    width: 11.93,
    height: 4.86,
    transform: "translate(-155.21 651.58) rotate(-124.81)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.08,
    y: 319.36,
    width: 10.79,
    height: 54.8,
    transform: "translate(-98.6 641.97) rotate(-124.81)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.41,
    y: 358.39,
    width: 10.79,
    height: 1.29,
    transform: "translate(-136.45 646.76) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.81,
    y: 355.33,
    width: 10.79,
    height: 1.3,
    transform: "translate(-127.02 645.57) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.21,
    y: 352.27,
    width: 10.79,
    height: 1.3,
    transform: "translate(-117.59 644.37) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.62,
    y: 349.21,
    width: 10.79,
    height: 1.3,
    transform: "translate(-108.15 643.18) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.02,
    y: 346.14,
    width: 10.79,
    height: 1.29,
    transform: "translate(-98.72 641.99) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.43,
    y: 343.08,
    width: 10.79,
    height: 1.29,
    transform: "translate(-89.29 640.79) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.83,
    y: 340.02,
    width: 10.79,
    height: 1.29,
    transform: "translate(-79.86 639.6) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.23,
    y: 336.96,
    width: 10.79,
    height: 1.29,
    transform: "translate(-70.43 638.4) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.64,
    y: 333.9,
    width: 10.79,
    height: 1.3,
    transform: "translate(-60.99 637.21) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.04,
    y: 330.84,
    width: 10.79,
    height: 1.3,
    transform: "translate(-51.56 636.02) rotate(-124.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.13,
    y: 446.43,
    width: 11.97,
    height: 14.14,
    transform: "translate(583.44 886.47) rotate(175.97)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.55,
    y: 446.6,
    width: 7.59,
    height: 14.66,
    transform: "translate(563.95 888.01) rotate(175.97)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.83,
    y: 446.65,
    width: 7.53,
    height: 8.41,
    transform: "translate(562.23 881.92) rotate(175.97)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.15,
    y: 447.08,
    width: 4.7,
    height: 8.41,
    transform: "translate(550.09 883.2) rotate(175.97)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.43,
    y: 377.05,
    width: 19.35,
    height: 70.34,
    transform: "translate(576.53 804.15) rotate(175.97)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.65,
    y: 441.49,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 591.83, 864.64)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.88,
    y: 442.04,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 576.35, 866.28)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.35,
    y: 437.28,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 590.94, 856.25)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.59,
    y: 437.83,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 575.46, 857.89)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.06,
    y: 433.07,
    width: 6.09,
    height: 2.49,
    transform: "translate(590.05 847.86) rotate(175.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.29,
    y: 433.62,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 574.57, 849.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.76,
    y: 428.86,
    width: 6.09,
    height: 2.49,
    transform: "translate(589.15 839.47) rotate(175.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.99,
    y: 429.41,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 573.68, 841.1)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.46,
    y: 424.65,
    width: 6.09,
    height: 2.49,
    transform: "translate(588.27 831.07) rotate(175.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.7,
    y: 425.2,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 572.79, 832.71)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.17,
    y: 420.44,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 587.38, 822.68)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.4,
    y: 420.98,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 571.91, 824.32)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.87,
    y: 416.22,
    width: 6.09,
    height: 2.49,
    transform: "translate(586.49 814.29) rotate(175.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.1,
    y: 416.77,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 571.02, 815.93)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.57,
    y: 412.01,
    width: 6.09,
    height: 2.49,
    transform: "translate(585.6 805.9) rotate(175.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.81,
    y: 412.56,
    width: 6.09,
    height: 2.49,
    transform: "translate(570.13 807.54) rotate(175.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.28,
    y: 407.8,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 584.71, 797.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.51,
    y: 408.35,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 569.24, 799.14)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.98,
    y: 403.59,
    width: 6.09,
    height: 2.49,
    transform: "translate(583.82 789.11) rotate(175.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.21,
    y: 404.14,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 568.35, 790.75)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.68,
    y: 399.38,
    width: 6.09,
    height: 2.49,
    transform: "translate(582.93 780.72) rotate(175.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.91,
    y: 399.93,
    width: 6.09,
    height: 2.49,
    transform: "translate(567.46 782.36) rotate(175.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.38,
    y: 395.17,
    width: 6.09,
    height: 2.49,
    transform: "translate(582.05 772.33) rotate(175.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.62,
    y: 395.71,
    width: 6.09,
    height: 2.49,
    transform: "translate(566.57 773.97) rotate(175.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.09,
    y: 390.95,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 581.16, 763.94)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.32,
    y: 391.5,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 565.68, 765.58)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.79,
    y: 386.74,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 580.27, 755.54)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.02,
    y: 387.29,
    width: 6.09,
    height: 2.49,
    transform: "matrix(-1, 0.07, -0.07, -1, 564.79, 757.18)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.79,
    y: 378.28,
    width: 15.68,
    height: 70.34,
    transform: "translate(541.71 807.84) rotate(175.97)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.69,
    y: 388.55,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -26.79, 18.63)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.06,
    y: 388.1,
    width: 5,
    height: 2.49,
    transform: "translate(-26.74 19.08) rotate(-4.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.98,
    y: 392.76,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -27.09, 18.67)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.36,
    y: 392.31,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -27.04, 19.11)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.28,
    y: 396.97,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -27.38, 18.69)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.66,
    y: 396.52,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -27.33, 19.14)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.58,
    y: 401.19,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -27.68, 18.72)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.95,
    y: 400.74,
    width: 5,
    height: 2.49,
    transform: "translate(-27.63 19.17) rotate(-4.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.87,
    y: 405.4,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -27.97, 18.75)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.25,
    y: 404.95,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -27.92, 19.2)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.17,
    y: 409.61,
    width: 5,
    height: 2.49,
    transform: "translate(-28.27 18.79) rotate(-4.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.55,
    y: 409.16,
    width: 5,
    height: 2.49,
    transform: "translate(-28.22 19.23) rotate(-4.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.47,
    y: 413.82,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -28.56, 18.82)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.85,
    y: 413.37,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -28.51, 19.26)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.77,
    y: 418.03,
    width: 5,
    height: 2.49,
    transform: "translate(-28.86 18.85) rotate(-4.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.14,
    y: 417.58,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -28.81, 19.3)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.06,
    y: 422.24,
    width: 5,
    height: 2.49,
    transform: "translate(-29.15 18.88) rotate(-4.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.44,
    y: 421.79,
    width: 5,
    height: 2.49,
    transform: "translate(-29.11 19.33) rotate(-4.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.36,
    y: 426.46,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -29.45, 18.91)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.74,
    y: 426.01,
    width: 5,
    height: 2.49,
    transform: "translate(-29.4 19.36) rotate(-4.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.66,
    y: 430.67,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -29.74, 18.94)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.03,
    y: 430.22,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -29.7, 19.39)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.95,
    y: 434.88,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -30.04, 18.97)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.33,
    y: 434.43,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -29.99, 19.42)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.25,
    y: 439.09,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -30.33, 19)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.63,
    y: 438.64,
    width: 5,
    height: 2.49,
    transform: "translate(-30.29 19.45) rotate(-4.03)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.55,
    y: 443.3,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -30.63, 19.04)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.92,
    y: 442.85,
    width: 5,
    height: 2.49,
    transform: "matrix(1, -0.07, 0.07, 1, -30.58, 19.48)",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buildings--inject-175"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.89,
    y: 235.49,
    width: 17.45,
    height: 88.26,
    transform: "translate(-126.02 465.87) rotate(-106.92)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.84,
    y: 290.43,
    width: 17.45,
    height: 0.93,
    transform: "translate(-184.63 444.97) rotate(-106.92)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.05,
    y: 292.7,
    width: 5.16,
    height: 3.21,
    transform: "translate(-82.2 35.91) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.28,
    y: 290.8,
    width: 5.16,
    height: 3.21,
    transform: "translate(-81.38 37.64) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.51,
    y: 288.91,
    width: 5.16,
    height: 3.21,
    transform: "translate(-80.56 39.37) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.74,
    y: 287.02,
    width: 5.16,
    height: 3.21,
    transform: "translate(-79.74 41.1) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.97,
    y: 285.12,
    width: 5.16,
    height: 3.21,
    transform: "matrix(0.96, -0.29, 0.29, 0.96, -78.92, 42.83)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.2,
    y: 283.23,
    width: 5.16,
    height: 3.21,
    transform: "translate(-78.09 44.56) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.42,
    y: 281.33,
    width: 5.16,
    height: 3.21,
    transform: "translate(-77.28 46.3) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.65,
    y: 279.44,
    width: 5.16,
    height: 3.21,
    transform: "translate(-76.45 48.03) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.88,
    y: 277.54,
    width: 5.16,
    height: 3.21,
    transform: "translate(-75.64 49.76) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.11,
    y: 275.65,
    width: 5.16,
    height: 3.21,
    transform: "translate(-74.82 51.49) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.34,
    y: 273.75,
    width: 5.16,
    height: 3.21,
    transform: "translate(-73.99 53.21) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.57,
    y: 271.86,
    width: 5.16,
    height: 3.21,
    transform: "translate(-73.17 54.95) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.05,
    y: 292.7,
    width: 5.16,
    height: 3.21,
    transform: "translate(-82.2 35.91) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.28,
    y: 290.8,
    width: 5.16,
    height: 3.21,
    transform: "translate(-81.38 37.64) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.51,
    y: 288.91,
    width: 5.16,
    height: 3.21,
    transform: "translate(-80.56 39.37) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.74,
    y: 287.02,
    width: 5.16,
    height: 3.21,
    transform: "translate(-79.74 41.1) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.97,
    y: 285.12,
    width: 5.16,
    height: 3.21,
    transform: "matrix(0.96, -0.29, 0.29, 0.96, -78.92, 42.83)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.2,
    y: 283.23,
    width: 5.16,
    height: 3.21,
    transform: "translate(-78.1 44.57) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.42,
    y: 281.33,
    width: 5.16,
    height: 3.21,
    transform: "translate(-77.27 46.29) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.65,
    y: 279.44,
    width: 5.16,
    height: 3.21,
    transform: "translate(-76.45 48.03) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.88,
    y: 277.54,
    width: 5.16,
    height: 3.21,
    transform: "translate(-75.63 49.76) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.11,
    y: 275.65,
    width: 5.16,
    height: 3.21,
    transform: "translate(-74.81 51.49) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.34,
    y: 273.75,
    width: 5.16,
    height: 3.21,
    transform: "translate(-73.99 53.21) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.57,
    y: 271.86,
    width: 5.16,
    height: 3.21,
    transform: "translate(-73.17 54.95) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 287.61,
    width: 5.16,
    height: 3.21,
    transform: "translate(-80.78 35.24) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.73,
    y: 285.71,
    width: 5.16,
    height: 3.21,
    transform: "translate(-79.97 36.97) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.96,
    y: 283.82,
    width: 5.16,
    height: 3.21,
    transform: "translate(-79.14 38.7) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.19,
    y: 281.93,
    width: 5.16,
    height: 3.21,
    transform: "translate(-78.32 40.43) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.42,
    y: 280.03,
    width: 5.16,
    height: 3.21,
    transform: "translate(-77.5 42.16) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.65,
    y: 278.14,
    width: 5.16,
    height: 3.21,
    transform: "translate(-76.69 43.9) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.87,
    y: 276.24,
    width: 5.16,
    height: 3.21,
    transform: "translate(-75.86 45.62) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.1,
    y: 274.35,
    width: 5.16,
    height: 3.21,
    transform: "translate(-75.04 47.36) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.33,
    y: 272.45,
    width: 5.16,
    height: 3.21,
    transform: "translate(-74.22 49.09) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.56,
    y: 270.56,
    width: 5.16,
    height: 3.21,
    transform: "translate(-73.39 50.81) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.79,
    y: 268.66,
    width: 5.16,
    height: 3.21,
    transform: "translate(-72.58 52.55) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.02,
    y: 266.77,
    width: 5.16,
    height: 3.21,
    transform: "translate(-71.76 54.28) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.5,
    y: 287.61,
    width: 5.16,
    height: 3.21,
    transform: "translate(-80.78 35.24) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.73,
    y: 285.71,
    width: 5.16,
    height: 3.21,
    transform: "translate(-79.97 36.97) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.96,
    y: 283.82,
    width: 5.16,
    height: 3.21,
    transform: "translate(-79.14 38.7) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.19,
    y: 281.93,
    width: 5.16,
    height: 3.21,
    transform: "translate(-78.32 40.43) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.42,
    y: 280.03,
    width: 5.16,
    height: 3.21,
    transform: "translate(-77.5 42.16) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.65,
    y: 278.14,
    width: 5.16,
    height: 3.21,
    transform: "translate(-76.68 43.89) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.87,
    y: 276.24,
    width: 5.16,
    height: 3.21,
    transform: "translate(-75.86 45.63) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.1,
    y: 274.35,
    width: 5.16,
    height: 3.21,
    transform: "translate(-75.04 47.36) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.33,
    y: 272.45,
    width: 5.16,
    height: 3.21,
    transform: "translate(-74.21 49.08) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.56,
    y: 270.56,
    width: 5.16,
    height: 3.21,
    transform: "translate(-73.4 50.82) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.79,
    y: 268.66,
    width: 5.16,
    height: 3.21,
    transform: "translate(-72.58 52.55) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.02,
    y: 266.77,
    width: 5.16,
    height: 3.21,
    transform: "translate(-71.76 54.28) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.95,
    y: 282.52,
    width: 5.16,
    height: 3.21,
    transform: "translate(-79.37 34.57) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.18,
    y: 280.62,
    width: 5.16,
    height: 3.21,
    transform: "translate(-78.55 36.3) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.41,
    y: 278.73,
    width: 5.16,
    height: 3.21,
    transform: "translate(-77.73 38.03) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.64,
    y: 276.84,
    width: 5.16,
    height: 3.21,
    transform: "translate(-76.91 39.76) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.87,
    y: 274.94,
    width: 5.16,
    height: 3.21,
    transform: "translate(-76.09 41.49) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.1,
    y: 273.05,
    width: 5.16,
    height: 3.21,
    transform: "translate(-75.27 43.23) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.32,
    y: 271.15,
    width: 5.16,
    height: 3.21,
    transform: "translate(-74.44 44.95) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.55,
    y: 269.26,
    width: 5.16,
    height: 3.21,
    transform: "translate(-73.63 46.69) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.78,
    y: 267.36,
    width: 5.16,
    height: 3.21,
    transform: "translate(-72.8 48.41) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.01,
    y: 265.47,
    width: 5.16,
    height: 3.21,
    transform: "translate(-71.98 50.14) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.24,
    y: 263.57,
    width: 5.16,
    height: 3.21,
    transform: "translate(-71.16 51.88) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.47,
    y: 261.68,
    width: 5.16,
    height: 3.21,
    transform: "translate(-70.34 53.6) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.95,
    y: 282.52,
    width: 5.16,
    height: 3.21,
    transform: "translate(-79.37 34.57) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.18,
    y: 280.62,
    width: 5.16,
    height: 3.21,
    transform: "translate(-78.55 36.3) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.41,
    y: 278.73,
    width: 5.16,
    height: 3.21,
    transform: "translate(-77.73 38.03) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.64,
    y: 276.84,
    width: 5.16,
    height: 3.21,
    transform: "translate(-76.91 39.76) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.87,
    y: 274.94,
    width: 5.16,
    height: 3.21,
    transform: "translate(-76.09 41.49) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.1,
    y: 273.05,
    width: 5.16,
    height: 3.21,
    transform: "translate(-75.27 43.22) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.32,
    y: 271.15,
    width: 5.16,
    height: 3.21,
    transform: "translate(-74.45 44.95) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.55,
    y: 269.26,
    width: 5.16,
    height: 3.21,
    transform: "translate(-73.63 46.69) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.78,
    y: 267.36,
    width: 5.16,
    height: 3.21,
    transform: "translate(-72.81 48.42) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.01,
    y: 265.47,
    width: 5.16,
    height: 3.21,
    transform: "translate(-71.98 50.14) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.24,
    y: 263.57,
    width: 5.16,
    height: 3.21,
    transform: "translate(-71.16 51.88) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.47,
    y: 261.68,
    width: 5.16,
    height: 3.21,
    transform: "translate(-70.34 53.61) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.57,
    y: 258.11,
    width: 29.83,
    height: 88.26,
    transform: "translate(-138.77 501.65) rotate(-106.92)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.53,
    y: 313.05,
    width: 29.83,
    height: 0.93,
    transform: "translate(-197.38 480.75) rotate(-106.92)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.75,
    y: 308.24,
    width: 19.2,
    height: 4.96,
    transform: "translate(-206.45 468.45) rotate(-106.92)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.73,
    y: 294.74,
    width: 9.02,
    height: 4.96,
    transform: "translate(331.32 147.35) rotate(73.08)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.03,
    y: 317.94,
    width: 5.16,
    height: 5.21,
    transform: "translate(-89.49 39.37) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.26,
    y: 316.05,
    width: 5.16,
    height: 5.21,
    transform: "translate(-88.67 41.1) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.49,
    y: 314.15,
    width: 5.16,
    height: 5.21,
    transform: "translate(-87.85 42.83) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.72,
    y: 312.26,
    width: 5.16,
    height: 5.21,
    transform: "translate(-87.03 44.56) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.95,
    y: 310.36,
    width: 5.16,
    height: 5.21,
    transform: "translate(-86.21 46.29) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.18,
    y: 308.47,
    width: 5.16,
    height: 5.21,
    transform: "translate(-85.39 48.03) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.4,
    y: 306.57,
    width: 5.16,
    height: 5.21,
    transform: "translate(-84.56 49.75) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.63,
    y: 304.68,
    width: 5.16,
    height: 5.21,
    transform: "translate(-83.75 51.49) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.86,
    y: 302.78,
    width: 5.16,
    height: 5.21,
    transform: "translate(-82.92 53.22) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.09,
    y: 300.89,
    width: 5.16,
    height: 5.21,
    transform: "translate(-82.11 54.95) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.32,
    y: 299,
    width: 5.16,
    height: 5.21,
    transform: "translate(-81.28 56.68) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.55,
    y: 297.1,
    width: 5.16,
    height: 5.21,
    transform: "translate(-80.46 58.41) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.03,
    y: 317.94,
    width: 5.16,
    height: 5.21,
    transform: "translate(-89.49 39.37) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.26,
    y: 316.05,
    width: 5.16,
    height: 5.21,
    transform: "translate(-88.67 41.1) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.49,
    y: 314.15,
    width: 5.16,
    height: 5.21,
    transform: "translate(-87.85 42.83) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.72,
    y: 312.26,
    width: 5.16,
    height: 5.21,
    transform: "translate(-87.03 44.56) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.95,
    y: 310.36,
    width: 5.16,
    height: 5.21,
    transform: "translate(-86.21 46.29) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.18,
    y: 308.47,
    width: 5.16,
    height: 5.21,
    transform: "translate(-85.39 48.02) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.4,
    y: 306.57,
    width: 5.16,
    height: 5.21,
    transform: "translate(-84.57 49.76) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.63,
    y: 304.68,
    width: 5.16,
    height: 5.21,
    transform: "translate(-83.75 51.49) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.86,
    y: 302.78,
    width: 5.16,
    height: 5.21,
    transform: "translate(-82.93 53.22) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.09,
    y: 300.89,
    width: 5.16,
    height: 5.21,
    transform: "translate(-82.11 54.95) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.32,
    y: 299,
    width: 5.16,
    height: 5.21,
    transform: "translate(-81.28 56.68) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.55,
    y: 297.1,
    width: 5.16,
    height: 5.21,
    transform: "translate(-80.46 58.4) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.52,
    y: 309.68,
    width: 5.16,
    height: 5.21,
    transform: "translate(-87.19 38.28) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.75,
    y: 307.78,
    width: 5.16,
    height: 5.21,
    transform: "translate(-86.38 40.01) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.98,
    y: 305.89,
    width: 5.16,
    height: 5.21,
    transform: "translate(-85.55 41.74) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.2,
    y: 303.99,
    width: 5.16,
    height: 5.21,
    transform: "translate(-84.73 43.47) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.43,
    y: 302.1,
    width: 5.16,
    height: 5.21,
    transform: "translate(-83.91 45.2) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.66,
    y: 300.2,
    width: 5.16,
    height: 5.21,
    transform: "translate(-83.09 46.94) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.89,
    y: 298.31,
    width: 5.16,
    height: 5.21,
    transform: "translate(-82.27 48.66) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.12,
    y: 296.41,
    width: 5.16,
    height: 5.21,
    transform: "translate(-81.45 50.4) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.35,
    y: 294.52,
    width: 5.16,
    height: 5.21,
    transform: "translate(-80.62 52.12) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.58,
    y: 292.63,
    width: 5.16,
    height: 5.21,
    transform: "translate(-79.81 53.85) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.81,
    y: 290.73,
    width: 5.16,
    height: 5.21,
    transform: "translate(-78.99 55.59) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.03,
    y: 288.84,
    width: 5.16,
    height: 5.21,
    transform: "translate(-78.17 57.32) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.52,
    y: 309.68,
    width: 5.16,
    height: 5.21,
    transform: "translate(-87.19 38.28) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.75,
    y: 307.78,
    width: 5.16,
    height: 5.21,
    transform: "translate(-86.38 40.01) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.98,
    y: 305.89,
    width: 5.16,
    height: 5.21,
    transform: "translate(-85.55 41.74) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.2,
    y: 303.99,
    width: 5.16,
    height: 5.21,
    transform: "translate(-84.73 43.47) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.43,
    y: 302.1,
    width: 5.16,
    height: 5.21,
    transform: "translate(-83.91 45.2) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.66,
    y: 300.2,
    width: 5.16,
    height: 5.21,
    transform: "translate(-83.09 46.94) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.89,
    y: 298.31,
    width: 5.16,
    height: 5.21,
    transform: "translate(-82.27 48.67) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.12,
    y: 296.41,
    width: 5.16,
    height: 5.21,
    transform: "translate(-81.45 50.4) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.35,
    y: 294.52,
    width: 5.16,
    height: 5.21,
    transform: "translate(-80.63 52.12) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.58,
    y: 292.63,
    width: 5.16,
    height: 5.21,
    transform: "translate(-79.81 53.86) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.81,
    y: 290.73,
    width: 5.16,
    height: 5.21,
    transform: "translate(-78.99 55.59) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.03,
    y: 288.84,
    width: 5.16,
    height: 5.21,
    transform: "translate(-78.17 57.32) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.01,
    y: 301.41,
    width: 5.16,
    height: 5.21,
    transform: "translate(-84.9 37.19) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.24,
    y: 299.52,
    width: 5.16,
    height: 5.21,
    transform: "translate(-84.08 38.92) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.47,
    y: 297.62,
    width: 5.16,
    height: 5.21,
    transform: "translate(-83.26 40.66) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.69,
    y: 295.73,
    width: 5.16,
    height: 5.21,
    transform: "translate(-82.44 42.38) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.92,
    y: 293.83,
    width: 5.16,
    height: 5.21,
    transform: "translate(-81.62 44.11) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.15,
    y: 291.94,
    width: 5.16,
    height: 5.21,
    transform: "translate(-80.8 45.85) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.38,
    y: 290.05,
    width: 5.16,
    height: 5.21,
    transform: "translate(-79.98 47.58) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.61,
    y: 288.15,
    width: 5.16,
    height: 5.21,
    transform: "translate(-79.15 49.31) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.84,
    y: 286.26,
    width: 5.16,
    height: 5.21,
    transform: "matrix(0.96, -0.29, 0.29, 0.96, -78.33, 51.03)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.06,
    y: 284.36,
    width: 5.16,
    height: 5.21,
    transform: "translate(-77.51 52.77) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.29,
    y: 282.47,
    width: 5.16,
    height: 5.21,
    transform: "translate(-76.69 54.5) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.52,
    y: 280.57,
    width: 5.16,
    height: 5.21,
    transform: "translate(-75.87 56.23) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.01,
    y: 301.41,
    width: 5.16,
    height: 5.21,
    transform: "translate(-84.9 37.19) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.24,
    y: 299.52,
    width: 5.16,
    height: 5.21,
    transform: "translate(-84.08 38.92) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.47,
    y: 297.62,
    width: 5.16,
    height: 5.21,
    transform: "translate(-83.26 40.66) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.69,
    y: 295.73,
    width: 5.16,
    height: 5.21,
    transform: "translate(-82.44 42.38) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.92,
    y: 293.83,
    width: 5.16,
    height: 5.21,
    transform: "translate(-81.62 44.11) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.15,
    y: 291.94,
    width: 5.16,
    height: 5.21,
    transform: "translate(-80.8 45.85) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.38,
    y: 290.05,
    width: 5.16,
    height: 5.21,
    transform: "translate(-79.97 47.58) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.61,
    y: 288.15,
    width: 5.16,
    height: 5.21,
    transform: "translate(-79.15 49.31) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.84,
    y: 286.26,
    width: 5.16,
    height: 5.21,
    transform: "translate(-78.33 51.03) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.06,
    y: 284.36,
    width: 5.16,
    height: 5.21,
    transform: "translate(-77.51 52.77) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.29,
    y: 282.47,
    width: 5.16,
    height: 5.21,
    transform: "translate(-76.69 54.5) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.52,
    y: 280.57,
    width: 5.16,
    height: 5.21,
    transform: "translate(-75.87 56.23) rotate(-16.92)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.07,
    y: 98.85,
    width: 16.9,
    height: 79.2,
    transform: "translate(-46.5 112.35) rotate(-31.56)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.07,
    y: 98.85,
    width: 16.9,
    height: 79.2,
    transform: "translate(-46.5 112.35) rotate(-31.56)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.59,
    y: 102.04,
    width: 17.91,
    height: 2.6,
    transform: "translate(340.31 110.5) rotate(148.44)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.05,
    y: 99.19,
    width: 15.18,
    height: 4.05,
    transform: "translate(333.83 108.09) rotate(148.44)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.05,
    y: 99.19,
    width: 15.18,
    height: 4.05,
    transform: "translate(333.83 108.09) rotate(148.44)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.91,
    y: 92.15,
    width: 11.62,
    height: 8.94,
    transform: "translate(322.31 102.15) rotate(148.44)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.91,
    y: 92.15,
    width: 11.62,
    height: 8.94,
    transform: "translate(322.31 102.15) rotate(148.44)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 152.55,
    y: 109.62,
    width: 2.29,
    height: 8.33,
    transform: "translate(-36.82 97.28) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 158.49,
    y: 119.29,
    width: 2.29,
    height: 8.33,
    transform: "translate(-41 101.81) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 164.43,
    y: 128.96,
    width: 2.29,
    height: 8.33,
    transform: "translate(-45.19 106.35) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 170.37,
    y: 138.63,
    width: 2.29,
    height: 8.33,
    transform: "translate(-49.37 110.9) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 176.31,
    y: 148.3,
    width: 2.29,
    height: 8.33,
    transform: "translate(-53.55 115.44) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 182.25,
    y: 157.97,
    width: 2.29,
    height: 8.33,
    transform: "translate(-57.73 119.97) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 155.78,
    y: 107.64,
    width: 2.29,
    height: 8.33,
    transform: "translate(-35.31 98.68) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 161.72,
    y: 117.31,
    width: 2.29,
    height: 8.33,
    transform: "translate(-39.49 103.21) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 167.66,
    y: 126.98,
    width: 2.29,
    height: 8.33,
    transform: "translate(-43.67 107.75) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 173.6,
    y: 136.65,
    width: 2.29,
    height: 8.33,
    transform: "translate(-47.86 112.29) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 179.54,
    y: 146.32,
    width: 2.29,
    height: 8.33,
    transform: "translate(-52.04 116.83) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 185.48,
    y: 155.99,
    width: 2.29,
    height: 8.33,
    transform: "translate(-56.22 121.37) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 159.01,
    y: 105.66,
    width: 2.29,
    height: 8.33,
    transform: "translate(-33.79 100.07) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 164.95,
    y: 115.33,
    width: 2.29,
    height: 8.33,
    transform: "translate(-37.97 104.61) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 170.89,
    y: 125,
    width: 2.29,
    height: 8.33,
    transform: "matrix(0.85, -0.52, 0.52, 0.85, -42.16, 109.14)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 176.83,
    y: 134.67,
    width: 2.29,
    height: 8.33,
    transform: "translate(-46.34 113.69) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 182.77,
    y: 144.33,
    width: 2.29,
    height: 8.33,
    transform: "translate(-50.52 118.23) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 188.71,
    y: 154,
    width: 2.29,
    height: 8.33,
    transform: "translate(-54.7 122.77) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 162.24,
    y: 103.67,
    width: 2.29,
    height: 8.33,
    transform: "translate(-32.28 101.47) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 168.18,
    y: 113.34,
    width: 2.29,
    height: 8.33,
    transform: "translate(-36.46 106.01) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 174.11,
    y: 123.01,
    width: 2.29,
    height: 8.33,
    transform: "translate(-40.64 110.54) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 180.05,
    y: 132.68,
    width: 2.29,
    height: 8.33,
    transform: "translate(-44.82 115.09) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 185.99,
    y: 142.35,
    width: 2.29,
    height: 8.33,
    transform: "translate(-49.01 119.63) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 191.93,
    y: 152.02,
    width: 2.29,
    height: 8.33,
    transform: "translate(-53.19 124.17) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 136.24,
    y: 112.34,
    width: 34.63,
    height: 79.2,
    transform: "translate(-56.81 102.85) rotate(-31.56)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.63,
    y: 111.79,
    width: 32.98,
    height: 4.05,
    transform: "translate(-40.18 85.47) rotate(-31.56)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.79,
    y: 101.68,
    width: 24.81,
    height: 8.94,
    transform: "translate(-36.15 84.37) rotate(-31.56)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.79,
    y: 101.68,
    width: 24.81,
    height: 8.94,
    transform: "translate(-36.15 84.37) rotate(-31.56)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.88,
    y: 116.06,
    width: 35.67,
    height: 2.6,
    transform: "translate(-41.94 86.3) rotate(-31.56)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.88,
    y: 116.06,
    width: 35.67,
    height: 2.6,
    transform: "translate(-41.94 86.3) rotate(-31.56)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 124.3,
    y: 126.23,
    width: 4.7,
    height: 8.33,
    transform: "translate(-49.52 85.58) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 130.24,
    y: 135.9,
    width: 4.7,
    height: 8.33,
    transform: "translate(-53.7 90.12) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 136.18,
    y: 145.57,
    width: 4.7,
    height: 8.33,
    transform: "translate(-57.88 94.66) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 142.12,
    y: 155.24,
    width: 4.7,
    height: 8.33,
    transform: "translate(-62.07 99.2) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 148.06,
    y: 164.91,
    width: 4.7,
    height: 8.33,
    transform: "matrix(0.85, -0.52, 0.52, 0.85, -66.25, 103.74)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 174.58,
    width: 4.7,
    height: 8.33,
    transform: "translate(-70.43 108.28) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 130.92,
    y: 122.17,
    width: 4.7,
    height: 8.33,
    transform: "translate(-46.41 88.45) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 136.86,
    y: 131.84,
    width: 4.7,
    height: 8.33,
    transform: "translate(-50.59 92.99) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 142.8,
    y: 141.51,
    width: 4.7,
    height: 8.33,
    transform: "translate(-54.78 97.52) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 148.74,
    y: 151.18,
    width: 4.7,
    height: 8.33,
    transform: "translate(-58.96 102.06) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 154.68,
    y: 160.85,
    width: 4.7,
    height: 8.33,
    transform: "translate(-63.14 106.6) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 160.62,
    y: 170.52,
    width: 4.7,
    height: 8.33,
    transform: "translate(-67.32 111.14) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 137.55,
    y: 118.1,
    width: 4.7,
    height: 8.33,
    transform: "translate(-43.3 91.31) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 143.48,
    y: 127.77,
    width: 4.7,
    height: 8.33,
    transform: "matrix(0.85, -0.52, 0.52, 0.85, -47.48, 95.85)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 149.42,
    y: 137.44,
    width: 4.7,
    height: 8.33,
    transform: "matrix(0.85, -0.52, 0.52, 0.85, -51.67, 100.39)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 155.36,
    y: 147.11,
    width: 4.7,
    height: 8.33,
    transform: "translate(-55.85 104.93) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 161.3,
    y: 156.78,
    width: 4.7,
    height: 8.33,
    transform: "translate(-60.03 109.47) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 167.24,
    y: 166.45,
    width: 4.7,
    height: 8.33,
    transform: "matrix(0.85, -0.52, 0.52, 0.85, -64.21, 114)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 144.17,
    y: 114.03,
    width: 4.7,
    height: 8.33,
    transform: "translate(-40.19 94.17) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 150.11,
    y: 123.7,
    width: 4.7,
    height: 8.33,
    transform: "translate(-44.38 98.71) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 156.05,
    y: 133.37,
    width: 4.7,
    height: 8.33,
    transform: "translate(-48.56 103.25) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 161.99,
    y: 143.04,
    width: 4.7,
    height: 8.33,
    transform: "matrix(0.85, -0.52, 0.52, 0.85, -52.74, 107.79)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 167.92,
    y: 152.71,
    width: 4.7,
    height: 8.33,
    transform: "translate(-56.92 112.32) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 173.86,
    y: 162.38,
    width: 4.7,
    height: 8.33,
    transform: "translate(-61.11 116.87) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 178.4,
    width: 12.47,
    height: 7.85,
    transform: "translate(-69.96 117.12) rotate(-31.56)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.51,
    y: 112.22,
    width: 16.9,
    height: 45.16,
    transform: "translate(-38.91 131.93) rotate(-31.56)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.51,
    y: 112.22,
    width: 16.9,
    height: 45.16,
    transform: "translate(-38.91 131.93) rotate(-31.56)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.94,
    y: 112.9,
    width: 17.91,
    height: 2.6,
    transform: "translate(433.69 105.82) rotate(148.44)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.4,
    y: 110.05,
    width: 15.18,
    height: 4.05,
    transform: "translate(427.21 103.42) rotate(148.44)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.4,
    y: 110.05,
    width: 15.18,
    height: 4.05,
    transform: "translate(427.21 103.42) rotate(148.44)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 199.9,
    y: 120.48,
    width: 2.29,
    height: 8.33,
    transform: "translate(-35.5 123.67) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 205.84,
    y: 130.15,
    width: 2.29,
    height: 8.33,
    transform: "translate(-39.68 128.21) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 211.78,
    y: 139.82,
    width: 2.29,
    height: 8.33,
    transform: "matrix(0.85, -0.52, 0.52, 0.85, -43.87, 132.74)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 203.13,
    y: 118.5,
    width: 2.29,
    height: 8.33,
    transform: "translate(-33.99 125.07) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 209.07,
    y: 128.17,
    width: 2.29,
    height: 8.33,
    transform: "translate(-38.17 129.6) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 215.01,
    y: 137.84,
    width: 2.29,
    height: 8.33,
    transform: "translate(-42.35 134.15) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 206.36,
    y: 116.51,
    width: 2.29,
    height: 8.33,
    transform: "translate(-32.47 126.46) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 212.3,
    y: 126.18,
    width: 2.29,
    height: 8.33,
    transform: "matrix(0.85, -0.52, 0.52, 0.85, -36.65, 130.99)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 218.24,
    y: 135.85,
    width: 2.29,
    height: 8.33,
    transform: "translate(-40.84 135.54) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 209.59,
    y: 114.53,
    width: 2.29,
    height: 8.33,
    transform: "translate(-30.96 127.86) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 215.53,
    y: 124.2,
    width: 2.29,
    height: 8.33,
    transform: "translate(-35.14 132.4) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 133.87,
    width: 2.29,
    height: 8.33,
    transform: "translate(-39.32 136.93) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 174.69,
    y: 125.71,
    width: 34.63,
    height: 45.16,
    transform: "translate(-49.22 122.43) rotate(-31.56)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.99,
    y: 122.65,
    width: 32.98,
    height: 4.05,
    transform: "translate(-38.86 111.86) rotate(-31.56)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.23,
    y: 126.92,
    width: 35.67,
    height: 2.6,
    transform: "matrix(0.85, -0.52, 0.52, 0.85, -40.62, 112.69)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.23,
    y: 126.92,
    width: 35.67,
    height: 2.6,
    transform: "matrix(0.85, -0.52, 0.52, 0.85, -40.62, 112.69)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 171.66,
    y: 137.09,
    width: 4.7,
    height: 8.33,
    transform: "translate(-48.2 111.97) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 146.76,
    width: 4.7,
    height: 8.33,
    transform: "translate(-52.38 116.51) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 183.53,
    y: 156.43,
    width: 4.7,
    height: 8.33,
    transform: "translate(-56.56 121.05) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 178.28,
    y: 133.02,
    width: 4.7,
    height: 8.33,
    transform: "translate(-45.09 114.83) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 184.22,
    y: 142.69,
    width: 4.7,
    height: 8.33,
    transform: "translate(-49.27 119.37) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 190.16,
    y: 152.36,
    width: 4.7,
    height: 8.33,
    transform: "translate(-53.45 123.91) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 184.9,
    y: 128.96,
    width: 4.7,
    height: 8.33,
    transform: "translate(-41.98 117.7) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 190.84,
    y: 138.63,
    width: 4.7,
    height: 8.33,
    transform: "matrix(0.85, -0.52, 0.52, 0.85, -46.16, 122.24)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 196.78,
    y: 148.3,
    width: 4.7,
    height: 8.33,
    transform: "translate(-50.35 126.78) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 191.52,
    y: 124.89,
    width: 4.7,
    height: 8.33,
    transform: "translate(-38.87 120.56) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 197.46,
    y: 134.56,
    width: 4.7,
    height: 8.33,
    transform: "translate(-43.05 125.1) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 203.4,
    y: 144.23,
    width: 4.7,
    height: 8.33,
    transform: "translate(-47.24 129.64) rotate(-31.56)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 301.47,
    y: 70.6,
    width: 28.44,
    height: 92.63,
    transform: "translate(92 -134.66) rotate(28.04)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.08,
    y: 68.9,
    width: 21.28,
    height: 9.32,
    transform: "translate(74.79 -152.45) rotate(28.04)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.78,
    y: 66.59,
    width: 1.82,
    height: 6.44,
    transform: "translate(72.21 -149.6) rotate(28.04)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.59,
    y: 68.09,
    width: 1.82,
    height: 6.44,
    transform: "translate(73.23 -150.73) rotate(28.03)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.4,
    y: 69.58,
    width: 1.82,
    height: 6.44,
    transform: "translate(74.28 -151.89) rotate(28.04)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.22,
    y: 71.08,
    width: 1.82,
    height: 6.44,
    transform: "translate(75.32 -153.04) rotate(28.04)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.03,
    y: 72.58,
    width: 1.82,
    height: 6.44,
    transform: "translate(76.34 -154.18) rotate(28.04)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.84,
    y: 74.07,
    width: 1.82,
    height: 6.44,
    transform: "translate(77.38 -155.32) rotate(28.04)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.54,
    y: 76.17,
    width: 9.68,
    height: 9.32,
    transform: "translate(79.81 -158.02) rotate(28.04)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.22,
    y: 76.34,
    width: 1.55,
    height: 6.44,
    transform: "translate(78.93 -157.05) rotate(28.04)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.61,
    y: 77.61,
    width: 1.55,
    height: 6.44,
    transform: "translate(79.8 -158.01) rotate(28.03)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 78.88,
    width: 1.55,
    height: 6.44,
    transform: "translate(80.68 -158.99) rotate(28.03)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.3,
    y: 80.64,
    width: 14.48,
    height: 92.63,
    transform: "translate(98.93 -142.34) rotate(28.04)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.74,
    y: 78.45,
    width: 5.25,
    height: 8.53,
    transform: "translate(77.29 -144.16) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.17,
    y: 83.47,
    width: 5.25,
    height: 8.53,
    transform: "translate(80.76 -148.01) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.42,
    y: 90.31,
    width: 5.25,
    height: 8.53,
    transform: "translate(82.12 -139.8) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.86,
    y: 95.34,
    width: 5.25,
    height: 8.53,
    transform: "translate(85.59 -143.65) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.11,
    y: 102.17,
    width: 5.25,
    height: 8.53,
    transform: "translate(86.96 -135.44) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.54,
    y: 107.2,
    width: 5.25,
    height: 8.53,
    transform: "translate(90.43 -139.29) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.79,
    y: 114.03,
    width: 5.25,
    height: 8.53,
    transform: "translate(91.79 -131.08) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.22,
    y: 119.06,
    width: 5.25,
    height: 8.53,
    transform: "translate(95.26 -134.93) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.48,
    y: 125.89,
    width: 5.25,
    height: 8.53,
    transform: "translate(96.62 -126.72) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.91,
    y: 130.92,
    width: 5.25,
    height: 8.53,
    transform: "translate(100.09 -130.57) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.16,
    y: 137.75,
    width: 5.25,
    height: 8.53,
    transform: "translate(101.46 -122.36) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.59,
    y: 142.78,
    width: 5.25,
    height: 8.53,
    transform: "translate(104.93 -126.2) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.09,
    y: 89.76,
    width: 3.02,
    height: 8.53,
    transform: "translate(85.1 -152.82) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.51,
    y: 92.65,
    width: 3.02,
    height: 8.53,
    transform: "translate(87.09 -155.02) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.77,
    y: 101.62,
    width: 3.02,
    height: 8.53,
    transform: "translate(89.93 -148.45) rotate(28.03)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.2,
    y: 104.51,
    width: 3.02,
    height: 8.53,
    transform: "translate(91.93 -150.67) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.46,
    y: 113.48,
    width: 3.02,
    height: 8.53,
    transform: "translate(94.77 -144.1) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.88,
    y: 116.37,
    width: 3.02,
    height: 8.53,
    transform: "translate(96.76 -146.31) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.14,
    y: 125.34,
    width: 3.02,
    height: 8.53,
    transform: "translate(99.6 -139.74) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.56,
    y: 128.23,
    width: 3.02,
    height: 8.53,
    transform: "translate(101.59 -141.95) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.83,
    y: 137.2,
    width: 3.02,
    height: 8.53,
    transform: "translate(104.44 -135.38) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.25,
    y: 140.09,
    width: 3.02,
    height: 8.53,
    transform: "translate(106.43 -137.59) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.51,
    y: 149.06,
    width: 3.02,
    height: 8.53,
    transform: "translate(109.27 -131.02) rotate(28.04)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.93,
    y: 151.95,
    width: 3.02,
    height: 8.53,
    transform: "translate(111.25 -133.22) rotate(28.03)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.02,
    y: 111.04,
    width: 20.17,
    height: 19.02,
    transform: "translate(625.43 489.81) rotate(-136.63)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.5,
    y: 99.63,
    width: 12.79,
    height: 19.72,
    transform: "translate(611.93 462.32) rotate(-136.63)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.01,
    y: 106.26,
    width: 12.69,
    height: 11.32,
    transform: "translate(604.14 464.09) rotate(-136.63)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.91,
    y: 99.18,
    width: 7.92,
    height: 11.32,
    transform: "translate(596.07 446.73) rotate(-136.63)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.73,
    y: 114.68,
    width: 32.61,
    height: 94.63,
    transform: "translate(532.94 535.93) rotate(-136.63)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.87,
    y: 135.22,
    width: 10.25,
    height: 3.35,
    transform: "translate(608.84 515.9) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.34,
    y: 126.21,
    width: 10.25,
    height: 3.35,
    transform: "translate(598.55 493.8) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.97,
    y: 139.35,
    width: 10.25,
    height: 3.35,
    transform: "translate(599.26 520.35) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.44,
    y: 130.34,
    width: 10.25,
    height: 3.35,
    transform: "matrix(-0.73, -0.69, 0.69, -0.73, 588.98, 498.25)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.07,
    y: 143.48,
    width: 10.25,
    height: 3.35,
    transform: "translate(589.69 524.8) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.53,
    y: 134.47,
    width: 10.25,
    height: 3.35,
    transform: "matrix(-0.73, -0.69, 0.69, -0.73, 579.41, 502.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.17,
    y: 147.6,
    width: 10.25,
    height: 3.35,
    transform: "translate(580.12 529.26) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.63,
    y: 138.6,
    width: 10.25,
    height: 3.35,
    transform: "translate(569.84 507.15) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.27,
    y: 151.73,
    width: 10.25,
    height: 3.35,
    transform: "translate(570.55 533.7) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.73,
    y: 142.72,
    width: 10.25,
    height: 3.35,
    transform: "translate(560.27 511.6) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.37,
    y: 155.86,
    width: 10.25,
    height: 3.35,
    transform: "translate(560.98 538.16) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.83,
    y: 146.85,
    width: 10.25,
    height: 3.35,
    transform: "translate(550.7 516.05) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.47,
    y: 159.99,
    width: 10.25,
    height: 3.35,
    transform: "translate(551.41 542.61) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.93,
    y: 150.98,
    width: 10.25,
    height: 3.35,
    transform: "translate(541.13 520.5) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.57,
    y: 164.12,
    width: 10.25,
    height: 3.35,
    transform: "translate(541.84 547.06) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.03,
    y: 155.11,
    width: 10.25,
    height: 3.35,
    transform: "translate(531.55 524.95) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.67,
    y: 168.25,
    width: 10.25,
    height: 3.35,
    transform: "translate(532.27 551.51) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.13,
    y: 159.24,
    width: 10.25,
    height: 3.35,
    transform: "translate(521.98 529.4) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.77,
    y: 172.38,
    width: 10.25,
    height: 3.35,
    transform: "matrix(-0.73, -0.69, 0.69, -0.73, 522.69, 555.96)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.23,
    y: 163.37,
    width: 10.25,
    height: 3.35,
    transform: "translate(512.41 533.85) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.86,
    y: 176.5,
    width: 10.25,
    height: 3.35,
    transform: "translate(513.12 560.41) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.33,
    y: 167.5,
    width: 10.25,
    height: 3.35,
    transform: "translate(502.84 538.31) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.96,
    y: 180.63,
    width: 10.25,
    height: 3.35,
    transform: "translate(503.55 564.86) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.43,
    y: 171.62,
    width: 10.25,
    height: 3.35,
    transform: "translate(493.27 542.76) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.06,
    y: 184.76,
    width: 10.25,
    height: 3.35,
    transform: "matrix(-0.73, -0.69, 0.69, -0.73, 493.97, 569.32)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.53,
    y: 175.75,
    width: 10.25,
    height: 3.35,
    transform: "translate(483.7 547.21) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.16,
    y: 188.89,
    width: 10.25,
    height: 3.35,
    transform: "matrix(-0.73, -0.69, 0.69, -0.73, 484.4, 573.77)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.63,
    y: 179.88,
    width: 10.25,
    height: 3.35,
    transform: "translate(474.13 551.66) rotate(-136.63)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.36,
    y: 94.41,
    width: 26.43,
    height: 94.63,
    transform: "translate(509.81 486.18) rotate(-136.63)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.59,
    y: 159.14,
    width: 8.42,
    height: 3.35,
    transform: "translate(199.14 -179.14) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.42,
    y: 166.54,
    width: 8.42,
    height: 3.35,
    transform: "translate(206.36 -182.49) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.49,
    y: 155.01,
    width: 8.42,
    height: 3.35,
    transform: "translate(197.37 -182.94) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.32,
    y: 162.41,
    width: 8.42,
    height: 3.35,
    transform: "translate(204.59 -186.3) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.39,
    y: 150.88,
    width: 8.42,
    height: 3.35,
    transform: "translate(195.6 -186.75) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.22,
    y: 158.28,
    width: 8.42,
    height: 3.35,
    transform: "translate(202.82 -190.11) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.29,
    y: 146.75,
    width: 8.42,
    height: 3.35,
    transform: "translate(193.83 -190.56) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.12,
    y: 154.15,
    width: 8.42,
    height: 3.35,
    transform: "translate(201.05 -193.91) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.19,
    y: 142.62,
    width: 8.42,
    height: 3.35,
    transform: "translate(192.06 -194.36) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.02,
    y: 150.02,
    width: 8.42,
    height: 3.35,
    transform: "translate(199.28 -197.72) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.09,
    y: 138.5,
    width: 8.42,
    height: 3.35,
    transform: "translate(190.29 -198.17) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.92,
    y: 145.89,
    width: 8.42,
    height: 3.35,
    transform: "translate(197.51 -201.53) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.99,
    y: 134.37,
    width: 8.42,
    height: 3.35,
    transform: "translate(188.52 -201.98) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.82,
    y: 141.76,
    width: 8.42,
    height: 3.35,
    transform: "translate(195.74 -205.33) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.89,
    y: 130.24,
    width: 8.42,
    height: 3.35,
    transform: "translate(186.75 -205.78) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.72,
    y: 137.64,
    width: 8.42,
    height: 3.35,
    transform: "translate(193.97 -209.14) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.79,
    y: 126.11,
    width: 8.42,
    height: 3.35,
    transform: "translate(184.98 -209.59) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.62,
    y: 133.51,
    width: 8.42,
    height: 3.35,
    transform: "translate(192.2 -212.95) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.7,
    y: 121.98,
    width: 8.42,
    height: 3.35,
    transform: "translate(183.21 -213.39) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.52,
    y: 129.38,
    width: 8.42,
    height: 3.35,
    transform: "translate(190.43 -216.75) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.6,
    y: 117.85,
    width: 8.42,
    height: 3.35,
    transform: "translate(181.44 -217.2) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.43,
    y: 125.25,
    width: 8.42,
    height: 3.35,
    transform: "translate(188.66 -220.56) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.5,
    y: 113.72,
    width: 8.42,
    height: 3.35,
    transform: "translate(179.67 -221.01) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.33,
    y: 121.12,
    width: 8.42,
    height: 3.35,
    transform: "translate(186.89 -224.36) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.4,
    y: 109.59,
    width: 8.42,
    height: 3.35,
    transform: "translate(177.9 -224.81) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.23,
    y: 116.99,
    width: 8.42,
    height: 3.35,
    transform: "translate(185.12 -228.17) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.3,
    y: 105.47,
    width: 8.42,
    height: 3.35,
    transform: "translate(176.13 -228.62) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.13,
    y: 112.86,
    width: 8.42,
    height: 3.35,
    transform: "translate(183.35 -231.98) rotate(43.37)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.87 307.18 370.06 284.35 436.83 322.92 437.44 353.72 356.87 307.18",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.56 304.25 368.57 286.92 433.48 324.41 433.94 347.79 358.56 304.25",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.56 304.25 368.57 286.92 433.48 324.41 433.94 347.79 358.56 304.25",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.66,
    y: 332.97,
    width: 17.72,
    height: 0.59,
    transform: "translate(928.44 130.62) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.45,
    y: 330.54,
    width: 17.72,
    height: 0.59,
    transform: "translate(920.01 130.62) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.23,
    y: 328.1,
    width: 17.72,
    height: 0.59,
    transform: "translate(911.57 130.61) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.01,
    y: 325.66,
    width: 17.72,
    height: 0.59,
    transform: "translate(903.13 130.61) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.79,
    y: 323.23,
    width: 17.72,
    height: 0.59,
    transform: "translate(894.7 130.61) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.57,
    y: 320.79,
    width: 17.72,
    height: 0.59,
    transform: "translate(886.26 130.61) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.36,
    y: 318.36,
    width: 17.72,
    height: 0.59,
    transform: "translate(877.82 130.6) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.14,
    y: 315.92,
    width: 17.72,
    height: 0.59,
    transform: "translate(869.38 130.6) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.92,
    y: 313.48,
    width: 17.72,
    height: 0.59,
    transform: "translate(860.95 130.6) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.7,
    y: 311.05,
    width: 17.72,
    height: 0.59,
    transform: "translate(852.51 130.6) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.48,
    y: 308.61,
    width: 17.72,
    height: 0.59,
    transform: "translate(844.07 130.6) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.27,
    y: 306.17,
    width: 17.72,
    height: 0.59,
    transform: "translate(835.63 130.59) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.05,
    y: 303.74,
    width: 17.72,
    height: 0.59,
    transform: "translate(827.2 130.59) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.83,
    y: 301.3,
    width: 17.72,
    height: 0.59,
    transform: "translate(818.76 130.59) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.61,
    y: 298.86,
    width: 17.72,
    height: 0.59,
    transform: "translate(810.32 130.59) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.39,
    y: 296.43,
    width: 17.72,
    height: 0.59,
    transform: "translate(801.88 130.59) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.68,
    y: 316.09,
    width: 79.32,
    height: 0.64,
    transform: "translate(211.53 -156.31) rotate(30.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.94 347.79 431.62 346.44 431.21 325.75 367.43 288.9 368.57 286.92 433.48 324.41 433.94 347.79",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.94 347.79 431.62 346.44 431.21 325.75 367.43 288.9 368.57 286.92 433.48 324.41 433.94 347.79",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.73,
    y: 293.99,
    width: 23.23,
    height: 93.05,
    transform: "translate(881.94 171.94) rotate(120.01)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.73,
    y: 293.99,
    width: 23.23,
    height: 93.05,
    transform: "translate(881.94 171.94) rotate(120.01)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 416.17,
    y: 359.2,
    width: 18.72,
    height: 2.11,
    transform: "translate(950.32 171.96) rotate(120.01)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 412.04,
    y: 356.81,
    width: 18.72,
    height: 2.11,
    transform: "translate(942.05 171.96) rotate(120.01)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 407.9,
    y: 354.43,
    width: 18.72,
    height: 2.11,
    transform: "translate(933.79 171.96) rotate(120.01)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 403.77,
    y: 352.04,
    width: 18.72,
    height: 2.11,
    transform: "translate(925.52 171.95) rotate(120.01)"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 399.64,
    y: 349.65,
    width: 18.72,
    height: 2.11,
    transform: "translate(917.25 171.95) rotate(120.01)"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 395.51,
    y: 347.27,
    width: 18.72,
    height: 2.11,
    transform: "translate(908.99 171.95) rotate(120.01)"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 391.38,
    y: 344.88,
    width: 18.72,
    height: 2.11,
    transform: "translate(900.73 171.95) rotate(120.01)"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 387.24,
    y: 342.49,
    width: 18.72,
    height: 2.11,
    transform: "translate(892.46 171.94) rotate(120.01)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 383.11,
    y: 340.11,
    width: 18.72,
    height: 2.11,
    transform: "translate(884.19 171.94) rotate(120.01)"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 378.98,
    y: 337.72,
    width: 18.72,
    height: 2.11,
    transform: "translate(875.93 171.94) rotate(120.01)"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 374.85,
    y: 335.33,
    width: 18.72,
    height: 2.11,
    transform: "translate(867.66 171.94) rotate(120.01)"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 370.72,
    y: 332.95,
    width: 18.72,
    height: 2.11,
    transform: "translate(859.4 171.93) rotate(120.01)"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 366.58,
    y: 330.56,
    width: 18.72,
    height: 2.11,
    transform: "translate(851.13 171.93) rotate(120.01)"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 362.45,
    y: 328.17,
    width: 18.72,
    height: 2.11,
    transform: "translate(842.87 171.93) rotate(120.01)"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 358.32,
    y: 325.79,
    width: 18.72,
    height: 2.11,
    transform: "translate(834.6 171.93) rotate(120.01)"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 354.19,
    y: 323.4,
    width: 18.72,
    height: 2.11,
    transform: "translate(826.34 171.92) rotate(120.01)"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 350.06,
    y: 321.01,
    width: 18.72,
    height: 2.11,
    transform: "translate(818.07 171.92) rotate(120.01)"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 345.92,
    y: 318.63,
    width: 18.72,
    height: 2.11,
    transform: "translate(809.81 171.92) rotate(120.01)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Earth--inject-175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.44,266a122.87,122.87,0,0,1-23.57,72.57l0,0a123.45,123.45,0,1,1-99.85-196q5.08,0,10.06.41a122.75,122.75,0,0,1,54,17.5A123.41,123.41,0,0,1,373.44,266Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.66,324.26c-1.56,4.14,1,4.32,1.21,6.05s0,5-5,10-13.31,4-15,6.05-4.67,10.9-8.82,13.84-4.84,1.21-10.72,2.42-10.37,8.81-12.1,12.44.35,9.68-3.8,9.86-6.05-8.82-9.85-13.66-5-9.16-6.23-14.87.69-17.63,0-22.3-13.14-13-17.63-18.67-10.72-17.12-10.38-20.92a15.54,15.54,0,0,1,5.19-9.51c2.08-1.56,1.21-2.42,1.56-3.8s2.07-1.73,2.42-3.46-1-6.92-2.77-7.78-2.94,2.07-4,1.56-4.14-4.15-5.35-4.5-.87,2.25-2.6-1-2.59-11.58-4-13-2.43,2.42-5.71,0-4.67-7.09-6-7.78-3.29.17-4.71-2.6,1.25-7.78,0-7.26-3.94,4.5-4.63.69,3.46-16.59,2.77-23.51a27.64,27.64,0,0,1,6.57-20s.69-3.81,1.38-6.23,15.56-12.1,17.29-14.86a13.45,13.45,0,0,0,1.22-4.92,122.88,122.88,0,0,1,73.09-24q5.08,0,10.06.41c.11.16.23.31.34.46,1.5,1.9,3.12,3.11,7.5,4.72s5.41,3.69,4.49,5.42-2.42,2.07-4.15,2.19-3.34-.81-5.18.35-3.69,7.37-6.11,7.72-6.69-5.53-7.61-7.26,2.07-5.42.66-7.15-3.89-1.38-7.81-1.73-13,1.16-12.67,2.65,13.36-.23,13.71,2.77-9.56,8.07-11.29,7.61-4-3.46-6.57-3.81-4.62,1.73-6.21,2-3.47-1.73-5.89-1.27-3,2.54-4.27,3.35-4.26.8-4.61,2.65,3.8,2.88,4.84,4-1.27,5.07-.23,5.88,7.49-4.84,9.11-6.22,3-7.38,6.45-7.27,4.61,6,5.76,6.57,3.69-1.38,7.5-.57,6.45,9.1,7.14,11.64,2.31,5.07.92,6.11-7.61-.69-8.41-2.31,4.15-4,3.8-4.61-3.23-1.38-4.72-.48-2.19,2.79-3.81,3.25-5.88-4.38-7-3,1.15,5.77,2.31,6.8,5.41,1.61,5.76,2.77-2.88,3.68-6.8,3.46-7.14-3.23-8.65-2-.69,4.61-1.72,5.76-6.69.35-9.45,3.34-4,7.49-6.81,10-4-.69-7.72,2.88-4.26,11.53-4.38,14.29,0,5-.92,4.61-2.19-2.76-2.54-4.26.81-4,.81-5-5.3-5.65-8.41-6.11-5.88,2.08-8.18,3.92-6.46,1.5-8,3-2.65,14.75-1.5,17.86,2.66,3.12,6.35,1.5,1.61-4.73,3.8-4a5.14,5.14,0,0,1,3.34,4.84c0,1.84-4.38,6.22-3.8,7.49s4.38-.23,6.22.35,2.77,1.72,2.19,6.45-.23,8.41,2.54,10,4.32-2.25,5.53-1.73,2.94,3.29,4.67,3.11.86-1.73,4.15-2.76,2.07-1.73,2.76-3.81,2.77-3.8,5-2.76.7,2.59.87,4.32,4.15,1.9,7.26,2.94,4.84,0,11.07,2.07,6.56,8.3,9.16,9.34,11.24-.69,17.46,3.8,4.49,12.8,7.61,15.22,14.69,5.7,19.19,6.57,5.18-2.25,8.81-1.39,5.71,1.9,6.92,6.92C291.72,310.86,278.21,320.11,276.66,324.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.76,235.85c.11,1,3,1.39,6.45,3.35s4.73,7.72,6.57,7.6,1.27-2.76,2-3.45,1.85-2.19,0-3.69-3.64-4.73-7-5.19-4-1.84-5.45-1.73A2.61,2.61,0,0,0,183.76,235.85Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.78,245.53c-.52,1.42,0,2.43,3.68,3.35s7.15-.92,6-1.67-2.88-.41-2.19-1.68.45-3.11-2.54-2.76S203.24,244.27,202.78,245.53Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M215.68,245.93c-1.25.18-2,2.37-.69,3.75s1.27,1.16,2.77,0,3.8-1.72,3.23-2.88S217,245.75,215.68,245.93Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M225.71,250.64c.57-1.73,3.46,0,4.73,1.81s.69,4.5,0,6.45-1.15,4.27-2.77,3.35.12-3.69-.11-5.3S225.25,252.05,225.71,250.64Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275.39,154.48c-.61,1.45,2.19,2,3.8,2.88s2.88,1.5,3.8,0-.34-3.22-1.61-3.57S276,153.1,275.39,154.48Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M297.17,168c1.07,1.12,2.88.92,4.15,2.53s.81,4.38,2.42,5.19,2.77,0,2.88-1.15-2.3-4-2.07-4.61,3.34.8,4,2.53-.69,4.15.92,4.61,1.27-1.61,2-2.07,2.19-.23,2.08-1.62a10.4,10.4,0,0,0-3.46-5.41c-1.5-1-2.65-2.19-5.19-2.77s-4.95-.11-6.22.92S296.52,167.28,297.17,168Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M347,189.69a2.08,2.08,0,0,1-.65,1.21c-2.42,1.73-5.31-4.26-8.65-5.41s-4.84-5.42-5.53-4.5-.46,2.19-1.5,3.69-2.53,1.15-3.23,4,3.23,8.19,2.31,9.92-2.07,1.15-3.92,1-1.5,1.5-3.92.81-.34-3.69-4.15-7.26-5.07-4.26-4.26-5.88-.35-3.92,1.38-4.15,3.11,2.31,4.27,3,2.65-1.38,2.76-3.23-4-4.38-5.53-5.81-1.62-6.64-1-7.68,2.31-.69,2.77-3.22c.27-1.49-2.09-4-4.08-5.78A124,124,0,0,1,347,189.69Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M364.25,293c.34-3.69-1.5-3.92.34-10.72s-1.95-14.06-3.34-15.56-4.38-1-6.8.46-.69,2.66-2.3,3.23-3.23-.35-4.73-.23-2.88,3.92-6.11,3.8-5.3-4.72-7.72-8-7.38-5.36-9-9.39,1.5-10.26.81-15-3.8-3.69-4.38-6.34.46-1.38,1.27-3.92-.93-3.92.69-8.3,4.49-6.57,3.8-8.53-2.88-5.18-3-7.48,2.2-2.2,6.57-5.43,5.54-3,8.88-1.84a47.31,47.31,0,0,0,7.37,2.07c2,.35,4.62,5.42,5.42,5.19s.93-1.73,1.27-3.92a5,5,0,0,1,1.44-2.48,123.52,123.52,0,0,1-4.87,137.92C361.62,320.61,363.9,296.71,364.25,293Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M345.63,344.05A123.44,123.44,0,1,1,250,142.55q5.08,0,10.06.41c.92.07,1.84.15,2.75.25a113.11,113.11,0,1,0,82.82,200.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.44,266a122.81,122.81,0,0,1-23.58,72.57v0a124.09,124.09,0,0,1-44.34,37.69,124.87,124.87,0,0,0,38.93-34.88l0,0a124.22,124.22,0,0,0,4.9-138.72,121,121,0,0,0-7.75-11,124.78,124.78,0,0,0-33.16-29.4,123.43,123.43,0,0,0-54.33-17.61c-3.33-.27-6.71-.4-10.11-.4a124.09,124.09,0,0,0-29.81,3.6A123.26,123.26,0,0,1,250,142.55q5.08,0,10.06.41a122.63,122.63,0,0,1,54,17.5,124,124,0,0,1,40.67,40.18A122.88,122.88,0,0,1,373.44,266Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lines--inject-175"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "326.62 169.11 329.55 168.47 329.55 168.49 326.62 169.11",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.43 167.29 341.34 166.25 341.36 166.35 335.44 167.35 335.43 167.29",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.28 165.36 353.24 164.65 353.26 164.85 347.3 165.51 347.28 165.36",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.23 164.16 365.23 163.94 365.23 164.23 359.24 164.41 359.23 164.16",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.24 164.05 377.24 164.61 377.18 164.98 371.22 164.38 371.24 164.05",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.14,165.78a32.16,32.16,0,0,1,5.67,2.09l-.21.42a30.38,30.38,0,0,0-5.57-2.1Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.78,171.33a14.07,14.07,0,0,1,1.91,2.37,12.53,12.53,0,0,1,.75,1.33c.21.47.4.94.59,1.41l-.49.18-.56-1.36a10.74,10.74,0,0,0-.72-1.28,13.49,13.49,0,0,0-1.84-2.29Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.8,182.46a24.06,24.06,0,0,1-1.22,5.93l-.52-.18a23.49,23.49,0,0,0,1.2-5.79Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.2,193.93a57.41,57.41,0,0,1-3.06,5.19l-.48-.32a58.62,58.62,0,0,0,3-5.13Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.64 204.02 383.83 208.67 383.37 208.27 387.17 203.65 387.64 204.02",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.8 213.13 375.6 217.42 375.15 216.96 379.35 212.7 379.8 213.13",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.25 221.56 366.79 225.58 366.35 225.07 370.81 221.08 371.25 221.56",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.23 229.49 357.58 233.29 357.14 232.74 361.79 228.96 362.23 229.49",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.86 237 348.07 240.62 347.64 240.03 352.42 236.43 352.86 237",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.23 244.16 338.33 247.63 337.89 247.01 342.79 243.56 343.23 244.16",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.38 251.03 328.39 254.36 327.95 253.7 332.94 250.39 333.38 251.03",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.36 257.63 318.28 260.83 317.85 260.13 322.92 256.94 323.36 257.63",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.17 263.97 308.02 267.06 307.59 266.33 312.73 263.26 313.17 263.97",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.84 270.09 297.63 273.07 297.19 272.3 302.4 269.34 302.84 270.09",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.38 276 287.12 278.86 286.68 278.06 291.95 275.21 292.38 276",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.82 281.68 276.49 284.45 276.06 283.61 281.38 280.86 281.82 281.68",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.14 287.17 265.76 289.84 265.33 288.96 270.71 286.31 271.14 287.17",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.36 292.46 254.94 295.02 254.51 294.12 259.94 291.56 260.36 292.46",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.48 297.53 244 299.98 243.61 299.1 249.07 296.64 249.48 297.53",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.5 302.39 232.97 304.74 232.61 303.88 238.12 301.52 238.5 302.39",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.43 307.04 221.86 309.28 221.53 308.44 227.08 306.19 227.43 307.04",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.27 311.46 210.65 313.59 210.35 312.78 215.95 310.64 216.27 311.46",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.02 315.66 199.36 317.66 199.08 316.87 204.72 314.85 205.02 315.66",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.67 319.6 187.97 321.47 187.72 320.7 193.41 318.82 193.67 319.6",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.24 323.27 176.49 324.99 176.27 324.24 182.01 322.51 182.24 323.27",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.71 326.63 164.91 328.18 164.72 327.46 170.5 325.89 170.71 326.63",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.08 329.64 153.23 330.99 153.07 330.29 158.91 328.93 159.08 329.64",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.35 332.23 141.45 333.35 141.33 332.67 147.21 331.54 147.35 332.23",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.52 334.32 129.56 335.13 129.48 334.47 135.42 333.65 135.52 334.32",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.58 335.74 117.58 336.12 117.55 335.5 123.53 335.1 123.58 335.74",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.56 336.22 105.54 335.95 105.59 335.36 111.57 335.61 111.56 336.22",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.56,335.2a43.61,43.61,0,0,1-5.86-1.45l.17-.54a42.53,42.53,0,0,0,5.79,1.42Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.18,331.26a16.68,16.68,0,0,1-4.57-4l.43-.32a16,16,0,0,0,4.42,3.86Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.12,321.73a17.14,17.14,0,0,1,0-6.06l.5.08a16.59,16.59,0,0,0,0,5.88Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.76,309.87a44.35,44.35,0,0,1,2.64-5.41l.37.21A44.15,44.15,0,0,0,83.19,310Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.64 299.39 92.27 294.6 92.53 294.81 88.95 299.61 88.64 299.39",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.17 290.04 100.28 285.66 100.45 285.83 96.39 290.23 96.17 290.04",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.55 281.44 108.95 277.36 109.05 277.48 104.68 281.59 104.55 281.44",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.46 273.41 118.06 269.56 118.1 269.61 113.53 273.49 113.46 273.41",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.79 265.78 125.16 263.94 122.81 265.8 122.79 265.78",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.25 254.83 375.77 256.45 375.76 256.47 373.25 254.83",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.77 259.77 385.69 263.21 385.62 263.3 380.73 259.83 380.77 259.77",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.51 266.78 395.23 270.5 395.1 270.65 390.42 266.9 390.51 266.78",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.81 274.38 404.21 278.47 404.01 278.68 399.64 274.57 399.81 274.38",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.38 282.8 412.23 287.44 411.92 287.66 408.13 283.02 408.38 282.8",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.57,292.44a31.38,31.38,0,0,1,2.53,5.49l-.44.14a30.32,30.32,0,0,0-2.45-5.42Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.17,303.89a14.12,14.12,0,0,1-.32,3c-.11.49-.25,1-.41,1.47l-.58,1.41-.47-.22.56-1.36a13.38,13.38,0,0,0,.4-1.41,13.67,13.67,0,0,0,.31-2.92Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.14,314.59a23.91,23.91,0,0,1-5.05,3.34l-.25-.5a22.72,22.72,0,0,0,5-3.24Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.49,320.17c-1.92.6-3.87,1.09-5.84,1.5l-.11-.57a57.55,57.55,0,0,0,5.78-1.47Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.72 322.66 385.73 323.26 385.69 322.65 391.64 322.07 391.72 322.66",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.73 323.56 373.73 323.62 373.73 322.98 379.72 322.93 379.73 323.56",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.72 323.47 361.72 323.16 361.77 322.49 367.75 322.82 367.72 323.47",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.74 322.69 349.76 322.1 349.84 321.4 355.8 322.01 355.74 322.69",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.8 321.38 337.86 320.56 337.96 319.84 343.9 320.68 343.8 321.38",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.93 319.64 326.01 318.63 326.14 317.88 332.05 318.91 331.93 319.64",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.11 317.53 314.22 316.36 314.38 315.58 320.25 316.77 320.11 317.53",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "308.35 315.11 302.5 313.79 302.69 312.98 308.53 314.32 308.35 315.11",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.66 312.39 290.84 310.94 291.05 310.11 296.86 311.58 296.66 312.39",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.03 309.42 279.24 307.84 279.48 306.99 285.26 308.58 285.03 309.42",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.46 306.2 267.71 304.5 267.97 303.63 273.71 305.33 273.46 306.2",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.97 302.75 256.25 300.94 256.54 300.04 262.25 301.86 261.97 302.75",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.54 299.08 244.85 297.16 245.17 296.24 250.84 298.17 250.54 299.08",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.18 295.2 233.53 293.17 233.87 292.24 239.51 294.26 239.18 295.2",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.9 291.09 222.29 288.95 222.64 288.05 228.24 290.17 227.9 291.09",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.7 286.76 211.13 284.51 211.48 283.65 217.05 285.88 216.7 286.76",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.59 282.22 200.06 279.87 200.42 279.04 205.94 281.37 205.59 282.22",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.56 277.46 189.09 274.99 189.45 274.2 194.92 276.64 194.56 277.46",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.64 272.47 178.22 269.88 178.59 269.12 184 271.69 183.64 272.47",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.83 267.23 167.47 264.52 167.84 263.8 173.2 266.49 172.83 267.23",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.15 261.74 156.87 258.89 157.24 258.21 162.53 261.04 162.15 261.74",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.62 255.97 146.42 252.96 146.8 252.31 152 255.3 151.62 255.97",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.27 249.87 136.18 246.69 136.56 246.08 141.66 249.24 141.27 249.87",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.15 243.41 126.18 240.02 126.58 239.46 131.53 242.83 131.15 243.41",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.3 236.52 116.52 232.88 116.93 232.36 121.7 235.98 121.3 236.52",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.86 229.08 107.34 225.11 107.77 224.65 112.27 228.59 111.86 229.08",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.02 220.92 98.95 216.48 99.4 216.09 103.45 220.49 103.02 220.92",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.25,211.71a43,43,0,0,1-3.12-5.17l.51-.25a42.6,42.6,0,0,0,3.09,5.09Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,200.88a16.48,16.48,0,0,1-.39-6.06l.53.07a15.88,15.88,0,0,0,.4,5.86Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.74,189.15A17,17,0,0,1,96,184.84l.29.41a16.87,16.87,0,0,0-4.12,4.18Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.28,181.92A44,44,0,0,1,107,180l.11.41a43,43,0,0,0-5.62,2Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.85 178.67 118.81 177.85 118.84 178.18 112.92 179.05 112.85 178.67",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.79 177.38 130.79 177.19 130.8 177.43 124.81 177.67 124.79 177.38",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.79 177.23 142.79 177.46 142.78 177.61 136.79 177.43 136.79 177.23",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.77 177.85 154.75 178.38 154.74 178.45 148.77 177.96 148.77 177.85",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.77 179.06 163.75 179.43 160.77 179.08 160.77 179.06",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Locators--inject-175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.84,180.85c-.25-2.55-2-5.09-5.1-5.09s-4.86,2.54-5.11,5.09c-.39,4,2.26,7.52,5.11,10.78C213.57,188.37,216.23,184.8,215.84,180.85Zm-5.1,2.71a2.75,2.75,0,1,1,2.74-2.74A2.75,2.75,0,0,1,210.74,183.56Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,264.23c-.26-2.55-2-5.09-5.11-5.09s-4.86,2.54-5.11,5.09c-.39,3.95,2.27,7.52,5.11,10.78C196.71,271.75,199.37,268.18,199,264.23Zm-5.11,2.71a2.75,2.75,0,1,1,2.75-2.74A2.75,2.75,0,0,1,193.87,266.94Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.49,292.25c-.25-2.55-2-5.1-5.1-5.1s-4.86,2.55-5.12,5.1c-.38,3.95,2.27,7.52,5.12,10.78C257.22,299.77,259.88,296.2,259.49,292.25Zm-5.1,2.71a2.75,2.75,0,1,1,2.74-2.75A2.75,2.75,0,0,1,254.39,295Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.56,180.59c-.26-2.55-2-5.1-5.11-5.1s-4.86,2.55-5.11,5.1c-.39,3.95,2.27,7.52,5.11,10.78C328.29,188.11,331,184.54,330.56,180.59Zm-5.11,2.71a2.75,2.75,0,1,1,2.75-2.75A2.75,2.75,0,0,1,325.45,183.3Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.2,249.46c-.25-2.55-2-5.09-5.1-5.09s-4.86,2.54-5.11,5.09c-.39,3.95,2.27,7.52,5.11,10.78C359.93,257,362.6,253.41,362.2,249.46Zm-5.1,2.71a2.75,2.75,0,1,1,2.74-2.75A2.75,2.75,0,0,1,357.1,252.17Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.61,334.77c-.25-2.56-2-5.1-5.1-5.1s-4.86,2.54-5.11,5.1c-.39,3.94,2.27,7.52,5.11,10.78C237.34,342.29,240,338.71,239.61,334.77Zm-5.1,2.7a2.75,2.75,0,1,1,2.74-2.74A2.75,2.75,0,0,1,234.51,337.47Z",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.64,187.73c7.22-3.2,14.69-8.43,13.88-10.84-1.09-3.25-5.87-9.38-9.14-12-1-.79-6.89,6.81-5.87,7.65a71.36,71.36,0,0,1,5.2,5.83c.19.29-5.32,4.78-7.43,7.27C54.8,188.51,57.27,189.23,60.64,187.73Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.44,162.06a16.86,16.86,0,0,1,5.9,4.71c.54,1-4.32,7-5.52,7s-7.55-2.88-8.65-4.67S59.44,161.34,61.44,162.06Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.42,171.48c1.07-.22.2-1.36.2-1.36s1.64,1.34,2.66.69-.12-2-.19-2.06c.08.07,1.63,1.26,2.58.5s-.34-1.94-.42-2c.1,0,1.47.55,2.07-.19,1-1.27-2.46-2.67-2.93-3.9l1.4-1.25s-2.63-1.22-4.26-.5a1.14,1.14,0,0,0-.67,1.26,1.8,1.8,0,0,0-1.78,0c-.4.29-.28,1.19-.28,1.19a1.43,1.43,0,0,0-1.48.13,1.39,1.39,0,0,0-.32,1.27,1.69,1.69,0,0,0-1.37.58C49.84,167.09,53.13,171.94,55.42,171.48Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,165.38s0,0,0,0a10.2,10.2,0,0,0,3.68,4.79c.06,0,.14,0,.09-.09A20.81,20.81,0,0,1,52,165.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.77,163.83s0,0,0,0a9.48,9.48,0,0,0,4.34,5c.07,0,.17,0,.09-.05A17.21,17.21,0,0,1,53.77,163.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.41,167.26a13.18,13.18,0,0,1-4.53-4.53s-.05,0,0,0a8.55,8.55,0,0,0,2,3,5.82,5.82,0,0,0,2.55,1.61S60.46,167.28,60.41,167.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.62,170.12a6.58,6.58,0,0,0,1.07.59,2.24,2.24,0,0,0,1.15.21.73.73,0,0,0,.46-.25,1.1,1.1,0,0,0,.23-.49,1.3,1.3,0,0,0-.34-1l-.57-.69.78.45a3.64,3.64,0,0,0,1.11.42,1.3,1.3,0,0,0,1.05-.18.75.75,0,0,0,.27-.9,2.29,2.29,0,0,0-.69-.9l-.82-.67,1,.37a3.62,3.62,0,0,0,.85.2,1.53,1.53,0,0,0,.81-.12.67.67,0,0,0,.36-.62,1.51,1.51,0,0,0-.37-.75,11.38,11.38,0,0,0-1.32-1.27c-.23-.21-.47-.41-.69-.63a2.23,2.23,0,0,1-.56-.74,2.5,2.5,0,0,0,.62.68c.23.19.48.38.73.57a10.26,10.26,0,0,1,1.42,1.23,1.75,1.75,0,0,1,.47.88,1,1,0,0,1-.49.93,1.78,1.78,0,0,1-1,.18,4,4,0,0,1-1-.21l.17-.31a2.57,2.57,0,0,1,.84,1,1.07,1.07,0,0,1,0,.73,1.23,1.23,0,0,1-.43.59,1.65,1.65,0,0,1-1.34.22,4.08,4.08,0,0,1-1.21-.48l.2-.24a1.52,1.52,0,0,1,.35,1.26,1.33,1.33,0,0,1-.31.6.93.93,0,0,1-.6.29,2.22,2.22,0,0,1-1.22-.31A5,5,0,0,1,55.62,170.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5,174s-8.71.81-7.36-2.75c.41-1.05,3.32-4.91,4.11-4.34,1,.73.1,2.57-.66,3.63,0,0,2.92-.69,4,1.2A2.17,2.17,0,0,1,61.5,174Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.05,171.59a4.63,4.63,0,0,1,.51-1.24,10.24,10.24,0,0,1,.73-1.12,15.93,15.93,0,0,1,1.76-2,2.27,2.27,0,0,1,.58-.42,1,1,0,0,1,.4-.1.61.61,0,0,1,.22,0,.57.57,0,0,1,.19.1,1.12,1.12,0,0,1,.43.65,2.25,2.25,0,0,1,0,.73,4.08,4.08,0,0,1-.46,1.31,8.42,8.42,0,0,1-.72,1.14l-.16-.24a5,5,0,0,1,1-.1,4.87,4.87,0,0,1,1,.09,3.54,3.54,0,0,1,1,.34,2.81,2.81,0,0,1,.78.63,3.16,3.16,0,0,0-.83-.53,3.84,3.84,0,0,0-.94-.25,5.25,5.25,0,0,0-1,0,5,5,0,0,0-.95.15l-.39.1.22-.34a8.43,8.43,0,0,0,.66-1.12,4.14,4.14,0,0,0,.4-1.2,1.1,1.1,0,0,0-.29-1c-.23-.19-.63.08-.94.35s-.63.6-.94.92-.6.64-.88,1A8.69,8.69,0,0,0,54.05,171.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.93,259.08c-.16.29-2.65,5.56-3.27,5.79-6.37,2.32-20.18,3-20.78,2.85-.38-.1-1.74-6.87-1.76-6.91-.27-.77-3.65-14.41-3.65-14.41l14.15-4.25,3.3,14,.07.24a37.35,37.35,0,0,0,6.38,1.73c.44.07,2.95-.72,3.32-.66C136.92,257.66,138.14,258.68,137.93,259.08Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.93,259.08c-.16.29-2.64,5.56-3.28,5.79-6.36,2.32-20.17,3-20.77,2.85-.38-.09-1.74-6.87-1.76-6.91s-.32-1.16-.67-2.52l14-4.11.47,2,.07.23a37.35,37.35,0,0,0,6.38,1.73c.44.07,2.95-.72,3.32-.66C136.92,257.66,138.14,258.68,137.93,259.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.11,258.92c0,.23-2.94,5.9-3.48,6.09-5.12,1.85-20.35,3.22-21,3-.36-.14-1.3-3.88-1.73-7.7l14.19-3.92a44.46,44.46,0,0,0,6.35,1.75c.54.08,2.88-.75,3.29-.73A3.23,3.23,0,0,1,138.11,258.92Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.11,258.92c0,.23-2.94,5.9-3.48,6.09-5.12,1.85-20.35,3.22-21,3-.36-.14-1.3-3.88-1.73-7.7l14.19-3.92a44.46,44.46,0,0,0,6.35,1.75c.54.08,2.88-.75,3.29-.73A3.23,3.23,0,0,1,138.11,258.92Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.93,257.77a3.91,3.91,0,0,0-1.85,2.33,3.35,3.35,0,0,0,.29,2.53s.06,0,0,0a4.19,4.19,0,0,1,1.54-4.78S135,257.75,134.93,257.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.25,262.58a1.32,1.32,0,0,0,.51,2.58A1.32,1.32,0,0,0,115.25,262.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.38,252.47c-.86-.51-1.71.26-2.07,1a8,8,0,0,0-.76,3.16,3.53,3.53,0,0,0,0,.46v.19s0,0,0,0v.05a.76.76,0,0,1,0,.15,0,0,0,0,0,.06,0,.19.19,0,0,0,.17.12.12.12,0,0,0,.11,0l.81-.75a.81.81,0,0,0,.14-.12,8.14,8.14,0,0,0,1.75-2C129,254,129.18,252.94,128.38,252.47Zm-1.32,3.45c-.21.22-.44.44-.66.65l-.55.56-.08.08-.06.07v-.09h0c0-.21.08-.41.11-.61a15.3,15.3,0,0,1,.36-1.63,7,7,0,0,1,.38-1.09c.24-.54,1.5-2,1.91-.43C128.7,254.3,127.6,255.38,127.06,255.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.88,257.33s0,0,0-.06a.3.3,0,0,0-.11-.06s0,0,0,0h0a.82.82,0,0,0-.17-.11,6.24,6.24,0,0,0-.68-.35A7.9,7.9,0,0,0,122,256c-.81,0-1.88.37-1.84,1.35,0,0,0,.07,0,.11.11.85,1.08,1.15,1.82,1.14a7.65,7.65,0,0,0,2.3-.46l1.53-.54h0A.18.18,0,0,0,125.88,257.33Zm-2.07.52c-.73.22-2.21.68-2.88.07a1.2,1.2,0,0,1-.36-.51c-.24-.73,1.15-1,1.64-1a8.86,8.86,0,0,1,1.15.17c.28.06.56.14.84.22.46.13.9.29,1.35.43h0l.09,0-.09,0-.21.05C124.83,257.52,124.33,257.69,123.81,257.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.84,256.63A5.24,5.24,0,0,0,124,259c0,.05,0,.09.09.06a20.78,20.78,0,0,1,3.83-2.27A.1.1,0,0,0,127.84,256.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.06,256.89a5.24,5.24,0,0,0-3.86,2.39c0,.05,0,.09.09.06a20.78,20.78,0,0,1,3.83-2.27A.1.1,0,0,0,129.06,256.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.28,257.15a5.24,5.24,0,0,0-3.86,2.39s0,.09.09.06a21.11,21.11,0,0,1,3.83-2.27C130.44,257.29,130.39,257.14,130.28,257.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5,257.41a5.24,5.24,0,0,0-3.85,2.39.05.05,0,0,0,.08.07,20.6,20.6,0,0,1,3.83-2.28C131.66,257.55,131.61,257.4,131.5,257.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.36,258.46c-1,1.44-1.84,3.05-2.82,4.52l-.35.52c-.13.19-.23.39-.45.46a10.52,10.52,0,0,1-1.27.22l-2.57.42c-3.44.56-6.89,1.06-10.34,1.54l-2.93.41c-1,.14-1.94.34-2.92.48,0,0,0,.06,0,.05.89-.08,1.78-.1,2.68-.2s1.78-.19,2.67-.31q2.64-.33,5.28-.72t5.28-.82l2.65-.44,1.29-.22a1.1,1.1,0,0,0,.8-.5c1.13-1.7,2.07-3.56,3.12-5.32C137.53,258.47,137.41,258.39,137.36,258.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.65,190.85S85,193.3,86.49,196.16c0,0,21.72,15.76,26.48,19.53,5.23,4.15,11.37,33.68,11.37,33.68l-14.13,4s-2.59-7.13-4.68-14.18c-1.52-5.09-1.79-10.52-2-10.64-3.06-1.58-20.68-16.06-21.3-16.06-7.07,0-13.14-6.36-13.14-6.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.49,196.16s9.05,6.59,15.67,11.44l-19.94,4.9h0c-7.05,0-13.1-6.36-13.1-6.36l5.77-15.85S85,193.3,86.49,196.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.45,175.94c.31.78,1.36,23.31.85,24.19-.08.15-3.67.08-7.88.24-5.23.19-11.31.6-11.31.6l.21-13.65,10.93-1s3.36-8.57,4-9.48S163.16,175.17,163.45,175.94Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.7,200.44l1.72-.07c4.21-.16,7.8-.09,7.88-.24a4.18,4.18,0,0,0,.12-1.15c0-.12,0-.26,0-.4v-.29h0c0-.1,0-.2,0-.31h0v-.69c0-.37,0-.77,0-1.19v-.36c0-1.24-.06-2.66-.11-4.16,0-.14,0-.27,0-.41,0-.39,0-.78,0-1.18s0-.71,0-1.07c-.23-6.13-.6-12.56-.76-13s-1.31-.32-2.21.16l-.29.17a2.89,2.89,0,0,0-.5.39l-.13.14,0,.07a11.52,11.52,0,0,0-.76,1.53l-.08.18-.15.34-.32.75c-.06.13-.11.26-.17.4l-.17.41c-.06.13-.12.27-.17.41-.35.85-.71,1.71-1,2.51-.06.13-.11.26-.16.38s-.05.13-.08.19-.14.37-.21.54a1.22,1.22,0,0,0-.07.17c0,.11-.08.21-.13.32s-.08.2-.11.29l-.31.77-.11.29-2.1-.28v.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.44,175.84c.3.78,1.53,23.48,1,24.36-.19.33-3.82.28-7.66.15l-.65-14.18s3.45-8.49,4.1-9.39S163.14,175.07,163.44,175.84Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.55,176.21c.09,3.76.78,18.94,1.15,22.65,0,0,0,0,0,0,0-3.73-.82-18.9-1.11-22.65C162.61,176.13,162.55,176.13,162.55,176.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.52,178.26a3,3,0,0,0,1,2.2,2.92,2.92,0,0,0,2,.75s0,0,0-.05a3.49,3.49,0,0,1-3-2.91S159.52,178.23,159.52,178.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.48,185a5.24,5.24,0,0,0,1.94,4.1c.05,0,.09,0,.07-.08a20.86,20.86,0,0,1-1.83-4.06A.09.09,0,0,0,156.48,185Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.88,183.79a5.27,5.27,0,0,0,1.93,4.11c.05,0,.1,0,.08-.08a20.86,20.86,0,0,1-1.83-4.06A.09.09,0,0,0,156.88,183.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.28,182.61a5.23,5.23,0,0,0,1.93,4.1s.1,0,.08-.08a20.6,20.6,0,0,1-1.83-4.06A.09.09,0,0,0,157.28,182.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.67,181.43a5.27,5.27,0,0,0,1.94,4.1s.1,0,.07-.08a20.82,20.82,0,0,1-1.82-4.06A.1.1,0,0,0,157.67,181.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.09,198.07a1.31,1.31,0,0,0,2.62-.13A1.31,1.31,0,0,0,160.09,198.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.39,183.54c-.6.79.06,1.72.74,2.16a7.87,7.87,0,0,0,3.06,1.11,3.47,3.47,0,0,0,.45.06h.4a0,0,0,0,0,0-.06.18.18,0,0,0,.14-.15.14.14,0,0,0,0-.12l-.65-.89-.11-.15a8.38,8.38,0,0,0-1.83-2C154,183.11,153,182.79,152.39,183.54Zm3.28,1.69.57.73.5.62.07.08.06.08-.09,0h0l-.6-.18a14.54,14.54,0,0,1-1.57-.54,7.66,7.66,0,0,1-1-.5c-.51-.3-1.84-1.72-.21-2C154.25,183.42,155.19,184.64,155.67,185.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.94,186.57a0,0,0,0,0-.06,0,.46.46,0,0,0-.07.1s0,0,0,0,0,0,0,0a.65.65,0,0,0-.13.16,4.31,4.31,0,0,0-.42.63,7.79,7.79,0,0,0-1,2.79c-.12.8.15,1.91,1.13,2h.11c.86,0,1.26-.93,1.34-1.67a7.64,7.64,0,0,0-.2-2.33c-.12-.54-.25-1.07-.36-1.59h0A.18.18,0,0,0,156.94,186.57Zm.28,2.11c.13.76.43,2.27-.26,2.87a1.22,1.22,0,0,1-.54.31c-.76.15-.87-1.26-.78-1.75a7.41,7.41,0,0,1,.3-1.12c.09-.27.2-.54.31-.81.19-.44.39-.86.58-1.3h0l0-.08a.24.24,0,0,0,0,.08l0,.22C157,187.63,157.12,188.15,157.22,188.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.16,187l.28,13.73a123,123,0,0,1-19.63.89c-6.65-.28-14-.67-14.48-.57-1.63.31-25.76,8-32.24,10.65-8.52,3.54-14.14-5.2-14.14-5.2l5.9-16.19,5.88,2c2.52-.53,26.89-6.75,32.24-6.63C122.32,185.92,149.16,187,149.16,187Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.85,205.52l5.35-1.72-4.33-5.88-5.65,1.3Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.1,203.2l1.27-.4-4.16-5.65-1.34.3Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.73,194.69a5.48,5.48,0,0,1,4-2.36,5.47,5.47,0,0,1-4,2.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.47,188.87l2.38,1.42-5.77,15.85S57,198.93,55.26,191.73c-.87-3.61.94-5.95,3.57-6.45.66-.13,7.6-1.36,10.31-.26A6.75,6.75,0,0,1,72.47,188.87Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.14,185a6.73,6.73,0,0,1,3.32,3.82,0,0,0,0,0,0,0h0L65.8,203.94c-1.13-.82-2.44-1.82-3.75-3a30.61,30.61,0,0,0,1.47-4.67c.12-.72-1.59-3-.66-4.88s3.54-3.06,3.54-3.06a6.6,6.6,0,0,1-.66-3.8A9.7,9.7,0,0,1,69.14,185Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.83,185.28a3.81,3.81,0,0,0-.51.12c1.49,0,4.73.23,4.61,1.45s-6,2.67-7.89,3.06a7.06,7.06,0,0,0,.22,1.82c1.27,5.24,7.52,10.6,10.84,13.13l7.32-15.47-1-.52S71.53,186,69.14,185C66.43,183.92,59.49,185.15,58.83,185.28ZM63,193.63c1.48,1.47,2.17,3.84,1.55,5-.5,1-2.06.94-3.67-.11-2.75-1.79-6.1-6.36-5.5-7.67C56,189.37,60.52,191.19,63,193.63Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.45,193.21a15.53,15.53,0,0,1,1.6-2.3c.3-.36.63-.69,1-1,.17-.16.33-.33.49-.51a2.43,2.43,0,0,0,.43-.58s0,0,0,0a3.46,3.46,0,0,1-.28.62,3.43,3.43,0,0,1-.4.54c-.3.36-.63.71-.94,1.07-.63.73-1.25,1.46-1.81,2.23C68.5,193.3,68.43,193.25,68.45,193.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.44,195.7a16.31,16.31,0,0,1,.8-2.15c.16-.35.34-.69.53-1,.09-.16.19-.32.29-.47s.24-.33.35-.5,0,0,0,0c-.09.17-.15.35-.23.53l-.24.51c-.17.35-.33.7-.49,1-.34.69-.66,1.38-1,2.09C68.5,195.77,68.43,195.74,68.44,195.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.66,188.8c.38.07,3.29-.59,3.89-2.17.2-.51-2.57-1.71-2.57-1.71l-.18-.13-2.57-1.89-3.62,2.41-.5.36,1.66,1,.14.09.15.09.41.27.33.19.34.2A20.67,20.67,0,0,0,55.66,188.8Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.77,186.71a6.43,6.43,0,0,0,5-1.92l-2.57-1.89-3.62,2.41-.5.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.24,176.54c5.42,1.39,5.2,4.8,4.9,6s-1.35,4.64-6.89,3.81-6.6-3.79-6.11-6.25S45.81,175.14,51.24,176.54Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.14,177.18a2.79,2.79,0,0,1-.18.34.7.7,0,0,1-.24.32.2.2,0,0,1-.24-.07.5.5,0,0,1,0-.5.7.7,0,0,1,.37-.37A.21.21,0,0,1,50.14,177.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.13,180.71c0-.13,0-.25,0-.38a.61.61,0,0,0,0-.4.18.18,0,0,0-.23-.07.48.48,0,0,0-.25.43.66.66,0,0,0,.11.51A.21.21,0,0,0,49.13,180.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.45,180.3s0,0,0,0c.37.08.79.24.82.6,0,0,0,0,0,0C51.37,180.52,50.82,180.32,50.45,180.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,180.53c-.19.59,1,.94,1.17.39S50.15,180.05,50,180.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,180.79a.86.86,0,0,1,.1.38c0,.15-.18.22-.33.28s0,0,0,0a.45.45,0,0,0,.59-.19.46.46,0,0,0-.27-.55S50,180.74,50,180.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,178.27l0,0c.36.13.8.2,1-.09,0,0,0,0,0,0C51.87,178.56,51.29,178.45,51,178.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.69,177.83c.13-.6,1.32-.29,1.2.27S50.58,178.34,50.69,177.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.83,177.6c.09-.07.23-.14.26-.25s-.06-.26-.16-.37,0,0,0,0c.23.06.45.19.43.42s-.24.31-.48.3C50.85,177.68,50.8,177.63,50.83,177.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.26,181.27c.12-.06.27-.1.33-.22a1,1,0,0,0,.06-.42h0a.53.53,0,0,1,0,.53.41.41,0,0,1-.43.16S53.24,181.27,53.26,181.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.45,179.32a7.15,7.15,0,0,1,.82.19s0,.07,0,.16h0a1.28,1.28,0,0,1-.84,1,0,0,0,0,1,0-.05,2,2,0,0,0,.68-1c-.07,0-1-.15-1-.19a2.45,2.45,0,0,1,.33-.54c-1.18-.25-2.38-.31-3.54-.57,0,0,0-.08,0-.08a20.46,20.46,0,0,1,3.84.46C52.89,178.77,52.53,179.23,52.45,179.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.11,179.91a1.29,1.29,0,0,1,.2.62.55.55,0,0,1-.09.34c-.15.22-.37.14-.54,0a1.31,1.31,0,0,1-.26-.21A1.62,1.62,0,0,0,53.11,179.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.31,180.53a.55.55,0,0,1-.09.34c-.15.22-.37.14-.54,0A.59.59,0,0,1,53.31,180.53Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.75,186.16c-.42.12-2.73,1.11-3.63.87-.52-.14-1.58-1.5-1.58-1.5l-.74.52.42-.58-2,.35,1.5-.78s-1.21-.7-1.48-.93a20,20,0,0,1-1.16-3l.86,1a37.8,37.8,0,0,1,.12-4.87c.56-1.16,3.46-3,3.46-3l-1.51,2.64a22.64,22.64,0,0,1,2.85-2.63c.7-.36,3.26.24,3.26.24l-2.59,1.83,1.72-.36s-.5,2.28-.76,2.9a23.75,23.75,0,0,1-2.82,3.94,13.92,13.92,0,0,1,1.54.56,11,11,0,0,1,1.68,1.45l-1.18-.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.88,185.37s-2.08.48-2,1.38,2.8,1,3.47.27a1,1,0,0,0,0-1.37Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.68,186.76s0,0,0,0a2.35,2.35,0,0,1,1.86-.58.52.52,0,0,0-.43.67s0,0,0,0a.56.56,0,0,1,.43-.51,3,3,0,0,1,.59-.09c.07,0,.08-.12,0-.12h0A2.1,2.1,0,0,0,48.68,186.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.58,193C53.29,201.18,56,209.94,58,211.29c3,1.93,13.78-.12,17.87-.54,1.27-.14-2.82-9.43-4.18-9.28s-9,2.17-9.18,2.11c-.33-.13-3.32-8.79-4.06-11C57.82,190.62,55.28,188.58,54.58,193Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.18,196.56a1.51,1.51,0,0,1,.3,1.71,2.26,2.26,0,0,1,1.32.8c.55.75-.39,1.94-.39,1.94a2.82,2.82,0,0,1,1.26,1.06c.46.77-.32,2.11-.32,2.11a2.47,2.47,0,0,1,.52,1.63c-.14,1.57-2.28,2.65-3.63,3.36s-5.85,1.43-6.69,1.66L71,202.18s5.17-4.88,6.88-5.49C79.27,196.19,82.31,195.74,83.18,196.56Z",
    style: {
      fill: "#c95f50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.35,198.16a20.09,20.09,0,0,0-4.73,1.4s0,.06,0,.05c1.53-.58,3.17-.85,4.73-1.37C83.41,198.23,83.39,198.16,83.35,198.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.33,200.91a4.6,4.6,0,0,0-1.08.37l-1.1.49c-.74.34-1.46.7-2.18,1.07,0,0,0,.07,0,0,.73-.33,1.47-.66,2.21-1l1.13-.45a6,6,0,0,0,1-.46A.06.06,0,0,0,84.33,200.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.32,204.2a3.1,3.1,0,0,0-.95.38l-1,.48c-.67.31-1.33.63-2,.92,0,0,0,.07,0,.05.69-.29,1.38-.57,2.07-.87l1-.45a2.6,2.6,0,0,0,.88-.48S85.34,204.2,85.32,204.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,202.15l-1.33.37a11.14,11.14,0,0,0-1.36.51s0,0,0,0c.44-.11.9-.18,1.34-.31s.91-.25,1.37-.36c.9-.22,1.79-.49,2.69-.71,0,0,0,0,0,0A27,27,0,0,0,68,202.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.64,195.26l.06.43c-.25-.66-.51-1.3-.81-1.94,0,0,0,0,0,0,.22.77.46,1.52.73,2.27.12.35.24.71.38,1.06s.33.78.46,1.18c0,0,.09,0,.07,0-.13-.38-.22-.77-.33-1.16s-.22-.67-.34-1c0-.11,0-.21,0-.32a4.71,4.71,0,0,0-.09-.52c-.07-.34-.16-.68-.24-1h0C59.55,194.57,59.6,194.91,59.64,195.26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.29,366.49c.23.23,4.56,4.12,4.6,4.79.41,6.77-2.91,20.2-3.23,20.72-.19.34-7.07-.3-7.12-.3-.81.05-14.85-.63-14.85-.63V376.3l14.38.86h.25a37.66,37.66,0,0,0,3.48-5.62c.2-.4.16-3,.32-3.37C205.64,367.05,207,366.17,207.29,366.49Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.28,366.49c.24.23,4.57,4.12,4.61,4.79.41,6.77-2.91,20.2-3.23,20.72-.19.34-7.07-.3-7.11-.29l-2.62-.08L199,377l2.05.12h.25a37.66,37.66,0,0,0,3.48-5.62c.19-.4.16-3,.32-3.37C205.64,367.05,207,366.17,207.28,366.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.19,366.27c.22,0,4.81,4.51,4.84,5.08.3,5.43-2.76,20.42-3.21,21-.23.31-4.09.13-7.87-.54l.31-14.72a44.7,44.7,0,0,0,3.5-5.58c.23-.5.11-3,.25-3.37A3.22,3.22,0,0,1,207.19,366.27Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.19,366.27c.22,0,4.81,4.51,4.84,5.08.3,5.43-2.76,20.42-3.21,21-.23.31-4.09.13-7.87-.54l.31-14.72a44.7,44.7,0,0,0,3.5-5.58c.23-.5.11-3,.25-3.37A3.22,3.22,0,0,1,207.19,366.27Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.17,369a3.85,3.85,0,0,0,1.71,2.43,3.26,3.26,0,0,0,2.5.45s0-.06,0-.06a4.18,4.18,0,0,1-4.14-2.84S205.17,369,205.17,369Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.21,373.74c-.73.68-.24,1.71.35,2.26a8,8,0,0,0,2.82,1.64,3.52,3.52,0,0,0,.43.13l.19.05h.05l.15,0a0,0,0,0,0,.05,0,.18.18,0,0,0,.16-.13.13.13,0,0,0,0-.12l-.49-1a1.3,1.3,0,0,0-.08-.17,7.77,7.77,0,0,0-1.46-2.26C199.84,373.6,198.9,373.11,198.21,373.74Zm2.93,2.25.44.82c.12.23.25.46.38.69a.26.26,0,0,0,0,.09l.05.09-.09,0h0l-.55-.28a13.88,13.88,0,0,1-1.46-.81,8.86,8.86,0,0,1-.93-.68c-.45-.39-1.51-2,.14-1.95C200.06,374,200.78,375.32,201.14,376Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.16,377.53a0,0,0,0,0-.06,0l-.09.08,0,0h0a.93.93,0,0,0-.15.13,5.38,5.38,0,0,0-.52.55,7.94,7.94,0,0,0-1.51,2.57c-.25.76-.19,1.9.77,2.15l.11,0c.85.14,1.4-.7,1.61-1.42a7.54,7.54,0,0,0,.22-2.33c0-.54-.06-1.09-.08-1.62h0A.18.18,0,0,0,202.16,377.53Zm-.1,2.13c0,.77,0,2.31-.76,2.78a1.21,1.21,0,0,1-.59.2c-.77,0-.64-1.39-.46-1.86a10.9,10.9,0,0,1,.49-1,7,7,0,0,1,.46-.74c.25-.4.53-.79.8-1.18h0l.05-.08v.09c0,.07,0,.14,0,.22C202,378.59,202.06,379.12,202.06,379.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.05,375.45a5.23,5.23,0,0,0,1.18,4.38s.1,0,.08-.07a20.62,20.62,0,0,1-1.08-4.31A.09.09,0,0,0,202.05,375.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.65,374.35a5.25,5.25,0,0,0,1.18,4.39s.1,0,.08-.07a21.86,21.86,0,0,1-1.08-4.32A.09.09,0,0,0,202.65,374.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.25,373.26a5.23,5.23,0,0,0,1.18,4.38s.1,0,.09-.07a20.62,20.62,0,0,1-1.08-4.31A.1.1,0,0,0,203.25,373.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.85,372.17a5.23,5.23,0,0,0,1.18,4.38s.1,0,.09-.07a20.55,20.55,0,0,1-1.08-4.32A.1.1,0,0,0,203.85,372.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.53,366.85c1.09,1.41,2.39,2.64,3.52,4l.4.48c.14.17.31.32.31.56a11.16,11.16,0,0,1-.15,1.28l-.33,2.58c-.46,3.46-1,6.9-1.5,10.35-.15,1-.29,1.95-.44,2.92s-.24,2-.38,2.94c0,0,0,0,0,0,.18-.88.41-1.74.58-2.63s.32-1.76.47-2.64q.44-2.64.82-5.28t.73-5.28c.12-.89.23-1.78.34-2.67l.15-1.3a1.08,1.08,0,0,0-.24-.91c-1.31-1.57-2.83-3-4.21-4.51A.08.08,0,0,0,206.53,366.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.32,406.9s6.41-7.79,9.59-8.41c0,0,21.32-16.29,26.3-19.77,5.47-3.81,40.74-2.17,40.74-2.17l-.39,15.82s-30.86.43-31,.61c-2.39,2.48-21,13.69-21.19,14.28-2,6.77-9.87,10.76-9.87,10.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.91,398.49s8.9-6.78,15.45-11.73l-1,20.5a.06.06,0,0,0,0,0c-2.06,6.75-9.86,10.72-9.86,10.72l-14.63-11.47S129.73,399.11,132.91,398.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.8,391.76c-.05-.94,0-1.88,0-2.82s0-1.87,0-2.81c0-1.88.09-3.75.17-5.63,0-.51,0-1,.07-1.54s.14-1.09.16-1.64a0,0,0,0,1,.07,0c0,.46.06.92.07,1.38s0,1,0,1.43c0,.94,0,1.88-.05,2.82,0,1.87-.09,3.75-.19,5.62-.06,1.06-.08,2.13-.2,3.18A.05.05,0,0,1,195.8,391.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6,319c.83-.07,22.72,5.39,23.42,6.12.12.13-1,3.54-2,7.62-1.31,5.07-2.67,11-2.67,11l-13-4.12,2.2-10.75s-7.24-5.67-7.93-6.56S134.78,319,135.6,319Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.56,334.37c.14-.56.29-1.12.43-1.67,1.06-4.08,2.15-7.49,2-7.62a4.39,4.39,0,0,0-1.06-.44l-.39-.12-.28-.09h0l-.3-.1h0l-.66-.19-1.14-.33-.35-.1c-1.19-.34-2.56-.71-4-1.09l-.39-.11q-.57-.13-1.14-.3l-1-.26c-5.93-1.53-12.2-3-12.63-3s-.69,1.17-.49,2.16a3.18,3.18,0,0,0,.08.33,2.69,2.69,0,0,0,.24.6,1.19,1.19,0,0,0,.09.15.35.35,0,0,1,.05.08,11.73,11.73,0,0,0,1.25,1.16l.15.13.28.24.63.52.33.28.35.28.34.29,2.11,1.69.32.26.16.13.46.36.14.11.27.22.24.19.66.51.24.2-.87,1.93.45.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.51,319c.82-.07,22.92,5.26,23.62,6,.27.28-.82,3.74-2,7.38l-13.78-3.44s-7.14-5.74-7.82-6.63S134.68,319,135.51,319Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.51,319c.82-.07,22.92,5.26,23.62,6,.27.28-.82,3.74-2,7.38l-13.78-3.44s-7.14-5.74-7.82-6.63S134.68,319,135.51,319Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6,319.9c3.63,1,18.37,4.68,22,5.39,0,0,0,0,0,0-3.57-1.07-18.34-4.64-22-5.43C135.54,319.82,135.53,319.88,135.6,319.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.7,323.39a3,3,0,0,0,2.4-.35,2.94,2.94,0,0,0,1.31-1.75s0,0,0,0a3.49,3.49,0,0,1-3.65,2.06A0,0,0,0,0,136.7,323.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.26,328.23a5.23,5.23,0,0,0,4.49-.68s0-.1-.06-.09a21.08,21.08,0,0,1-4.41.59A.09.09,0,0,0,142.26,328.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.24,327.51a5.27,5.27,0,0,0,4.49-.68s0-.1-.06-.09a20.43,20.43,0,0,1-4.41.58A.1.1,0,0,0,141.24,327.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.22,326.79a5.27,5.27,0,0,0,4.49-.68s0-.1-.06-.09a20.43,20.43,0,0,1-4.41.58A.1.1,0,0,0,140.22,326.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.2,326.07a5.27,5.27,0,0,0,4.49-.68c.05,0,0-.1-.06-.09a21.07,21.07,0,0,1-4.41.58A.1.1,0,0,0,139.2,326.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.71,331.74c.59.8,1.67.43,2.28-.09a8.09,8.09,0,0,0,1.95-2.61,3.79,3.79,0,0,0,.18-.42l.07-.18h0v0a1.31,1.31,0,0,0,.05-.15s0-.05,0-.05a.17.17,0,0,0-.11-.18.16.16,0,0,0-.12,0c-.33.13-.68.25-1,.37l-.18.06a8,8,0,0,0-2.41,1.2C139.75,330.11,139.15,331,139.71,331.74Zm2.56-2.66.87-.34c.24-.1.49-.19.73-.3l.1,0,.09,0-.05.08h0c-.11.18-.23.34-.34.52a14,14,0,0,1-1,1.36,8.82,8.82,0,0,1-.77.85c-.44.4-2.18,1.27-1.93-.36C140.13,329.92,141.57,329.37,142.27,329.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.92,328.24a0,0,0,0,0,0,.07l.07.09s0,0,0,0h0a1.25,1.25,0,0,0,.12.17,4.55,4.55,0,0,0,.49.58A7.66,7.66,0,0,0,147,331c.73.35,1.87.41,2.22-.52l0-.1c.24-.82-.53-1.47-1.22-1.76a7.73,7.73,0,0,0-2.29-.48c-.55,0-1.1-.06-1.63-.11h0C144,328,143.89,328.13,143.92,328.24Zm2.1.35c.76.08,2.3.24,2.68,1.06a1.37,1.37,0,0,1,.14.61c-.07.77-1.46.48-1.9.25a7.74,7.74,0,0,1-1-.61c-.23-.17-.46-.34-.68-.53-.37-.3-.72-.62-1.08-.93h0l-.07-.05h.08l.22,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.52,329.47l16.8,4.2S147.23,371.54,147.18,372c-.17,1.65-1.1,27.18-.38,34.15.95,9.18-9,12.06-9,12.06l-14.92-11.7,4.75-3.64c.21-2.57,1.24-27.7,2.89-32.79C133.37,361.22,142.52,329.47,142.52,329.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.87,337.38c-.93-.16-1.84-.4-2.75-.62s-1.83-.44-2.74-.68c-1.81-.47-3.62-.95-5.43-1.46l-1.48-.42c-.53-.16-1-.38-1.56-.54,0,0,0-.07,0-.06.45.11.91.15,1.36.25s.93.22,1.4.33l2.72.7c1.82.47,3.63.95,5.43,1.48,1,.3,2,.57,3,.93A0,0,0,1,1,156.87,337.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.7,407.42a5.5,5.5,0,0,1-1.11-4.51,5.5,5.5,0,0,1,1.11,4.51Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.44,424.88c1.23-3.55,3.94-15.79,2.65-17.78s-9.11-8.34-10.32-9.42c-.92-.83-6.55,7.43-5.39,8.07s7.62,5.23,8.16,6.06-.05,11.93.63,15.24C114.33,432.76,116.78,426.8,117.44,424.88Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.31,398.19a52,52,0,0,0-5.84-4.88c-1.18-.64-4.69-2.22-5.27-1.37s.42,1.39.42,1.39-1.59-.43-2.1.48,1.07,1.71,1.07,1.71-1.66-.33-2.1.61,1.27,1.48,1.27,1.48-1.5-.37-1.54.56c0,1.12,2.82,1.48,4.06,2.28.28.18,5.46,4.09,5.46,4.09Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.62,397.56a7.46,7.46,0,0,1,4.57,2.09s.08,0,0,0c-1.45-1.45-2.46-2.21-4.61-2.15C97.52,397.46,97.52,397.55,97.62,397.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.42,395.5a11.09,11.09,0,0,1,4.89,2.26s.06,0,0,0c-1.65-1.4-2.67-2.14-4.89-2.33C98.36,395.38,98.32,395.48,98.42,395.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.71,393.4A10,10,0,0,1,104.4,396s.09,0,0-.05a7.12,7.12,0,0,0-4.72-2.6C99.6,393.32,99.58,393.36,99.71,393.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,406.44a21.18,21.18,0,0,1-3.86-1.05c-1.07-.54-4.31-4-3.6-4.74.91-1,3.18.67,4.18,1.61,0,0,2.11-2.22,4-1.4S105.9,406.44,105.9,406.44Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.78,400.47c1.46-.27,2.7,1,3.74,1.89.08.07.16,0,.2-.05,1-.87,2.53-1.82,3.86-1.53a0,0,0,1,0,0-.06c-1.38-.51-3,.3-4,1.33-1.06-.88-2.36-2.16-3.84-1.59C98.76,400.46,98.77,400.47,98.78,400.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.87,407.07l6.33-8s7.31,5.58,8.47,8.1-1.92,15-3.65,19.42-3.79,3.67-4.38-1-.29-13.17-.67-13.64S105.87,407.07,105.87,407.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.07,404.7c-.5.64-2.51,3.18-3.06,3.77,0,0,0,0,0,0,.42-.67,2.33-3.23,2.83-3.87a44.37,44.37,0,0,1,3.1-3.75s.06,0,0,0C113.09,402.21,112.06,403.44,111.07,404.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,426.56c1.72-4.38,4.8-16.91,3.64-19.42-.55-1.21-2.52-3.12-4.42-4.78l-2.36,26.79C114.79,430,116,429.23,117,426.56Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.22,401l18.1,14.45S129.38,428.6,118.19,431c-1.35.29-4-.84-4.24-4C113.56,422.79,126.13,401,126.22,401Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.63,431.09s4.17-6.55,8.13-11.53c10.73-13.49,23.88-27.5,33.67-32.49l7.93,19.83a99.5,99.5,0,0,0-18.9,8.35c-5.81,3.24-11.69,7.61-16.07,10.26C118.84,433.11,116.63,431.09,116.63,431.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.27,406.8c1.93-1.41,4-3.15,4.07-3.85.15-1.32-1.47-3.26-2-3.88s-2.24-2.85-3.8-2.47a26.05,26.05,0,0,0-4.3,2.87c-.37.3-2.17,1.83-2.35,2,0,0,.06.17.1.15.24-.14,1-.75,1.15-.86a26.13,26.13,0,0,1,5.3,7.07c-.34.27-.62.48-1,.76a24,24,0,0,0-2.34-3.65c-1-1.24-2.63-3-3.18-3.52,0,0-.15.11-.12.15.38.46,1.81,2,3.08,3.59a35.76,35.76,0,0,1,2.46,3.7C150.47,408.92,152.34,407.47,153.27,406.8Zm3.68-3.9c-.14.75-1.42,1.82-2.21,2.43l-3,2.34a23.24,23.24,0,0,0-5.35-7c.05,0,2.32-1.83,3.06-2.38a5.54,5.54,0,0,1,2.58-1.33c.65,0,1.74.52,3.29,2.49C156.4,400.86,157.08,402.27,157,402.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.66,426.76s6.13-11.46,7.16-13.28,6.43-9.81,6.86-11.45c.15-.55,1.93-25.18,1.93-25.18a138.59,138.59,0,0,1-5.08,23.43c-3.47,10.63-9.2,20.41-9.68,21.61C113.12,426.15,113.66,426.76,113.66,426.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.33,
    y: 406.5,
    width: 17.52,
    height: 13.46,
    transform: "translate(-174.47 107.41) rotate(-27.28)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.33,
    y: 406.5,
    width: 17.52,
    height: 13.46,
    transform: "translate(-174.47 107.41) rotate(-27.28)",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.07,
    y: 405.98,
    width: 17.52,
    height: 13.46,
    transform: "translate(-174.27 107.23) rotate(-27.28)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.07,
    y: 405.98,
    width: 17.52,
    height: 13.46,
    transform: "translate(-174.27 107.23) rotate(-27.28)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.94,
    y: 415.78,
    width: 6.38,
    height: 1.93,
    transform: "translate(438.38 113.29) rotate(62.66)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.07 418.74 125.71 418.04 124.92 418.45 124.04 416.75 124.84 416.34 124.47 415.64 123.03 416.39 124.64 419.49 126.07 418.74",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.05,432.08c10.29,0,22.06-3.17,22.59-6.14a24.15,24.15,0,0,0-1.34-11.87c-.41-1.15-9.5,1.14-9.21,2.42.5,2.17,1.12,6.24,1.19,6.38.16.3-10.26,4-14.14,5.39C114.27,430.4,116.53,432.1,121.05,432.08Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55,405.39a1.46,1.46,0,0,1,1.66-.11,2.17,2.17,0,0,1,.89-1.17c.77-.45,1.81.56,1.81.56a2.7,2.7,0,0,1,1.14-1.08c.78-.36,2,.51,2,.51a2.38,2.38,0,0,1,1.61-.32c1.47.29,2.29,2.44,2.82,3.79s.77,5.72.9,6.54l-8.7,3.49s-4.12-5.41-4.51-7.1C128.8,409.08,128.69,406.14,129.55,405.39Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.09,405.4a19.27,19.27,0,0,0,.85,4.64s.06,0,.05,0c-.4-1.52-.49-3.11-.82-4.64C131.16,405.35,131.09,405.36,131.09,405.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.81,404.75a4.29,4.29,0,0,0,.24,1.06c.11.37.23.74.35,1.1.25.73.52,1.46.8,2.18a0,0,0,1,0,.05,0c-.24-.73-.48-1.46-.69-2.2-.11-.37-.21-.74-.31-1.11a5.27,5.27,0,0,0-.34-1C133.89,404.67,133.81,404.69,133.81,404.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,404.14a3.16,3.16,0,0,0,.27.94l.36,1c.23.67.46,1.33.67,2a0,0,0,1,0,0,0c-.21-.68-.41-1.37-.62-2.05l-.32-1a2.84,2.84,0,0,0-.37-.88A0,0,0,0,0,137,404.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,417.36l10.15-2.4s2.07,9.84.36,12.19-15.28,6.22-22.56,5.24c-3.66-.5-7.37-1.5-.81-4.46s13.62-5.06,13.69-5.2S132.9,417.36,132.9,417.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.34,418.25c-1.15.26-2.29.51-3.43.82l-1.93.53s0,0,0,0c1.15-.22,2.32-.44,3.47-.71s2.28-.53,3.42-.82c.65-.16,1.29-.34,1.93-.55,0,0,0,0,0,0C141.64,417.72,140.49,418,139.34,418.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.64,415.05l.41-.12h0a25.48,25.48,0,0,1,1,7.15c-.2-2.34-.77-4.87-1-7.09l-.42.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.26,417.28l-.35.09c.31,1.37.57,2.9.8,4.33,0,.18.1.65.11.83s.05.26-.1.31c-.38.2-.69.3-1.05.45-1.33.55-8.88,3.14-10.4,3.67,3.69-1.55,7.59-2.81,11.32-4.26.08,0,0-.06,0-.16s-.07-.64-.09-.81l-.65-4.37h0l.36-.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,426a9.86,9.86,0,0,1-1.95.28A10.66,10.66,0,0,1,125,426Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.86,440.3c-2.69-3.79-6.5-5.87-11.66-6.36l-1.24-.11c-2.69-.24-5.74-.5-7.47-1.47-2.19-1.23-4.72-4.56-3.57-6.8l.44.23c-1,2,1.59,5.13,3.37,6.13s4.64,1.18,7.28,1.41l1.24.11c5.31.5,9.24,2.65,12,6.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.12,440.79a1.36,1.36,0,1,0-1.92.24A1.37,1.37,0,0,0,138.12,440.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,440.46a.83.83,0,1,0-1.15.14A.83.83,0,0,0,137.69,440.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.25,421.38c4.07-4.29,4.54-5.63,4.44-6.43a3.8,3.8,0,0,0-.65-1.6l-.34.25.17-.12-.17.12a3.32,3.32,0,0,1,.58,1.4c.07.58-.3,1.84-4.33,6.09Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.21,414h0a.45.45,0,0,0,.14-.61l-.3-.46a.44.44,0,0,0-.61-.14h0a.44.44,0,0,0-.14.61l.3.47A.45.45,0,0,0,122.21,414Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.05,419.46c1.08-4.33,2-6.53,2.81-6.93a3.4,3.4,0,0,1,1.49-.26l0-.42a3.81,3.81,0,0,0-1.69.31c-1,.47-1.89,2.56-3,7.2Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.72,412.07h0a.45.45,0,0,1,.45-.44h.55a.45.45,0,0,1,.44.45h0a.44.44,0,0,1-.44.44h-.55A.46.46,0,0,1,118.72,412.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.44,419.45a22.28,22.28,0,0,0-.71,2.82,2.52,2.52,0,0,0,.24,1.3,4.08,4.08,0,0,1-.64,1.16c-.28.44-.62.95-.59,1.16a.41.41,0,0,0,.48.3c.2-.07.5-.6.77-1.05s.69-1.13.76-1.09a2.74,2.74,0,0,0,1.23-.4,19.47,19.47,0,0,0,2.22-2c.41-.47.27-.63.15-.77s-.4-.12-.9.38c-.78.79-2,2.19-2.65,1.82h0c-.61-.43,0-2.25.35-3.3.19-.66.1-.78-.16-.86S114.62,418.87,114.44,419.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.2,425.38c1.13.73,1.24,3.75.68,5.51a26.5,26.5,0,0,1-2.14,1.7c-.68.55-1.43,1.17-2.08,1.79-.13.12-2.89-5-2.89-5a13.91,13.91,0,0,0,2.85-2,2.78,2.78,0,0,0,.24-.28.1.1,0,0,1,0-.05C113.32,426.52,115.11,424.67,116.2,425.38Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67,433.47c.78-3.53-.57-5.7-1-6.05a13.27,13.27,0,0,1-2.85,2s2.76,5.11,2.89,5C113,434.07,113.33,433.76,113.67,433.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.57,439.71c1.73-1.15,4.56-6.24,4.28-8.12-.41-2.73-2.88-5-5.66-4.09s-6.26,7.57-5.78,9.47A4.94,4.94,0,0,0,109.57,439.71Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.83,432.93s0,0,0,0c.2-.34.48-.69.85-.61,0,0,0,0,0,0C108.34,432.11,108,432.58,107.83,432.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.91,433.47c.51.38,1.23-.67.76-1S107.48,433.15,107.91,433.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,431.75s0,0,0-.05c.24-.32.45-.72.23-1,0,0,0,0,0,0C106.53,431,106.24,431.48,106,431.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.45,431.88c-.55-.31.13-1.38.64-1.09S105.91,432.15,105.45,431.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,434.4a4.09,4.09,0,0,0-.46-.25A.88.88,0,0,0,107,434a.27.27,0,0,0-.21.26.63.63,0,0,0,.4.53,1,1,0,0,0,.69.13A.28.28,0,0,0,108,434.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.57,432.11a4,4,0,0,1,.41.31c.16.12.3.2.37.4a.27.27,0,0,1-.14.29.65.65,0,0,1-.66-.13,1,1,0,0,1-.41-.57A.29.29,0,0,1,104.57,432.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,430.43c0-.13,0-.29-.16-.37a1,1,0,0,0-.41-.14s0,0,0,0a.55.55,0,0,1,.54.08.43.43,0,0,1,.08.46S110,430.44,110,430.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,431.17a1.31,1.31,0,0,0-.39-1,1.82,1.82,0,0,0-.38-.29l-.08-.05-.08,0a.08.08,0,0,0-.11,0h0a.05.05,0,0,1,0,0h0l0,0c-.18.24-.42.64-.42.64s-.37-.64-.45-.51a19.46,19.46,0,0,0-1.89,3.62,0,0,0,0,0,.06,0c.7-1.05,1.21-2.21,1.9-3.27a2.19,2.19,0,0,0,.41.52s.44-.77.53-.88h0a1.86,1.86,0,0,1,.89,1.15S109.13,431.21,109.13,431.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,435.4c-.55-.71-1.72-.28-2.21,0s-1.87,2.48-2.69,2.88a1.87,1.87,0,0,1-2.26-.36c-.45-.59-.64-1.89-1.09-2.17s-1.22.57-1.52.36c-.65-.48-.24-2.09.17-2.88,0,0-2.6,3.34.31,5.9s5.41,1.36,6.34.64A12,12,0,0,0,113,435.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.66,434.58s-.13,2.26.82,2.42,1.84-2.56,1.29-3.46a1,1,0,0,0-1.39-.41Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.71,436.21a0,0,0,1,0,0,0,2.51,2.51,0,0,1,0-2.06c0,.33.13.61.55.63,0,0,0,0,0,0a.62.62,0,0,1-.4-.59,2.66,2.66,0,0,1,.09-.63c0-.07-.1-.12-.12,0h0A2.23,2.23,0,0,0,112.71,436.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.7,427.17l3.28-1.06-.22,5.8,1.73-.31s1.87-7,1.65-6.81l-2.81.82.06-2.63-3.26,3.22Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.69,424.48c-.52.55-1.06,1.09-1.55,1.66a0,0,0,0,0,0,.05,41.82,41.82,0,0,0,3.12-3h0c0,.11,0,2.37,0,2.37.5-.08,2.55-.67,2.72-.74-.3,1.11-1.35,5.6-1.54,6.76,0,0,0,.05,0,0,.39-1.09,1.83-7,1.79-7a30.65,30.65,0,0,0-3,.87,22,22,0,0,0,.09-2.76A20.77,20.77,0,0,0,114.69,424.48Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.59,339.84c.3-.14,5.46-3,6.07-2.71a157.63,157.63,0,0,1,18.41,10.05c.24.3-2.68,6.56-2.7,6.6-.23.79-5.62,13.76-5.62,13.76l-13.4-4.39,5.17-13.84.09-.23a37.39,37.39,0,0,0-4.11-5.18c-.31-.32-2.79-1.18-3.06-1.44C331.56,341.58,331.18,340,331.59,339.84Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.6,339.84c.29-.14,5.45-3,6.06-2.71a158.51,158.51,0,0,1,18.41,10.05c.15.22-1,3-1.9,4.85-2.61-2.7-14.2-9.46-16-10s-3.77-.05-2.67,1.91c-.32-.33-2.8-1.18-3.07-1.45C331.56,341.58,331.19,340,331.6,339.84Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.8,431.87s-7.09-7.91-6.7-11.12c0,0-8.85-25.33-10.61-31.14-1.93-6.39,10.38-35.89,10.38-35.89l13.39,4.8s-8.79,25.68-8.67,25.9c1.61,3,7.83,25,8.34,25.34,5.8,4,7.16,12.72,7.16,12.72Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.1,420.75s-3.67-10.57-6.34-18.34l19.17,7.35,0,0c5.77,4.06,7.13,12.7,7.13,12.7l-13.78,9.73S337.71,424,338.1,420.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.35,393.47c.19-.81,12.18-19.91,13.1-20.35.15-.08,3.06,2,6.61,4.3,4.41,2.82,9.37,6.32,9.37,6.32l-8,11.09L275.2,389s-7.64,5.12-8.7,5.49S263.15,394.28,263.35,393.47Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.7,391.34l0,0,0,0Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.23,375.55c-4.48,4.15-12.55,15.83-13.11,17.33s3.65-1,4.47-1.47a55.63,55.63,0,0,1-5.09,3.11c-1.06.37-3.35-.24-3.15-1s12.18-19.91,13.1-20.35A38.23,38.23,0,0,1,280.23,375.55Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.56,391.87,288,380.75s28.73,19.36,29.19,19.56c1.52.67,25.69,8.19,32.56,9.63,8.44,1.76,8.65,12.34,8.65,12.34l-14.09,9.93-3.65-5c-2.38-1-26-9.78-30.28-12.94C302.83,408.73,280.56,391.87,280.56,391.87Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.28,427.52a10.47,10.47,0,0,1-4.62-.34,10.62,10.62,0,0,1,4.62.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.75,392.1s-14.36,3.59-21,8.4S318,418.83,318,418.83l22.88,8.69,3.4,4.69,14.09-9.93s-.31-9.54-5.7-12.69Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.75,392.1s-14.36,3.59-21,8.4S318,418.83,318,418.83l22.88,8.69,3.4,4.69,14.09-9.93s-.31-9.54-5.7-12.69Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.58,407.21a33.94,33.94,0,0,1-10.43-1.83,87.87,87.87,0,0,0,10.43,1.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.67,406a5.83,5.83,0,0,1-3.59-1.45,25,25,0,0,0,3.59,1.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.86,460.25a5.77,5.77,0,0,0,6-2.84c2.9-4.41-1.38-15.75-1.41-16.86s.34-1.47.25-2.45-1-1.38-1.21-1.68a8,8,0,0,1,.3-2.27s-5.49,0-8.54,1.49a26.1,26.1,0,0,0-6.09,4.65s1,.84,1.14,1.33-.27,1.29,0,2.17,1.91,1.6,2.17,2,1.9,9.45,3.49,12.33S360.86,460.25,360.86,460.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,440.58a4.79,4.79,0,0,1,1,.91.68.68,0,0,1,.15.32c0,.75-.43,1.55-.11,2.28a5,5,0,0,0,1.52,1.23,2,2,0,0,1,.76.75,2.56,2.56,0,0,1,.1.34c.85,3.7,1.56,7.48,3.12,11a6.68,6.68,0,0,0,1.49,2.21,6.59,6.59,0,0,1-1.62-2.14c-1.7-3.44-2.45-7.25-3.25-11a2.33,2.33,0,0,0-.08-.31,1.77,1.77,0,0,0-.66-.64,4.92,4.92,0,0,1-1.55-1.35c-.32-.79.16-1.57.19-2.35a.67.67,0,0,0-.12-.29,5.63,5.63,0,0,0-.94-.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.13,434.55c-.09.5-.24,1.15-.3,1.65v0a1,1,0,0,0,.19.16,2.59,2.59,0,0,1,1.15,1.61,7.92,7.92,0,0,1-.28,2.38,3.72,3.72,0,0,0,.25,1.51c1.25,4.27,3.24,11.54.77,15.55a4.58,4.58,0,0,1-1.06,1.18,4.9,4.9,0,0,0,1-1.22c2.25-4.06.23-11.16-1-15.44a3.87,3.87,0,0,1-.23-1.61A8.11,8.11,0,0,0,366,438a2.26,2.26,0,0,0-.76-1.31c-.14-.14-.3-.25-.44-.39a.16.16,0,0,1-.06-.08,15.91,15.91,0,0,1,.38-1.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.47,434.73l-1.16-2.52,14.09-9.93s4.62,12.87,2.83,19.92a4.61,4.61,0,0,1-6.61,3.26c-.61-.27-7-3.22-8.62-5.66A6.79,6.79,0,0,1,345.47,434.73Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.24,433.46a16.79,16.79,0,0,1-2.62,1c-.46.12-.92.21-1.38.29q-.35.06-.69.15a2.34,2.34,0,0,0-.69.23s0,0,0,0a4.36,4.36,0,0,1,.59-.35,3.33,3.33,0,0,1,.63-.21c.46-.13.93-.23,1.39-.35.93-.24,1.85-.48,2.75-.8C351.25,433.36,351.28,433.44,351.24,433.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.67,431.42a19.33,19.33,0,0,1-1.89,1.32c-.33.19-.67.36-1,.53l-.51.22c-.19.08-.39.13-.57.21,0,0,0,0,0,0s.32-.2.49-.3l.5-.28,1-.58c.67-.37,1.33-.76,2-1.16C352.66,431.33,352.7,431.39,352.67,431.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.23,444.38c-.27-.27-3-1.39-4.43-.44-.45.31,1.13,2.87,1.13,2.87l.08.22,1,3,4.34.09.62,0-.77-1.8a1,1,0,0,0-.07-.15l-.06-.16-.2-.45c-.05-.12-.1-.23-.16-.35l-.16-.36A20.72,20.72,0,0,0,359.23,444.38Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.24,448.31A6.37,6.37,0,0,0,356,447l1,3,4.34.09.62,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.87,457c-3.66-4.23-1.53-6.91-.62-7.7s3.75-3,7.83.79,3.27,6.89,1.46,8.62S359.54,461.21,355.87,457Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.14,457.07a3.65,3.65,0,0,1,.34-.18.66.66,0,0,1,.38-.12.2.2,0,0,1,.16.19.5.5,0,0,1-.3.4.73.73,0,0,1-.52.1A.22.22,0,0,1,357.14,457.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,454.75a2.26,2.26,0,0,0-.25.29.63.63,0,0,0-.19.36.2.2,0,0,0,.15.19.51.51,0,0,0,.45-.21.76.76,0,0,0,.2-.49A.21.21,0,0,0,360,454.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.66,454.33s0,0,0-.05c-.26-.28-.51-.64-.33-1,0,0,0,0,0,0C358,453.63,358.37,454.1,358.66,454.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.18,454.4c.49-.36-.28-1.32-.73-1S358.77,454.71,359.18,454.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.33,454.2c0-.12,0-.28.14-.37s.27-.08.43-.05,0,0,0,0c-.15-.19-.37-.32-.59-.19a.47.47,0,0,0-.1.61S359.31,454.25,359.33,454.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.08,455.7h0c-.23-.3-.54-.62-.89-.5,0,0,0,0,0,0C356.5,455,356.92,455.37,357.08,455.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.06,456.22c-.45.42-1.25-.51-.83-.9S357.44,455.87,357.06,456.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.82,456.33c-.12,0-.27,0-.36.06s-.1.24-.08.4h0c-.16-.18-.26-.41-.11-.59s.37-.12.57,0C356.84,456.25,356.86,456.32,356.82,456.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.91,451.93a.58.58,0,0,0-.39,0,.92.92,0,0,0-.29.3h0a.51.51,0,0,1,.29-.44.39.39,0,0,1,.44.11S356.93,451.94,356.91,451.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.46,454a7.63,7.63,0,0,1-.56-.62s0-.07.09-.13h0a1.29,1.29,0,0,1,1.28-.37s0,.05,0,.06a1.86,1.86,0,0,0-1.13.43c0,.07.72.68.68.7a2.14,2.14,0,0,1-.57.26c.82.87,1.78,1.61,2.58,2.49,0,0,0,.08,0,.06a19.17,19.17,0,0,1-2.89-2.57C355.79,454.19,356.35,454,356.46,454Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.26,453.14a1.27,1.27,0,0,1,.18-.63.53.53,0,0,1,.27-.22c.25-.1.39.09.47.28a1.18,1.18,0,0,1,.09.31A1.68,1.68,0,0,0,356.26,453.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.44,452.51a.53.53,0,0,1,.27-.22c.25-.1.39.09.47.28A.61.61,0,0,1,356.44,452.51Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.28,450.27c-.83.43,0,2.2,0,2.2s-1.61,1-.71,3.63a4.17,4.17,0,0,1-.47-2.35,6.46,6.46,0,0,0-2.38,5.17,7.41,7.41,0,0,1-.09-2.21,4,4,0,0,0-1,2.39,8.32,8.32,0,0,0-2-1.2s3.1,4.3,7.46,1.52c0,0,2.77-2,2.39-4.9A6,6,0,0,0,363.28,450.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,450.49s2,.8,2.41,0-1.73-2.42-2.7-2.2a.94.94,0,0,0-.78,1.12Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.8,450s0,0,0,0a2.34,2.34,0,0,1-1.85-.58.52.52,0,0,0,.73-.3s0,0,0,0a.6.6,0,0,1-.65.18,2.73,2.73,0,0,1-.54-.27c-.06,0-.13.05-.08.1h0A2.11,2.11,0,0,0,363.8,450Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.31,393.31l-16.08,4c-4.34,1.08-2.79,4.38-.85,7.77s4.86,8.54,8.74,7.58l4.17-1,4.18-1c3.88-1,4.06-6.87,4.21-10.77S361.66,392.24,357.31,393.31Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.71,410.44a1.38,1.38,0,1,0-1,1.66A1.38,1.38,0,0,0,349.71,410.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.6,408.25a1.38,1.38,0,1,0-1,1.66A1.37,1.37,0,0,0,358.6,408.25Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.28,410.55a.93.93,0,1,0-.68,1.12A.93.93,0,0,0,349.28,410.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.17,408.36a.93.93,0,1,0-.68,1.12A.93.93,0,0,0,358.17,408.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,410.32l.12,0a.57.57,0,0,1,.65.45c.69,3.64,3.08,13.4,5.85,14.74a1.13,1.13,0,0,0,1.1,0,.57.57,0,0,1,.76.24.55.55,0,0,1-.24.75,2.25,2.25,0,0,1-2.11,0c-1.65-.8-3.24-3.68-4.72-8.57a70,70,0,0,1-1.73-7A.56.56,0,0,1,348,410.32Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,440.22c3.09-9.8,3.7-22,1-23.38a24.18,24.18,0,0,0-11.72-2.34c-1.22,0-1.81,9.39-.5,9.5,2.22.2,6.28.84,6.44.82.33-.06.66,11,.82,15.11C358.67,446.17,361,444.54,362.34,440.22Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.51,424a1.46,1.46,0,0,1,.4-1.62,2.11,2.11,0,0,1-.84-1.2c-.2-.87,1.08-1.56,1.08-1.56a2.62,2.62,0,0,1-.68-1.41c-.1-.85,1.09-1.72,1.09-1.72a2.34,2.34,0,0,1,.18-1.63c.72-1.31,3-1.44,4.47-1.53s5.68,1,6.5,1.14l.68,9.34s-6.41,2.27-8.14,2.14C342.79,425.84,340,425.05,339.51,424Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,422.53a18.88,18.88,0,0,0,4.67.61s0-.05,0-.05c-1.57-.09-3.11-.49-4.67-.64C340,422.45,340,422.51,340,422.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.19,419.74a4.43,4.43,0,0,0,1.09.1h1.15c.78,0,1.55,0,2.32-.1,0,0,0-.05,0-.05-.77,0-1.54,0-2.31,0l-1.15,0a4.42,4.42,0,0,0-1.09,0C340.15,419.65,340.14,419.73,340.19,419.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.59,416.49a2.93,2.93,0,0,0,1,0l1.06,0c.7,0,1.4,0,2.11,0,0,0,0-.05,0-.05l-2.14,0h-1.06a2.76,2.76,0,0,0-1,.08S340.58,416.48,340.59,416.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.93,424.45l.8-10.4s10,1,11.73,3.37,1.27,16.45-1.89,23.09c-1.59,3.33-3.67,6.56-4.49-.59s-.67-14.51-.78-14.62S351.93,424.45,351.93,424.45Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.73,418.59c-.09,1.17-.2,2.34-.25,3.52,0,.66-.07,1.33-.09,2,0,0,0,0,0,0,.15-1.17.29-2.34.38-3.52s.19-2.34.27-3.51q.06-1,.06-2h0C354.93,416.24,354.83,417.41,354.73,418.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.7,414.48V414a25.3,25.3,0,0,1,7.11,1.26c-2.29-.52-4.87-.75-7.05-1.23l-.06.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,424.08l0,.37c1.41.12,2.93.34,4.37.56.18,0,.65.1.82.14s.27,0,.27.19c.07.43.08.75.11,1.13.12,1.44.28,9.43.32,11-.3-3.64-.38-7.37-.54-11,0-.36,0-.77-.06-1.07,0-.08-.05-.05-.14-.08-.47-.13-4.59-.78-5.16-.88h0l0-.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.72,434.61a9.84,9.84,0,0,1-.33,1.94,10.78,10.78,0,0,1,.33-1.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.06,408.11l.11,0a.56.56,0,0,1,.66.43,60.92,60.92,0,0,1,1,7.87c.33,5.59-.55,9-2.62,10.06a.55.55,0,0,1-.75-.23.57.57,0,0,1,.23-.76c3.36-1.76,1.87-12.65,1-16.7A.55.55,0,0,1,357.06,408.11Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.63,211.74c0-.33-.82-6.1-.42-6.63,4.06-5.43,15.27-13.54,15.86-13.73.36-.13,5.2,4.8,5.24,4.83.65.49,10.92,10.08,10.92,10.08l-9.53,11.28-10.42-9.95-.19-.16a37.57,37.57,0,0,0-6.29,2c-.41.18-2.08,2.21-2.42,2.36C350.25,212.38,348.67,212.19,348.63,211.74Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.63,211.74c0-.33-.82-6.1-.42-6.63,4.06-5.43,15.27-13.54,15.86-13.73.36-.13,5.2,4.8,5.24,4.83s.9.79,1.94,1.74L361.76,209l-1.48-1.42-.19-.16a37.57,37.57,0,0,0-6.29,2c-.41.18-2.08,2.21-2.42,2.36C350.25,212.38,348.67,212.19,348.63,211.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.56,212c-.14-.17-.75-6.55-.41-7,3.28-4.34,15.3-13.81,16-14,.38-.08,3.2,2.54,5.65,5.5l-9.74,11a44.68,44.68,0,0,0-6.28,2c-.49.23-2,2.21-2.36,2.41A3.21,3.21,0,0,1,348.56,212Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.86,211.2a3.85,3.85,0,0,0,.27-3,3.27,3.27,0,0,0-1.62-2s-.05,0,0,.05a4.22,4.22,0,0,1,1.33,4.85A0,0,0,0,0,351.86,211.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.24,212.07c1,0,1.29-1.15,1.2-1.95a8.21,8.21,0,0,0-1.09-3.07c-.08-.13-.16-.26-.25-.38l-.11-.16h0l0,0-.09-.13a0,0,0,0,0-.07,0,.17.17,0,0,0-.28.09c-.08.35-.17.71-.26,1.07a1.21,1.21,0,0,0-.05.18,7.86,7.86,0,0,0-.35,2.67C358.91,211.13,359.31,212.11,360.24,212.07Zm-.78-3.61c.06-.31.13-.61.2-.91s.11-.51.16-.77c0,0,0-.07,0-.1s0-.07,0-.1l0,.08h0c.08.2.15.38.24.57a14.68,14.68,0,0,1,.59,1.56,9.17,9.17,0,0,1,.28,1.12c.09.59-.16,2.52-1.37,1.4C359,210.71,359.3,209.2,359.46,208.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.68,206.63s0,.05,0,.05h.16s0,0,0,0a.67.67,0,0,0,.2,0,6.31,6.31,0,0,0,.76-.08,7.73,7.73,0,0,0,2.8-1c.69-.42,1.38-1.33.8-2.14l-.06-.08c-.56-.66-1.53-.38-2.15,0a7.68,7.68,0,0,0-1.67,1.65c-.34.42-.66.87-1,1.28h0A.18.18,0,0,0,359.68,206.63Zm1.45-1.56c.5-.59,1.48-1.78,2.37-1.63a1.17,1.17,0,0,1,.59.22c.6.48-.42,1.48-.85,1.72a10,10,0,0,1-1.05.48c-.27.1-.55.19-.83.27-.45.14-.91.25-1.37.38h0l-.08,0,.05-.07.15-.17C360.45,205.9,360.79,205.48,361.13,205.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.42,208.29a5.24,5.24,0,0,0,1.93-4.11c0-.06-.09-.05-.11,0a20.8,20.8,0,0,1-2,4A.09.09,0,0,0,358.42,208.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.25,208.74a5.24,5.24,0,0,0,1.93-4.11c0-.06-.09,0-.1,0a21.23,21.23,0,0,1-2,4A.09.09,0,0,0,357.25,208.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.09,209.18a5.24,5.24,0,0,0,1.93-4.1.06.06,0,0,0-.11,0,20.81,20.81,0,0,1-2,4A.09.09,0,0,0,356.09,209.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.92,209.63a5.24,5.24,0,0,0,1.93-4.11c0-.06-.09-.05-.11,0a20.8,20.8,0,0,1-2,4A.09.09,0,0,0,354.92,209.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.44,212c.08-1.77-.11-3.56-.1-5.33,0-.21,0-.41,0-.62a1,1,0,0,1,.13-.64,9.68,9.68,0,0,1,.94-.87l1.92-1.75c2.58-2.35,5.2-4.65,7.83-6.94l2.22-1.94c.75-.65,1.45-1.35,2.19-2a0,0,0,1,0,0,0c-.71.55-1.44,1.06-2.14,1.63l-2.07,1.72c-1.35,1.15-2.7,2.31-4,3.49s-2.66,2.36-4,3.56l-2,1.82-1,.89a1.05,1.05,0,0,0-.4.85c0,2.05.21,4.12.29,6.17C349.29,212,349.44,212,349.44,212Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.83,235.15s-9.93,1.8-12.76.23c0,0-26.79-1.34-32.84-1.91-6.65-.62-32.5-24.67-32.5-24.67L371.25,197s23.83,19.61,24.08,19.59c3.42-.35,24.88,3.13,25.4,2.79,5.93-3.85,14.48-1.84,14.48-1.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.07,235.38s-11.17-.58-19.37-1l14-15,0,0c5.93-3.82,14.45-1.82,14.45-1.82L439,235.73S428.9,237,426.07,235.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.73,199.88c-.57.75-1.2,1.45-1.8,2.17l-1.84,2.13c-1.25,1.4-2.5,2.8-3.77,4.18-.34.38-.69.75-1.05,1.12s-.8.75-1.18,1.15c0,0-.08,0,0,0,.3-.35.55-.74.84-1.1l.93-1.1c.62-.7,1.23-1.41,1.86-2.11,1.24-1.41,2.49-2.81,3.77-4.17.73-.77,1.44-1.57,2.21-2.3A.05.05,0,0,1,373.73,199.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.63,294.33c-.68-.48-13.86-18.78-13.91-19.8,0-.17,3-2.07,6.47-4.5,4.28-3,9.14-6.68,9.14-6.68l7.28,11.56L373,281.68s1.86,9,1.81,10.14S373.3,294.82,372.63,294.33Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.59,269l-1.4,1c-3.45,2.43-6.49,4.33-6.47,4.5a3.76,3.76,0,0,0,.52,1l.21.35c.06.08.1.16.16.25h0l.17.27h0l.38.57.65,1,.21.3c.69,1,1.5,2.2,2.36,3.43l.23.33.68,1,.62.88c3.55,5,7.36,10.19,7.72,10.44s1.28-.45,1.77-1.33c.05-.1.11-.21.15-.31a3.25,3.25,0,0,0,.2-.6.62.62,0,0,0,0-.18.38.38,0,0,0,0-.1,12.71,12.71,0,0,0-.2-1.69l0-.19-.06-.36c0-.26-.09-.53-.14-.81s-.05-.28-.08-.43,0-.29-.08-.44-.05-.29-.08-.44c-.17-.9-.34-1.82-.51-2.65,0-.14-.05-.28-.08-.41s0-.14,0-.2-.08-.39-.11-.57,0-.12,0-.18,0-.23-.07-.34l-.06-.3-.16-.82c0-.19-.06-.3-.06-.3l1.91-.91-.27-.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.7,294.41c-.68-.49-14.1-18.83-14.16-19.85,0-.38,3-2.32,6.33-4.31l8.29,11.53s1.74,9,1.69,10.11S373.37,294.89,372.7,294.41Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.24,293.62c-2.13-3.11-11-15.45-13.33-18.36,0,0,0,0,0,0,2,3.12,11,15.39,13.3,18.38C373.23,293.72,373.28,293.68,373.24,293.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.66,290.25a3,3,0,0,0-2.07-1.29,2.93,2.93,0,0,0-2.12.49s0,.05,0,0a3.48,3.48,0,0,1,4.12.79S374.67,290.28,374.66,290.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.54,283a5.23,5.23,0,0,0-3.86-2.38c-.06,0-.06.08,0,.1a20.82,20.82,0,0,1,3.75,2.41A.09.09,0,0,0,373.54,283Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.85,284.17a5.18,5.18,0,0,0-3.86-2.38c-.06,0-.06.08,0,.1a20.82,20.82,0,0,1,3.75,2.41C373.8,284.36,373.92,284.25,373.85,284.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.17,285.37A5.28,5.28,0,0,0,370.3,283c-.06,0-.06.09,0,.11a21.62,21.62,0,0,1,3.74,2.4C374.11,285.57,374.23,285.46,374.17,285.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.48,286.58a5.28,5.28,0,0,0-3.87-2.38c-.06,0-.06.09,0,.11a20.69,20.69,0,0,1,3.74,2.4A.1.1,0,0,0,374.48,286.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.76,281.93c.06-1-1-1.41-1.81-1.41a7.94,7.94,0,0,0-3.17.74l-.41.2-.17.09h0l0,0-.14.08a0,0,0,0,0,0,.07.2.2,0,0,0,0,.21.15.15,0,0,0,.09.08l1,.38.17.08a8.31,8.31,0,0,0,2.62.64C376.67,283.15,377.69,282.86,377.76,281.93Zm-3.68.37-.88-.3-.75-.24a.19.19,0,0,0-.1,0l-.1,0,.09,0h0l.6-.17a14.6,14.6,0,0,1,1.61-.41,7.55,7.55,0,0,1,1.15-.15c.59,0,2.48.44,1.23,1.52C376.26,283,374.8,282.54,374.08,282.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.29,281.88a.05.05,0,0,0,0,0,.45.45,0,0,0,0-.11.11.11,0,0,0,0-.05v0a.68.68,0,0,0,0-.2,6.43,6.43,0,0,0,0-.76,8,8,0,0,0-.67-2.9c-.34-.73-1.16-1.52-2-1l-.09.06c-.72.48-.54,1.47-.21,2.14a8,8,0,0,0,1.44,1.84c.39.38.8.76,1.17,1.14h0A.18.18,0,0,0,372.29,281.88Zm-1.39-1.63c-.53-.55-1.6-1.66-1.35-2.54a1.17,1.17,0,0,1,.28-.55c.55-.54,1.42.58,1.61,1a7.07,7.07,0,0,1,.36,1.1,8,8,0,0,1,.18.85c.09.47.15.93.22,1.4h0a.29.29,0,0,0,0,.09l-.06-.07-.15-.16C371.65,281,371.27,280.65,370.9,280.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.15,281.84l-10.12-14s33.7-21.1,34.06-21.44c1.19-1.16,18.4-20,22.36-25.83,5.2-7.62,14.69-3.36,14.69-3.36L439,235.73l-6-.29c-1.82,1.82-18.84,20.34-23.39,23.16C401.64,263.52,374.15,281.84,374.15,281.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.31,266.54c.6.72,1.14,1.49,1.69,2.25s1.11,1.51,1.65,2.28q1.62,2.3,3.2,4.62c.29.43.58.85.86,1.28s.54,1,.84,1.42c0,0,0,.07-.05,0-.27-.37-.6-.71-.88-1.08s-.57-.76-.85-1.15c-.55-.76-1.09-1.52-1.63-2.29-1.08-1.53-2.16-3.07-3.19-4.64-.58-.88-1.2-1.76-1.72-2.68C368.19,266.54,368.27,266.49,368.31,266.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.06,231.28a5.5,5.5,0,0,1-2.07,4.16,5.5,5.5,0,0,1,2.07-4.16Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.83,226.19c-3.45,1.65-15.69,9.3-15.92,13.32-.17,2.85,3.2,13.11,4.71,15.35.85,1.27,8.4-3.22,7.9-5-.61-2.22-3.17-8.39-3.12-9.75,0-.73,3.83-5,8.9-11C460.9,226,458.82,224.76,455.83,226.19Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.29,254.31a53.78,53.78,0,0,0,3.33,7.19c.82,1.12,3.42,4.17,4.34,3.63s.23-1.5.23-1.5,1.31,1.11,2.18.48-.24-2.08-.24-2.08,1.42,1.05,2.25.36-.54-2-.54-2,1.25,1,1.69.16c.54-1-2-2.65-2.8-3.95-.19-.3-3.32-6.27-3.32-6.27Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,260.54a7.69,7.69,0,0,1-3.37-4s-.08,0-.07,0c.73,2,1.33,3.18,3.39,4.07C456,260.68,456,260.6,456,260.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.28,262.13a11.66,11.66,0,0,1-3.59-4.3s-.07,0-.06,0c.93,2,1.56,3.19,3.56,4.36C454.28,262.26,454.36,262.19,454.28,262.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.14,263.53a10.42,10.42,0,0,1-3.26-4.52,0,0,0,0,0-.08,0,7.39,7.39,0,0,0,3.29,4.54C452.2,263.65,452.24,263.62,452.14,263.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.1,248.52a22.34,22.34,0,0,1,3.17,2.7c.76,1,2.28,5.67,1.28,6-1.28.5-2.69-2-3.22-3.37,0,0-3,1.15-4.37-.45S452.1,248.52,452.1,248.52Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.15,257.29c-1.5-.39-2.07-2.18-2.68-3.44a.13.13,0,0,0-.21,0c-1.27.4-3.19.59-4.31-.28a0,0,0,0,0,0,.05c1.07,1.09,3,1.06,4.34.53.6,1.3,1.26,3.07,2.9,3.2C456.16,257.31,456.16,257.29,456.15,257.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.37,248.48,442.16,253s-3-9.92-2.47-14.24c.37-3.22,10.89-10.29,15.66-12.7s5.21.65,2.9,3.47-8.44,10.06-8.54,10.52S452.37,248.48,452.37,248.48Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.45,248.11l2.3-.94c.76-.3,1.52-.64,2.3-.89a0,0,0,1,1,0,.05c-.7.37-1.45.67-2.18,1l-2.32,1c-1.53.66-3.09,1.27-4.65,1.85,0,0-.05,0,0-.05C443.41,249.43,444.92,248.74,446.45,248.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.35,226c-4.77,2.41-15.29,9.48-15.66,12.7a16,16,0,0,0,.15,3.81l19.53-16.87C458.87,225,457.59,224.91,455.35,226Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.72,237.8c-.52-.51-2.94-22.41-2.79-22.53s21,.43,27.3,6.3c1.83,1.69,2.12,5.27.47,6.77C454.8,231.88,434,238.12,433.72,237.8Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453.8 226.18 455.61 226.9 454.23 228.51 452.89 228.25 452.63 226.91 453.8 226.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.63 226.91 437.28 228.44 432.91 231.19 438.11 232.8 452.89 228.25 452.63 226.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.08,
    y: 195.19,
    width: 19.47,
    height: 32.14,
    transform: "translate(-10.6 21.42) rotate(-3.03)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.37,
    y: 194.92,
    width: 9.17,
    height: 32.14,
    transform: "translate(-10.58 21.69) rotate(-3.03)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.03,
    y: 206.29,
    width: 33.66,
    height: 9.09,
    transform: "translate(596.85 -207.59) rotate(86.97)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.94 217.39 412.77 217.67 412.64 215.23 415.58 215.08 415.09 205.79 412.15 205.95 412.02 203.51 417.2 203.24 417.94 217.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.63,
    y: 197.8,
    width: 2.19,
    height: 4.34,
    transform: "translate(581.15 -212.76) rotate(86.97)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.81,
    y: 220,
    width: 2.19,
    height: 4.34,
    transform: "translate(604.45 -192.9) rotate(86.97)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.05,219.56c-6-7.76-12.48-11-14.34-11.49-4.51-1.12-12.45-2.72-16-2.85-1.3-.05-.53,10,.86,10.05,4.37.29,13.9,1.66,14.07,1.7a39.14,39.14,0,0,1,9.31,3.4C456.5,223,459.56,222.83,457.05,219.56Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.86,215.2a1.55,1.55,0,0,1,.46-1.72,2.35,2.35,0,0,1-.88-1.3c-.18-.94,1.2-1.64,1.2-1.64a2.85,2.85,0,0,1-.71-1.52c-.08-.91,1.21-1.82,1.21-1.82a2.53,2.53,0,0,1,.22-1.72c.52-.9,3.25-1.47,4.81-1.54s6,1.2,6.9,1.35l.52,10s-6.88,2.29-8.72,2.11C417.32,217.22,414.31,216.32,413.86,215.2Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4,213.64a20.82,20.82,0,0,0,5,.75s0-.06,0-.06c-1.68-.12-3.3-.58-5-.77C414.37,213.55,414.35,213.62,414.4,213.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.68,210.67a4.06,4.06,0,0,0,1.15.12c.41,0,.82,0,1.24,0,.82,0,1.64,0,2.46,0,0,0,.05-.06,0-.06-.82,0-1.64,0-2.46-.06l-1.23-.07a5.62,5.62,0,0,0-1.16,0A.06.06,0,0,0,414.68,210.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.17,207.21a3.08,3.08,0,0,0,1.05,0h1.12c.75,0,1.5,0,2.25,0,0,0,.05-.06,0-.06l-2.29-.08-1.12,0a2.68,2.68,0,0,0-1,.07S415.16,207.2,415.17,207.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.51,215.75l.3-11s11.92,1.79,15.18,2.93,10.53,6.86,14.2,11.56c3.45,4.43.48,4.44-3.83,2.53s-11.7-4.34-12.47-4.54S427.51,215.75,427.51,215.75Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.76,215.44c.07-.41.07-.84.1-1.26s.05-.84.07-1.26c0-.82.05-1.63.06-2.44s0-1.62,0-2.43.06-1.7,0-2.54a0,0,0,0,0-.06,0c-.1.83-.1,1.69-.13,2.53s-.07,1.65-.1,2.48-.06,1.65-.08,2.48c0,.4,0,.81,0,1.22s0,.82,0,1.22C429.71,215.48,429.75,215.47,429.76,215.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.92,216.11c3,.25,6.3.63,9.34.94,3.95.71,7.65,2.6,11.4,4-3.42-1.11-8-3.19-11.41-3.78-3-.37-6.31-.74-9.33-1.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.64,221.27a14.82,14.82,0,0,1-1.91-1.33,13.89,13.89,0,0,1,1.91,1.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.37,227.13c-.44-1.23,1.14-3.59,2.62-4.62a25.59,25.59,0,0,1,2.66,0c.85,0,1.8-.05,2.67-.14l-.74,5.56a13.83,13.83,0,0,0-3.37-.17,1.8,1.8,0,0,0-.35.08h-.06C458.14,228,455.79,228.33,455.37,227.13Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.27,222.64c-1.43.41-4.81,1.72-4.56,4.62a4,4,0,0,0,.09.55h.06l.35-.08a13.78,13.78,0,0,1,3.37.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.75,220.86c-2-.37-7.42,1.26-8.5,2.77-1.58,2.18-1.39,5.44,1.16,6.7s9.52-1,10.47-2.69A4.82,4.82,0,0,0,469.75,220.86Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.94,226.46s0,0,0,0c-.37.1-.81.17-1-.14h0C466,226.71,466.61,226.62,466.94,226.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.24,226c-.11-.6-1.32-.34-1.22.23S467.33,226.53,467.24,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.41,228.6s0,0,0,0c-.38.08-.8.22-.85.58,0,0,0,0,0,0C466.49,228.79,467.05,228.61,467.41,228.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.88,228.85c.17.59-1,.9-1.18.35S467.73,228.35,467.88,228.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.6,225.51a3.74,3.74,0,0,0,.22.45.8.8,0,0,0,.32.42.25.25,0,0,0,.31-.08.63.63,0,0,0,0-.65,1,1,0,0,0-.47-.5A.28.28,0,0,0,467.6,225.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.56,229.21a4.35,4.35,0,0,1,0-.51.76.76,0,0,1,.11-.51.26.26,0,0,1,.32-.05.61.61,0,0,1,.25.6.89.89,0,0,1-.23.64A.27.27,0,0,1,468.56,229.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.42,227c-.07.11-.17.22-.15.36a1.11,1.11,0,0,0,.18.38s0,0,0,0a.53.53,0,0,1-.3-.43.42.42,0,0,1,.26-.37S463.43,227,463.42,227Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.62,227.17a1.3,1.3,0,0,0-.38,1,2.46,2.46,0,0,0,.08.46l0,.08,0,.08a.11.11,0,0,0,.1.06h0l0,0h0c.29-.06.72-.18.72-.18s-.15.7,0,.66A20,20,0,0,0,469,228s0-.08,0-.07c-1.19.29-2.33.79-3.52,1.09a2,2,0,0,0,0-.64s-.83.26-1,.27h0a1.81,1.81,0,0,1,.11-1.41S464.65,227.14,464.62,227.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.38,228.41a1.51,1.51,0,0,1-.59-.49.7.7,0,0,1-.11-.41c0-.31.28-.37.52-.37a2,2,0,0,1,.38.06A1.93,1.93,0,0,0,464.38,228.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.79,227.92a.7.7,0,0,1-.11-.41c0-.31.28-.37.52-.37A.72.72,0,0,1,463.79,227.92Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.41,222.15c.25,1,2.63.41,2.63.41a3.36,3.36,0,0,0,2.75,1.79,6.19,6.19,0,0,0-.23,3.72c.95,2.44,4.23,1.74,4.72.66.69-1.53-1.16-3.65-1.16-3.65s.31-3.82-2.34-4.43a1.9,1.9,0,0,0-2.19-1.37C467.78,219.52,465.23,221.42,465.41,222.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.69,222.26a3.35,3.35,0,0,0,1.4,1.7,2.56,2.56,0,0,0,2.33.15s.06,0,0,.06a2.91,2.91,0,0,1-2.48.06,2.36,2.36,0,0,1-1.34-1.95A0,0,0,0,1,467.69,222.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.61,219a2.33,2.33,0,0,1,1.09,1.88s-.06,0-.07,0a2.11,2.11,0,0,0-1.37-1.68,2.68,2.68,0,0,0-2,.25,5.33,5.33,0,0,0-2.73,2.7s0,0,0,0a5.33,5.33,0,0,1,3-3A2.72,2.72,0,0,1,470.61,219Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474,225a2.52,2.52,0,0,1,1.34,1.19,3,3,0,0,1,.19,2.14,1.7,1.7,0,0,1-1.25,1.15,3,3,0,0,1-2-.3s0,0,0,0a2.93,2.93,0,0,0,1.8.19,1.54,1.54,0,0,0,1.18-1.17,2.67,2.67,0,0,0-1.29-3.11S473.94,225,474,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.53,222.82s1.63-1.48,1.07-2.24-3,.53-3.25,1.53a1,1,0,0,0,.69,1.23Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.9,221s0,0,0,0a2.51,2.51,0,0,1-1.37,1.47.54.54,0,0,0,0-.82s0,0,0,0a.61.61,0,0,1-.12.68,3.11,3.11,0,0,1-.49.39c-.06,0,0,.14,0,.11h0C464.83,222.71,465.94,221.89,465.9,221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.45,227.73l-3.32-1,3.71-4.34-1.4-1s-6.11,4.47-5.81,4.46l2.88,1.09L453.75,229l4.82-.57Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.15,228.83c.79-.12,1.59-.22,2.38-.38,0,0,0,0,0,0a42.3,42.3,0,0,0-4.54.45h0c.07-.09,1.53-1.92,1.51-1.93-.47-.25-2.57-1-2.75-1.1,1-.7,4.78-3.67,5.68-4.49a0,0,0,1,0,0,0c-1,.64-6.07,4.48-6.05,4.53s2.56,1,3,1.13a21.59,21.59,0,0,0-1.87,2.17A25.88,25.88,0,0,0,456.15,228.83Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.71,52.47c-.78,3.39-1.13,7.59-3.43,10.37A11.51,11.51,0,0,1,245,66.45c-6,.89-13.52-.87-15.8-7.19-.9-2.52.06-7,3-7.92a14.53,14.53,0,0,1,4.61-.24,6.36,6.36,0,0,0,5-2.19c2.66-3,3-5.57,4.36-9.2A2.81,2.81,0,0,1,247.6,38a5,5,0,0,1,2.54-.61,4.86,4.86,0,0,1,2.36.25c1.59.63,2.75,2.58,3.77,3.87a4.52,4.52,0,0,1,1,4.12C256.78,47.93,256.22,50.2,255.71,52.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.69,54.17c.5-3.16.95-6.32,1.42-9.47,0,0,0,0,0,0-.46,2.59-1,5.16-1.38,7.76s-.68,5.18-1.31,7.68c-1.44,5.61-7.8,6.29-12.46,4.71-.22-.07-.31.28-.09.34,4.14,1.26,9.51,1.21,12-3C255.23,59.92,255.27,56.74,255.69,54.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.5,39.5a0,0,0,1,0-.09,0c-1,3-1.85,6.65-4.33,8.84a8.12,8.12,0,0,1-4.37,2,20,20,0,0,1-3.78-.24c-5-.38-6.76,6-4,9.39.06.07.19,0,.13-.1A6,6,0,0,1,231,51c2.15-1.62,5-.13,7.45-.65C243.52,49.29,245.37,44,246.5,39.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.39,52.72c3.77,2.31,15.06,11.08,14.25,14.76s-4.84,3.86-8.36.56c-2.52-2.36-5.77-7.78-7.75-11.67C248.93,53.21,248.9,50.59,252.39,52.72Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.39,52.72c3.77,2.31,15.06,11.08,14.25,14.76s-4.84,3.86-8.36.56c-2.52-2.36-5.77-7.78-7.75-11.67C248.93,53.21,248.9,50.59,252.39,52.72Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.23,68.86c2,2.39,5.26.22,5.47-1.77.48-4.68-1.17-10.86-2.78-14.8-.52-1.26-9.21,1.8-8.88,3.22C255.44,57.22,257.38,64.17,261.23,68.86Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.7,53.58l1.4,1.9a80.59,80.59,0,0,0,4.65,11.34A46.77,46.77,0,0,1,255,55.56l-1.28-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.88,52.77a46.68,46.68,0,0,0-.28-7.55c-.32-1.4-1.55-5.37-2.65-5.23s-.83,1.33-.83,1.33-.78-1.6-1.88-1.36-.62,2.08-.62,2.08-.92-1.57-2-1.26-.29,2.09-.29,2.09-.77-1.48-1.55-.85c-.93.77.81,3.34,1.05,4.92.06.36.6,7.33.6,7.33Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.27,42.72a8,8,0,0,1,1.58,5.19c0,.05.06.06.07,0,.13-2.21,0-3.57-1.56-5.27C255.28,42.57,255.21,42.63,255.27,42.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.52,41.9a12.16,12.16,0,0,1,1.66,5.57s.06,0,.05,0c0-2.32-.17-3.67-1.6-5.61C257.57,41.77,257.46,41.8,257.52,41.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.13,41.44a10.78,10.78,0,0,1,1.25,5.64,0,0,0,0,0,.09,0,7.71,7.71,0,0,0-1.28-5.68C260.12,41.29,260.07,41.31,260.13,41.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.86,40.85l-1.24,10.84a.66.66,0,0,1-.59.58l-5.21.32a.44.44,0,0,1-.47-.51l1.24-10.85a.68.68,0,0,1,.59-.58l5.22-.31A.43.43,0,0,1,261.86,40.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.08,40.36l-5.21.31a.67.67,0,0,0-.59.58L254,52.1a.44.44,0,0,0,.46.51l5.22-.32a.68.68,0,0,0,.59-.58l1.24-10.84A.44.44,0,0,0,261.08,40.36ZM260,51.4a.62.62,0,0,1-.54.54l-4.66.29a.4.4,0,0,1-.41-.49l1.15-10.1c.07-.58.28-.62.54-.64l.94-.06s.09.06.08.14v0c0,.18.07.18.19.17l2.17-.13c.12,0,.21,0,.23-.2v0a.17.17,0,0,1,.11-.15l.94-.05c.26,0,.46.05.4.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.72,41l-.59,0a0,0,0,0,1,0,0h0s0,0,0,0l.59,0s0,0,0,0h0S258.74,41,258.72,41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 254.48,
    y1: 51.1,
    x2: 254.46,
    y2: 51.1,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.17,41.3,260,51.4a.62.62,0,0,1-.54.54l-4.66.29a.4.4,0,0,1-.41-.49l1.15-10.1c.07-.58.28-.62.54-.64l.94-.06s.09.06.08.14v0c0,.18.07.18.19.17l2.17-.13c.12,0,.21,0,.23-.2v0a.17.17,0,0,1,.11-.15l.94-.05C261,40.7,261.23,40.77,261.17,41.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-175"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.85,41.18h0a.08.08,0,0,0-.09,0,.12.12,0,0,0-.09,0h0l0,0h.16Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.69,41.23h0a.09.09,0,0,1,.07,0,.08.08,0,0,1,.08,0l0,0a0,0,0,0,0-.05,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.79,41.24l0,0h-.07A.06.06,0,0,1,256.79,41.24Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.75,41.27v0s0,0,0,0a0,0,0,0,1,0,0S256.75,41.26,256.75,41.27Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256,41.26a0,0,0,0,1,0,0s0,0,0,0a0,0,0,0,1,0,0S256,41.28,256,41.26Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.08,41.26a.05.05,0,0,1,.05,0s0,0,0,0a0,0,0,0,1,0,0S256.08,41.28,256.08,41.26Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,41.25a0,0,0,0,1,0,0s0,0,0,0,0,0,0,0A0,0,0,0,1,256.2,41.25Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.32,41.24a0,0,0,0,1,0,0s0,0,0,0a0,0,0,0,1,0,0S256.32,41.26,256.32,41.24Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.44,41.23s0,0,0,0,0,0,0,0a0,0,0,0,1,0,0S256.43,41.25,256.44,41.23Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.79 40.92 260.5 40.94 260.49 41.06 260.77 41.04 260.79 40.92",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.2 41.33 260.28 40.7 261.07 40.65 261 41.28 260.2 41.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.71 40.94 260.52 40.95 260.51 41.04 260.7 41.03 260.71 40.94",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.81 41.02 260.79 41.02 260.79 40.94 260.82 40.94 260.81 41.02",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.36,51.7l-2.35.14s0,0,0,.06,0,.05,0,.05l2.35-.14a.06.06,0,0,0,.06-.06A0,0,0,0,0,258.36,51.7Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.39,45.82a.65.65,0,0,1-.59.56.42.42,0,0,1-.46-.5.65.65,0,0,1,.59-.56A.42.42,0,0,1,258.39,45.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.75,45.59s-.05,0-.06,0a.05.05,0,1,0,.1,0S257.78,45.59,257.75,45.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.9,45.58a.06.06,0,0,0-.06.06s0,0,0,0a.06.06,0,0,0,.06,0A0,0,0,0,0,257.9,45.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,45.68a.09.09,0,0,0,.06-.06,0,0,0,0,0,0,0,.06.06,0,0,0-.05.06S258,45.68,258,45.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.73,45.73s-.05,0-.05.06,0,.05,0,.05a.09.09,0,0,0,.06-.06A0,0,0,0,0,257.73,45.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.88,45.73a.06.06,0,0,0-.06.05,0,0,0,0,0,.05,0,.06.06,0,0,0,.05-.06S257.91,45.72,257.88,45.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,45.72a.06.06,0,0,0-.06.05,0,0,0,0,0,0,0,.06.06,0,0,0,.06-.06S258.05,45.71,258,45.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.72,45.88a.06.06,0,0,0-.06,0,0,0,0,0,0,0,0,.06.06,0,0,0,.05,0A0,0,0,0,0,257.72,45.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.86,45.87a0,0,0,0,0-.05.05s0,0,0,0,0,0,.06,0A0,0,0,0,0,257.86,45.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,45.86s-.05,0-.06,0a.05.05,0,1,0,.1,0S258,45.86,258,45.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.85,46a.06.06,0,0,0-.06.06s0,0,0,0a.06.06,0,0,0,.06,0A0,0,0,0,0,257.85,46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.71,47.28a.67.67,0,0,1-.59.56.44.44,0,0,1-.47-.5.66.66,0,0,1,.59-.56A.43.43,0,0,1,259.71,47.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.31,47.15a.14.14,0,0,1-.13.12.1.1,0,0,1-.1-.11.16.16,0,0,1,.13-.12A.1.1,0,0,1,259.31,47.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.36,47.46v0l-.11.05a.34.34,0,0,1-.28,0v-.05a.24.24,0,0,1,.21-.21A.17.17,0,0,1,259.36,47.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.9,45.91a.66.66,0,0,1-.59.56.42.42,0,0,1-.46-.5.64.64,0,0,1,.58-.56A.43.43,0,0,1,256.9,45.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.34,46.24a0,0,0,0,1,0,0l0-.15h0l0,.14S256.35,46.24,256.34,46.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.42,46.23h-.16a0,0,0,0,1,0,0h.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.49,45.73l0,.21a.13.13,0,0,1-.11.11.08.08,0,0,1-.08,0,.09.09,0,0,1,0,0l0-.2a.11.11,0,0,1,.11-.11.07.07,0,0,1,.06,0,.06.06,0,0,1,0,.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.36,46.09a.11.11,0,0,1-.1,0,.12.12,0,0,1,0-.1v-.09h0V46a.1.1,0,0,0,.11.11.16.16,0,0,0,.13-.13v-.1h0v.09a.17.17,0,0,1-.16.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.22,47.37a.67.67,0,0,1-.59.56.43.43,0,0,1-.47-.5.65.65,0,0,1,.59-.56A.43.43,0,0,1,258.22,47.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,47.31v.14a.07.07,0,0,1-.05,0h-.09l0-.16.08,0h0S258,47.29,258,47.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.84,47.29l0,.2a.08.08,0,0,1-.08.07l-.23,0a.06.06,0,0,1-.06-.07l0-.19s0-.08.08-.08h.23A.06.06,0,0,1,257.84,47.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.72,47.46a.64.64,0,0,1-.59.56.42.42,0,0,1-.46-.5.66.66,0,0,1,.59-.56A.42.42,0,0,1,256.72,47.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.4,47.45h-.17l0-.18a0,0,0,0,0,0,0s0,0,0,0l0,.17H256a0,0,0,0,0,0,0s0,0,0,0h.17l0,.18a0,0,0,0,0,0,0s0,0,0,0l0-.17h.17a0,0,0,0,0,0,0S256.42,47.44,256.4,47.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.88,45.73a.65.65,0,0,1-.58.56.44.44,0,0,1-.47-.5.67.67,0,0,1,.59-.57A.43.43,0,0,1,259.88,45.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.62,45.72v0a.19.19,0,0,0,0-.07.08.08,0,0,0,0,0l0,0h0l0,0h0a.2.2,0,0,1,.06.18.3.3,0,0,1-.1.19h0l0,0h0l0,0,0,0,0,0a.25.25,0,0,0,0-.07v-.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.54,45.71a.16.16,0,0,0-.05-.11l0,0a.12.12,0,0,1,0,.12.17.17,0,0,1-.06.12l0,0A.25.25,0,0,0,259.54,45.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.42,45.66l0,0a.14.14,0,0,1,0,.06.15.15,0,0,1,0,.07l0,0A.13.13,0,0,0,259.42,45.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.17 45.85 259.09 45.86 259.11 45.69 259.19 45.68 259.17 45.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "259.19 45.68 259.36 45.6 259.33 45.91 259.17 45.85 259.19 45.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,49.93a.78.78,0,0,1-.7.67.51.51,0,0,1-.55-.59.78.78,0,0,1,.7-.67A.51.51,0,0,1,258,49.93Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.75,50s0,0,0,0,0,0,0,0l0,0h0a.16.16,0,0,0-.12,0,.76.76,0,0,0-.3,0,.52.52,0,0,0-.13.06l0,0,0,0h0s0,0,0,0h0l.2,0h0a.07.07,0,0,1,.06,0h.18a.05.05,0,0,1,.05,0h0l.19,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,50h0v.07s0,0,0,0h.15s0,0,0,0V50Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,50l-.2,0a.17.17,0,0,1,0,.07s0,0,0,0h.15a0,0,0,0,0,0,0V50Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.34,44.42a.19.19,0,0,1,.16-.16.12.12,0,0,1,.09,0,0,0,0,0,1,0,0h0a.08.08,0,0,0-.07,0,.11.11,0,0,0-.07,0,.25.25,0,0,0,0,.07.12.12,0,0,0,0,.07.1.1,0,0,0,.14,0h0s0,0,0,0a.14.14,0,0,1-.09,0A.11.11,0,0,1,257.34,44.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.68,44.52l0,0h0l0-.24,0,0,0,0v.07h.05c.05,0,.08,0,.07.08v.09a0,0,0,0,1,0,0s0,0,0,0v-.09a0,0,0,0,0,0,0s0,0-.05,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.08,44.42v.08l0,0,0,0-.06,0a.07.07,0,0,1-.08-.09.11.11,0,0,1,0-.08.19.19,0,0,1,.08,0l.05,0s0,0,0,0,0,0,0,0Zm0,0s0,0,0,0l0,0,0,0a.08.08,0,0,0,0,0,.06.06,0,0,0,0,0h0l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.29,44.32s0,0,0,0h0s0,0,0,0l0,0v.08l0,0,0,0,0-.16,0,0,0,0h0l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.38,44.22a0,0,0,0,1,0,0l0,.24a0,0,0,0,1,0,0s0,0,0,0l0-.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.49,44.24l0,0a0,0,0,0,1,0,0h0s0,0,0,0l0,0Zm0,.07,0,.16s0,0,0,0,0,0,0,0l0-.15a0,0,0,0,1,0,0A0,0,0,0,1,258.49,44.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.53,44.39a.13.13,0,0,1,.11-.11.08.08,0,0,1,.09.09h-.15a0,0,0,0,0,0,0h.11v0a.09.09,0,0,1-.07,0C258.56,44.49,258.53,44.44,258.53,44.39Zm.05,0h.11a0,0,0,0,0-.05,0A.06.06,0,0,0,258.58,44.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.77,42.3a.14.14,0,0,1,.11-.1l.05,0s0,0,0,0h-.06l0,0a.05.05,0,0,0,0,0,.08.08,0,0,0,0,0s0,0,0,0h0s0,0,0,0v0l-.06,0S257.77,42.35,257.77,42.3Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.07,42.31v0H258s0,0,0,0a.08.08,0,0,1,0,0s0,0,0,0a.05.05,0,0,1,0,0h.06Zm0,0a0,0,0,0,0,0,0H258a0,0,0,0,0,0,0,0,0,0,0,0,0,0h0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.15,42.19h0l0,.15,0,0v0l0-.15Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.22,42.19a0,0,0,0,1,0,0l0,.15h0l0-.15S258.21,42.19,258.22,42.19Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.29,42.2l0,0s0,0,0,0h0a0,0,0,0,1,0,0,0,0,0,0,1,0,0Zm0,0v.11h0l0-.1s0,0,0,0S258.28,42.24,258.28,42.25Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,42.28v.06h0v-.06s0,0,0,0a0,0,0,0,0,0,0v.06h0s0,0,0,0v-.1a0,0,0,0,1,0,0,0,0,0,0,1,0,0h0S258.43,42.25,258.42,42.28Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.58,42.28v0a.08.08,0,0,1-.07.07h0a0,0,0,0,1,0,0h0s0,0,0,0h0s0,0,0,0a.08.08,0,0,1,0,0s0,0,0,0a.05.05,0,0,1,0,0h0l0,0v.07Zm0,0v0h0l0,0v0a0,0,0,0,0,0,0h0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.65,42.3a0,0,0,0,1,0,0l0,0s0,0,0,0A0,0,0,0,1,258.65,42.3Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.71,42.3s0,0,0,0l0,0s0,0,0,0A0,0,0,0,1,258.71,42.3Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.76,42.29a0,0,0,0,1,0,0l0,0,0,0A0,0,0,0,1,258.76,42.29Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.47,43.89l-.22.1a.66.66,0,0,1-.54-.06.59.59,0,0,1-.28-.43.9.9,0,0,1,.64-.92.6.6,0,0,1,.81.49A.88.88,0,0,1,258.47,43.89Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.39,43.19a.28.28,0,0,1-.25.23.17.17,0,0,1-.19-.21.27.27,0,0,1,.24-.23A.18.18,0,0,1,258.39,43.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.48,43.79v.1l-.22.1a.66.66,0,0,1-.54-.06v-.09a.47.47,0,0,1,.42-.41A.32.32,0,0,1,258.48,43.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14,55.62a28.43,28.43,0,0,1-2.27-3.46c-.54-1.17-.94-6.26.15-6.41,1.42-.2,2.23,2.7,2.45,4.17a5.79,5.79,0,0,1,3.75,2.87C260.25,54.74,255.14,55.62,255.14,55.62Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.46,155.52c-.32,0-6.2-.16-6.61-.69A156.64,156.64,0,0,1,198,136.89c-.07-.38,5.61-4.32,5.64-4.35.6-.56,11.77-9.09,11.77-9.09l9.52,11.3-11.55,8.6-.19.16a37.26,37.26,0,0,0,1,6.54c.11.44,1.83,2.42,1.93,2.78C216.37,154,215.92,155.56,215.46,155.52Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.46,155.52c-.32,0-6.2-.17-6.6-.69A160.24,160.24,0,0,1,198,136.9c0-.27,2.4-2.05,4.08-3.25.91,3.65,7.54,15.31,8.8,16.7s3.23,1.93,3.27-.31c.11.45,1.83,2.43,1.93,2.79C216.36,154,215.91,155.56,215.46,155.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.91,70.33s1.86,10.46-.17,13c0,0-5.82,26.19-7.39,32.06C243.62,121.82,221,142,221,142l-11.29-14.2s5.52-5.22,11.15-9.94c4.07-3.41,9-5.82,9-6.07.23-3.43,6.51-25.36,6.26-25.93-2.8-6.49.62-14.58.62-14.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.74,83.31s-2.44,10.92-4.27,18.93L236.05,85.89a.08.08,0,0,0,0,0c-2.77-6.49.63-14.55.63-14.55l16.83-1S254.77,80.79,252.74,83.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.9,145.89c-.59.58-20.85,10.51-21.86,10.39-.17,0-1.53-3.33-3.35-7.13-2.26-4.73-5.05-10.14-5.05-10.14l12.61-5.23,5.23,9.64s9.2-.33,10.3-.08S302.49,145.31,301.9,145.89Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.9,145.88c-.59.59-20.85,10.51-21.86,10.4a37.11,37.11,0,0,1-1.88-4c5.64-1.44,18.18-6.3,19.38-7.63s-4.25-1.37-4.53-1.38a66.09,66.09,0,0,1,6.77,0C300.87,143.57,302.49,145.31,301.9,145.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.48,136.8,268.69,145s-9.44-33.43-9.73-33.84c-.93-1.37-16.77-20-21.81-24.83-6.64-6.4-.85-15-.85-15l17.2-1,.46,6.2c1.49,2.11,16.9,22,18.91,27C276.39,112.12,286.48,136.8,286.48,136.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.21,73.77A10.46,10.46,0,0,1,254,76.5a10.67,10.67,0,0,1-3.75-2.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.85,67.55l-.35,2.75-16.83,1s1.8-14,7.72-18.42c3-2.23,5.83-1.5,7.33.71.39.56,4.27,6.44,4.35,9.36C256.13,65.54,253.85,67.55,253.85,67.55Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.27,65.59a15.4,15.4,0,0,1,2.75.55c.45.13.89.3,1.33.47q.33.14.66.24a2.54,2.54,0,0,0,.71.17s0,0,0,0a5.3,5.3,0,0,1-.69,0,4,4,0,0,1-.65-.15c-.45-.13-.9-.29-1.36-.44-.91-.28-1.83-.57-2.76-.77C248.22,65.67,248.23,65.58,248.27,65.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,66.57a17.48,17.48,0,0,1,2.29-.13,10.92,10.92,0,0,1,1.15.09l.54.07c.2,0,.4.1.6.12,0,0,0,0,0,0a5.42,5.42,0,0,0-.57,0l-.57,0-1.15,0c-.77,0-1.53,0-2.3,0C245.94,66.65,246,66.58,246,66.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.26,52.45c.05.37,1.55,2.94,3.24,3,.55,0,.86-3,.86-3l.07-.22,1-3-3.39-2.71-.49-.37s-.23.85-.5,1.91c0,0,0,.09,0,.15a1.09,1.09,0,0,0-.05.17l-.12.48-.09.37-.09.38A20.28,20.28,0,0,0,247.26,52.45Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.06,48.11a6.39,6.39,0,0,0,3.37,4.2l1-3-3.39-2.71-.49-.37S248.33,47.05,248.06,48.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.6,44.5c.32,5.6-3,6.42-4.2,6.49s-4.83.13-5.73-5.4,1.6-7.45,4.1-7.72S257.28,38.91,257.6,44.5Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.66,43.66c-.14,0-.26,0-.39-.07a.63.63,0,0,1-.37-.14.2.2,0,0,1,0-.24.5.5,0,0,1,.48-.14.79.79,0,0,1,.47.24A.22.22,0,0,1,256.66,43.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,43.76l.38-.08a.66.66,0,0,0,.36-.16.2.2,0,0,0,0-.25.5.5,0,0,0-.49-.11.73.73,0,0,0-.45.27C252.66,43.57,252.81,43.78,253,43.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.77,44.9s0,0,0,0c0,.38,0,.82-.33,1,0,0,0,0,0,0C253.84,45.84,253.87,45.26,253.77,44.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.41,44.52c-.62,0-.59,1.23,0,1.24S253.92,44.53,253.41,44.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.17,44.6c-.11.07-.21.19-.34.21s-.27-.11-.37-.23,0,0,0,0c0,.24.1.48.35.51s.4-.19.45-.43C253.25,44.63,253.21,44.57,253.17,44.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.86,44.78s0,0,0,0c0,.38.05.82.4.94,0,0,0,0,0,0C255.87,45.72,255.8,45.14,255.86,44.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,44.37c.61,0,.68,1.18.11,1.23S255.68,44.42,256.2,44.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.46,44.44c.1.06.2.17.32.18s.23-.14.3-.27,0,0,0,0c0,.23,0,.48-.26.54s-.37-.14-.44-.37C256.39,44.48,256.42,44.42,256.46,44.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.71,47.87c.08.09.16.22.3.24a1.22,1.22,0,0,0,.42-.06s0,0,0,0a.51.51,0,0,1-.49.17.41.41,0,0,1-.28-.36S253.69,47.86,253.71,47.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.31,46.51s.08.57.08.84c0,0-.07,0-.16,0h0A1.28,1.28,0,0,1,254,46.9s0-.06,0,0a2,2,0,0,0,1.17.35c0-.08-.16-1-.12-1a2.42,2.42,0,0,1,.61.14c-.12-1.19-.43-2.35-.53-3.54,0,0,.06-.06.07,0a19.17,19.17,0,0,1,.73,3.8C256,46.76,255.42,46.55,255.31,46.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,47.31a1.26,1.26,0,0,1-.52.39.72.72,0,0,1-.36,0c-.25-.08-.25-.31-.2-.51a1.72,1.72,0,0,1,.13-.3A1.63,1.63,0,0,0,255,47.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.43,47.7a.72.72,0,0,1-.36,0c-.25-.08-.25-.31-.2-.51A.61.61,0,0,1,254.43,47.7Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.34,46.12c1,.11,1.26-2.26,1.26-2.26s4.38-.83,4.69-4.42a6,6,0,0,0,3.12,3.25s-.23-3.92-3.36-4.62c0,0-3.89-1.34-6,1.77S247.65,46,248.34,46.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.3,39.17a3.81,3.81,0,0,1-.17,1.64,3.94,3.94,0,0,1-.8,1.46,2.81,2.81,0,0,1-.29.31l-.15.14a1.09,1.09,0,0,1-.17.13l-.33.25-.37.21-.18.09-.19.08-.39.16c-.26.08-.53.14-.79.2l.75-.31.36-.19.18-.09.17-.11.33-.22.31-.25.16-.13.14-.14a3.71,3.71,0,0,0,.27-.29,4.59,4.59,0,0,0,.81-1.36,4.25,4.25,0,0,0,.23-.77A4.53,4.53,0,0,0,254.3,39.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.77,45.9s-1.08-1.84-1.91-1.47-.1,3,.8,3.39a.94.94,0,0,0,1.3-.41Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.09,45.17s0,0,0,0a2.41,2.41,0,0,1,1.12,1.59.53.53,0,0,0-.77-.21,0,0,0,0,0,0,0,.59.59,0,0,1,.63.25,3.36,3.36,0,0,1,.26.54c0,.06.14,0,.12,0v0A2.09,2.09,0,0,0,247.09,45.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.56,51a7.4,7.4,0,0,0,3.28-1,3.48,3.48,0,0,1-3.28,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.69,60c2.92.08,5.46-4.64,5.21-6.83-.21-1.9-3.07-1.36-6.57,1S238.79,59.91,241.69,60Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.6,52.36c-7.82,2.66-14.32,9.11-14.55,11.56-.33,3.53,6.52,12.14,8.8,15.56.7,1.07,7-6.88,6.26-8s-6.12-7-6.14-7.14c0-.35,6.23-7,7.83-8.7C247.24,54.12,247.86,50.91,243.6,52.36Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.8,79.32a1.53,1.53,0,0,1-1.38,1.06,2.32,2.32,0,0,1-.09,1.54c-.41.84-1.9.57-1.9.57a2.75,2.75,0,0,1-.36,1.6c-.47.76-2,.7-2,.7a2.48,2.48,0,0,1-1.2,1.22c-1.45.61-3.41-.78-4.66-1.65s-4-4.51-4.59-5.15l5.51-8.09s6.73,2.3,8.06,3.53C252.3,75.68,254.11,78.17,253.8,79.32Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.45,80.22A19.87,19.87,0,0,0,249,76.68s-.06,0,0,0c1.23,1.09,2.22,2.41,3.41,3.55C252.42,80.3,252.47,80.25,252.45,80.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.47,82.36a4.39,4.39,0,0,0-.83-.78l-.94-.75c-.64-.49-1.3-1-2-1.42,0,0-.07,0,0,0,.64.49,1.27,1,1.88,1.51l.92.78a4.63,4.63,0,0,0,.9.7A.05.05,0,0,0,250.47,82.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,84.77a3.11,3.11,0,0,0-.78-.66l-.89-.66c-.59-.44-1.18-.88-1.75-1.34,0,0-.06,0,0,0l1.74,1.42.86.68a2.71,2.71,0,0,0,.84.55S248,84.79,248,84.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,57.88l-.36.25c.47-.52.92-1.05,1.34-1.61,0,0,0,0,0,0-.56.56-1.12,1.12-1.66,1.7-.25.28-.52.55-.76.83s-.54.66-.83,1c0,0,0,.09.05.06.28-.29.58-.56.87-.84s.49-.5.73-.76l.27-.17c.14-.1.29-.21.42-.32s.53-.46.8-.69h0C244.55,57.48,244.27,57.68,244,57.88Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalization);
export default __webpack_public_path__ + "static/media/Globalization.30c2483f1beb52fc1f4971fc22ecb100.svg";
export { ForwardRef as ReactComponent };